/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// eslint-disable-next-line import/order
import {
  jotaiStore,
  showModalAtom,
  showArtworkHistoryModalAtom,
  variantIdAtom,
  productIdAtom,
  catalogNumberAtom,
  printAsIsAtom,
  neckLabelAtom,
  dtfMaxWidthAtom,
  dtfMaxHeightAtom,
  dtfMinWidthAtom,
  dtfMinHeightAtom,
  pdpTypeAtom,
  preCutAtom,
  productSlugAtom,
  showCTAAtom,
  favoritesAtom,
  stickerAtom,
  currentStoreAtom,
  allowForceBgRemoveAtom,
  canvaReviewerAtom,
  unitPriceAtom,
  printingServiceNameAtom,
  cachedArtworkPricesAtom,
  dtfCategoryAtom,
  spanglesAtom,
  canvaDtfEnabledStateAtom,
  showMultiSizeArtworkAtom,
  enablePreCutAtom,
  preCutPriceAtom,
  preCutEnabledAtom,
  preCutDurationAtom,
  preCutUpsellThresholdAtom,
  loadFromConfigAtom,
  artworksStateAtom,
  artworkHistoryAtom,
  artworkHistoryPaginationAtom,
  summaryAtom,
  bogoPromotionDataAtom,
  simulationAtom,
  fileToRemoveAtom,
  showDiscardModalAtom,
  discardedAtom,
  fetchControllerAtom,
  useDefaultValuesAtom,
  showFilesErrorAtom,
  replaceArtworkAtom,
  errorTypesAtom,
  isRetryingAtom,
  allRetryFailedAtom,
  localeAtom,
  experimentsAtom,
  minStickerQuantityAtom,
  userTypeAtom,
  bogoEligibilityAtom,
  bogoMaxDimensionLabelAtom,
  promotionResolutionAtom,
  transferPdpBackButtonDetectionAtom,
  spangleConfigAtom,
  sizeErrorTypesAtom,
  isMobileAtom,
  enableMobileFooterCTAAtom,
  dtfChannelUuidAtom,
  isEnhancementLoadingAtom,
  actionCableOptionsAtom,
  actionCableConnectedAtom,
  stickerQrScannedAtom,
  cableAtom,
  businessLineAtom,
  isPuffAtom,
  puffAtom,
  isProColorAtom,
  isStickerAtom,
  isDieCutStickerAtom,
  isStickerSampleAtom,
  isJiffyMadeAtom,
  printReadyInfoConfigAtom,
  loadingAtom,
  isJerseyNumbersAtom,
  isLettersAtom,
  letterPreviewMessagesAtom,
  artworkBackgroundAtom,
  backgroundTypeAtom,
  stickersStyleOptionsAtom,
  letterPreviewLoadingAtom,
  isGoldFoilAtom,
  forcePdpTransfersRedrawAtom,
  pinBasedRedrawEnabledAtom,
  pinBasedRedrawEscapedAtom,
  enableRedrawAtom,
  isPricingLoadingAtom,
  enhancementNoteAtom,
  puffMaxImageCountAtom,
  previewCanvasSizeAtom,
  gangSheetBuilderAtom,
  showGangSheetBuilderAtom,
  generatedGangSheetsAtom,
  gangSheetBuilderShopIdAtom,
  showGangSheetBuilderFeatureAtom,
  isGangSheetBuilderAtom,
  gangSheetBuilderVariantsAtom,
  gangSheetBuilderSettingsAtom,
  gangSheetBuilderSizesAtom,
  isDtfSheetAtom,
  gangSheetBulkPriceAtom,
  storeCreditInfoAtom,
  presetMockupColorAtom,
  gangSheetBuilderCarouselsAtom,
  updatePricingAbortSignalAtom,
  preloadedDesignIdAtom,
  reorderEnabledAtom,
  validateArtworkStartTimeAtom,
  validateArtworkStartEventIntervalIDAtom,
  paidExpertEditAddonEnabledAtom,
  gangSheetCatalogNumbersAtom,
  customerReviewOnRedrawsAtom,
  customerReviewOnTransferRedrawsAtom,
  klaviyoSmsTransactionalSubscribedAtom,
  smsTransactionalSubscriptionPdpEnabledAtom,
  transferPdpInactivityDetectionAtom,
  smsTransactionalPhoneAtom,
  smsTransactionalSubscribeButtonTextAtom,
  messagingConsentsAtom,
  blankItemsCountAtom,
  transfersInCartCountAtom,
  isNewToTransfersAtom,
  showPinningModalAtom,
  pinningArtworkIndexAtom,
  pinningModalSessionIdAtom,
  pinningSessionLoadingAtom,
  pendingInitialMessageAtom,
  pendingPinningInvalidationAtom,
  lastConfirmedConfigSectionAtom
} from "./store.atoms";

/* eslint-disable no-param-reassign, max-lines, no-return-await */
import { logUnsupportedFileTypeEvent, validateAndMaterializeFile } from "common/file-type-helper";
import getVariantInfo from "common/jiffy/get-variant";
import { redirectTo } from "common/utils/browser";
import { deleteCookie } from "common/utils/cookie";
import { isSessionExpired, withCsrfRetry } from "common/utils/csrf-token-manager";
import datadogTracker from "common/utils/datadog-tracker";
import { objNamesToCamelCase } from "common/utils/helpers/cases";
import { findIndexById } from "common/utils/helpers/find-index-by-id";
import { logUploadError } from "common/utils/app-monitoring/log-upload-error";
import isRelevantBrowserError from "common/utils/app-monitoring/is-relevant-browser-error";
import { notifyError } from "common/utils/app-monitoring/notify";
import { tryParse } from "common/utils/json";
import {
  getErrorContext,
  logUploadErrorEvent
} from "common/utils/mixpanel/dropzone-error-event-tracker";
import { submitCompletedEvent, submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import mobileApp from "common/utils/mobile/app";
import "common/utils/pinia/index"; // Sets up global Pinia instance
import { DTF_PROGRESS_MAPPING } from "common/utils/progress-bar/constants";
import { shouldReportError } from "common/utils/request/request";
import {
  trackRudderstackImageProcessingCompleted,
  trackRudderstackImageRemoved,
  trackRudderstackImageUploadRetry,
  trackRudderstackImageUploadStarted
} from "common/utils/rudderstack/tracker.react";
import { getStickerDimensions } from "common/utils/stickers";
import { DEFAULT_STICKER_VALUES } from "common/utils/stickers/constants";
import idleCallback from "common/utils/ui/idle_callback";
import { generateUUID } from "common/utils/uuid";
import { incrementHeaderCounter } from "components/jiffy/masthead-cart/masthead-cart";
import {
  deliveryDateResponse,
  reloadDeliveryEstimates
} from "components/jiffy/product-details-delivery-date-simple/init-dates";
import validationErrors from "components/jiffy/product-details-quantity-form/show-product-modules/validation-errors";
import { sendDataLayer } from "jiffy-analytics";
import { api } from "jiffy-api";
import { EventBus, Events } from "jiffy-store";
import debounce from "lodash.debounce";
import { createJotaiPiniaFacadeForReact } from "common/vue/createJotaiPiniaFacadeForReact";
import { startPinSessionRecording } from "../design-lab/shared/lib/pinSessionRecording";
import {
  calculateDefaultDimensions,
  calculateDimensions,
  convertImageToHexColor,
  getFormPayload,
  getIsBuyItAgainStatus,
  getPdpImage,
  getRandomId,
  groupByKeyPrefix,
  recalculateCustomSizes,
  validateGangSheetDimensions,
  zipArray,
  zipArrayByKey
} from "./utils";
import {
  BACKEND_TRIGGERED_ENHANCEMENT_ELIGIBLE_CATALOG,
  DEFAULT_PUFF_VALUES,
  DEFAULT_VALUES,
  DTF001_CATALOG_NUMBER,
  GANG_DEFAULT_VALUES,
  GOLD_FOIL_HEX,
  JERSEY_NUMBERS_DEFAULT_VALUES,
  LETTER_DEFAULTS,
  LETTERS_FILL_IN_VALUES,
  MIXPANEL_METADATA_KEYS,
  RETRY_INTERVALS
} from "./common/constants";
import initCable from "./dtf-channel"; // eslint-disable-line import/no-cycle
import { trackAddToCart } from "./dtf-ga-tracker";
import ErrorTypes from "./error-types";
import { cancelSession, createSession } from "./PinningSession/composables/usePinningSession";
import {
  trackPinsSessionSummaryEditClicked,
  trackTransfersPinningInstructionsRemoved,
  trackTransfersPinsCtaClicked
} from "./PinningSession/transfersPinningAnalytics";
import { SPANGLE_MODES, useSpanglesStore, spanglesStore } from "./spangles-module"; // eslint-disable-line import/no-cycle
import transfersPollingService from "./transfers-polling-service";

const DEFAULT_SIZE_AND_QUANTITY = {
  ...DEFAULT_VALUES,
  preset: "custom",
  id: getRandomId()
};

const DEFAULT_SIMULATION_ARTWORK = {
  ...LETTER_DEFAULTS,
  widthEdited: false,
  isSimulated: true,
  id: "simulation",
  style: null,
  height: null,
  color: null,
  quantity: 1,
  quantities: {},
  sizes: {},
  prices: {},
  enhancementNote: "",
  enhancementFeedbackSubmitted: false,
  enhancementRatingSubmitted: false,
  enhancementSatisfied: null,
  sizesAndQuantities: [DEFAULT_SIZE_AND_QUANTITY],
  enhancementTier: "full_enhancements"
};

const initialState = {
  showModal: false,
  showArtworkHistoryModal: false,
  variantId: null,
  productId: null,
  catalogNumber: null,
  printAsIs: false,
  neckLabel: false,
  dtfMaxWidth: null,
  dtfMaxHeight: null,
  dtfMinWidth: null,
  dtfMinHeight: null,
  pdpType: null,
  preCut: false,
  productSlug: "",
  showCTA: false,
  favorites: [],
  sticker: null,
  currentStore: null,
  allowForceBgRemove: false,
  canvaReviewer: null,
  unitPrice: null,
  printingServiceName: null,
  cachedArtworkPrices: {},
  dtfCategory: null,
  spangles: [],
  canvaDtfEnabledState: false,
  showMultiSizeArtwork: false,
  enablePreCut: false,
  preCutPrice: 0,
  preCutEnabled: false,
  preCutDuration: null,
  preCutUpsellThreshold: 0,
  loadFromConfig: true,
  artworksState: [],
  artworkHistory: [],
  artworkHistoryPagination: {
    page: 1
  },
  /**
   * @type {import('./types').PriceSummary}
   */
  summary: {
    orderTotal: "0.0",
    productCartQuantity: 0
  },
  /**
   * BOGO promotion data from the pricing API
   * @type {{ applicable: boolean, freeQtyAvailable?: number, artworks?: object }}
   */
  bogoPromotionData: {
    applicable: false
  },
  /**
   * @type {import('./types').Standard.Artwork | import('./types').Sticker.Artwork}
   */
  simulation: { ...DEFAULT_SIMULATION_ARTWORK },
  fileToRemove: null,
  showDiscardModal: false,
  discarded: null,
  fetchController: null,
  useDefaultValues: false,
  showFilesError: false,
  replaceArtwork: false,
  errorTypes: ErrorTypes,
  isRetrying: false,
  allRetryFailed: false,
  locale: "en-US",
  experiments: {},
  minStickerQuantity: 10,
  userType: "guest_user",
  bogoEligibility: { visible: false, reason: null },
  bogoMaxDimensionLabel: '12"x12"',
  promotionResolution: { winner: "none" },

  transferPdpBackButtonDetection: false,
  spangleConfig: {
    spangleAlgorithms: [],
    isSpangle: false,
    spangleColors: []
  },
  sizeErrorTypes: [
    ErrorTypes.INVALID_WIDTH.toString(),
    ErrorTypes.INVALID_HEIGHT.toString(),
    ErrorTypes.NEGATIVE_VALUES.toString(),
    ErrorTypes.MIN_PRINT_SIZE.toString(),
    ErrorTypes.MAX_PRINT_SIZE.toString(),
    ErrorTypes.UPSCALE_THRESHOLD_EXCEEDED.toString()
  ],

  isMobile: false,
  enableMobileFooterCTA: false,
  dtfChannelUuid: null,
  isEnhancementLoading: false,
  actionCableOptions: {},
  actionCableConnected: false,
  stickerQrScanned: false,
  cable: null,
  businessLine: null,
  isPuff: false,
  puff: { ...DEFAULT_PUFF_VALUES },
  isProColor: false,
  isSticker: false,
  isDieCutSticker: false,
  isStickerSample: false,
  isJiffyMade: false,
  printReadyInfoConfig: {
    show: false,
    expanded: false
  },
  loading: {
    removeBg: false
  },
  isJerseyNumbers: false,
  isLetters: false,
  letterPreviewMessages: {},
  artworkBackground: "transparent",
  backgroundType: "checkered",
  stickersStyleOptions: false,
  letterPreviewLoading: false,
  isGoldFoil: false,
  forcePdpTransfersRedraw: false,
  pinBasedRedrawEnabled: false,
  pinBasedRedrawEscaped: false,
  enableRedraw: false,
  isPricingLoading: false,
  enhancementNote: "",
  puffMaxImageCount: 1,
  previewCanvasSize: { width: 0, height: 0 },
  gangSheetBuilder: null,
  showGangSheetBuilder: false,
  generatedGangSheets: [],
  gangSheetBuilderShopId: null,
  showGangSheetBuilderFeature: false,
  isGangSheetBuilder: false,
  gangSheetBuilderVariants: [],
  gangSheetBuilderSettings: {},
  gangSheetBuilderSizes: [],
  isDtfSheet: false,
  gangSheetBulkPrice: {},
  storeCreditInfo: {},
  presetMockupColor: ["#E1E1E1"],
  gangSheetBuilderCarousels: {},
  updatePricingAbortSignal: null,
  preloadedDesignId: null,
  reorderEnabled: false,
  validateArtworkStartTime: {},
  validateArtworkStartEventIntervalID: {},
  paidExpertEditAddonEnabled: false,
  gangSheetCatalogNumbers: [],
  customerReviewOnRedraws: false,
  customerReviewOnTransferRedraws: false,
  pinSessionRecording: false,
  pinSessionForceMixpanelRecording: false,
  klaviyoSmsTransactionalSubscribed: false,
  smsTransactionalSubscriptionPdpEnabled: false,
  transferPdpInactivityDetection: false,
  smsTransactionalPhone: "",
  smsTransactionalSubscribeButtonText: "Subscribe",
  messagingConsents: { smsTransactional: true },
  blankItemsCount: 0,
  transfersInCartCount: 0,
  isNewToTransfers: null,
  showPinningModal: false,
  pinningArtworkIndex: null,
  pinningModalSessionId: null,
  pinningSessionLoading: false,
  pendingInitialMessage: null,
  pendingPinningInvalidation: null,
  lastConfirmedConfigSection: null
};

const emptyArtworkItem = {
  id: null,
  file: null,
  name: null,
  isFile: true,
  metadata: null,
  borneoMetadata: null,
  isLoading: true,
  removeBackground: false,
  width: null,
  height: null,
  quantity: null,
  pricing: {},
  isValid: true,
  projectId: null,
  uploadError: null,
  toggleBackgroundError: null,
  originalWidth: null,
  originalHeight: null,
  progress: 0,
  retryFailed: false,
  currentProgress: 0,
  lastWebSocketEvent: null,
  lastWebSocketEventData: {},
  spangled: false,
  spangledImageUrl: null,
  cutlineUrl: null,
  imageProcessingCompletedEventSent: false,
  color: null,
  paddingSize: "no_padding",
  bgColor: null,
  data: {},
  printReadyInfo: {},
  processTimeStamp: null,
  annotateEnabled: false,
  annotateMode: "keep",
  annotatedPoints: [],
  annotatedCanvasWidth: null,
  annotatedCanvasHeight: null,
  annotatedXOffset: 0,
  annotatedYOffset: 0,
  revisionImageUrls: [],
  revisionPosition: 0,
  sizesAndQuantities: [DEFAULT_SIZE_AND_QUANTITY],
  enhancedNoBgUrl: null,
  enhancedWithBgUrl: null,
  enhancementCompleted: false,
  enhancementFeedbackSubmitted: false,
  enhancementRatingSubmitted: false,
  originalDpi: 0,
  sizeBasedDpi: 0,
  enhancedDpi: 0,
  sliderPreviewUrl: null,
  downscaledOriginalImage: null,
  catalogNumber: null,
  fromGangSheetBuilder: false,
  enhancementTier: "full_enhancements"
};

const summarizeFonts = (fontDetails: any) =>
  fontDetails.reduce(
    (acc: any, font: any) => {
      if (font.font_family) {
        acc.fontFamilies.push(font.font_family);
      }
      if (font.text_effect?.name) {
        acc.textEffects.push(font.text_effect.name);
      }
      return acc;
    },
    { fontFamilies: [], textEffects: [] }
  );

const validation = validationErrors();

// Helper function to map size and quantity data
function mapSizeAndQuantity({ width, height, quantity, preset, size }: any) {
  return { width, height, quantity, preset, size };
}

/**
 * Determines the preview image name for a pinning session based on the artwork's
 * enhancement tier and background removal setting.
 * Matches the Design Lab logic in RequestDesignChanges.getPreviewImageName.
 */
function getArtworkPreviewImageName(artwork: any) {
  if (artwork.manualEditUrl) {
    return "manual_edit_image";
  }

  const tier = artwork.enhancementTier;

  if (tier === "print_original") {
    return "original_image";
  }

  if (tier === "full_enhancements") {
    if (artwork.removeBackground && artwork.canRemoveBg) {
      return "image_no_background";
    }
    return "image_with_background";
  }

  return undefined;
}

// Helper function to transform artwork for form submission
function transformArtworkToFormData(artwork: any, store: any) {
  const sizes = artwork.sizesAndQuantities.filter(({ quantity }: any) => Number(quantity) > 0);
  const llmRedrawRequestId =
    ["custom", "full_enhancements"].includes(artwork.enhancementTier) && artwork.llmRedrawRequestId
      ? artwork.llmRedrawRequestId
      : null;

  return {
    artwork_id: artwork.id,
    width: artwork.width,
    height: artwork.height,
    quantity: store.showMultiSize ? 1 : Number(artwork.quantity),
    from_dam: artwork.fromDam,
    variant_id: artwork.variantId || store.variantId,
    metadata: artwork.metadata,
    borneo_metadata: artwork.borneoMetadata,
    project_id: artwork.projectId,
    spangled_image_url: artwork.spangledImageUrl,
    spangled: artwork.spangled,
    spangle_csv: artwork.spangleCsv,
    spangle_pages_info: artwork.spanglePagesInfo,
    spangle_positions_json: artwork.spanglePositionsJson,
    color: artwork.color,
    padding_size: artwork.paddingSize,
    preview_url: artwork.url || artwork.originalNoBgUrl,
    bg_color: artwork.bgColor,
    shape: artwork.shape,
    remove_background: artwork.removeBackground,
    enhancement_request_note: artwork.enhancementNote,
    llm_redraw_request_id: llmRedrawRequestId,
    enhancement_tier: artwork.enhancementTier,
    enhance_image: artwork.enhanceImage,
    from_gang_sheet_builder: artwork.fromGangSheetBuilder,
    catalog_number: artwork.catalogNumber,
    sizes_and_quantities: sizes.map(mapSizeAndQuantity),
    messaging_consents: store.messagingConsents || { smsTransactional: true },
    ...(artwork.pinningSessionId && { pinning_session_id: artwork.pinningSessionId }),
    ...(artwork.editImageManual && { edit_image_manual: true })
  };
}

export const useDtfStore = createJotaiPiniaFacadeForReact({
  // @ts-expect-error TS(2322): Type 'Store' is not assignable to type 'JotaiStore... Remove this comment to see the full error message
  jotaiStore,

  state: {
    showModal: showModalAtom,
    showArtworkHistoryModal: showArtworkHistoryModalAtom,
    variantId: variantIdAtom,
    productId: productIdAtom,
    catalogNumber: catalogNumberAtom,
    printAsIs: printAsIsAtom,
    neckLabel: neckLabelAtom,
    dtfMaxWidth: dtfMaxWidthAtom,
    dtfMaxHeight: dtfMaxHeightAtom,
    dtfMinWidth: dtfMinWidthAtom,
    dtfMinHeight: dtfMinHeightAtom,
    pdpType: pdpTypeAtom,
    preCut: preCutAtom,
    productSlug: productSlugAtom,
    showCTA: showCTAAtom,
    favorites: favoritesAtom,
    sticker: stickerAtom,
    currentStore: currentStoreAtom,
    allowForceBgRemove: allowForceBgRemoveAtom,
    canvaReviewer: canvaReviewerAtom,
    unitPrice: unitPriceAtom,
    printingServiceName: printingServiceNameAtom,
    cachedArtworkPrices: cachedArtworkPricesAtom,
    dtfCategory: dtfCategoryAtom,
    spangles: spanglesAtom,
    canvaDtfEnabledState: canvaDtfEnabledStateAtom,
    showMultiSizeArtwork: showMultiSizeArtworkAtom,
    enablePreCut: enablePreCutAtom,
    preCutPrice: preCutPriceAtom,
    preCutEnabled: preCutEnabledAtom,
    preCutDuration: preCutDurationAtom,
    preCutUpsellThreshold: preCutUpsellThresholdAtom,
    loadFromConfig: loadFromConfigAtom,
    artworksState: artworksStateAtom,
    artworkHistory: artworkHistoryAtom,
    artworkHistoryPagination: artworkHistoryPaginationAtom,
    summary: summaryAtom,
    bogoPromotionData: bogoPromotionDataAtom,
    simulation: simulationAtom,
    fileToRemove: fileToRemoveAtom,
    showDiscardModal: showDiscardModalAtom,
    discarded: discardedAtom,
    fetchController: fetchControllerAtom,
    useDefaultValues: useDefaultValuesAtom,
    showFilesError: showFilesErrorAtom,
    replaceArtwork: replaceArtworkAtom,
    errorTypes: errorTypesAtom,
    isRetrying: isRetryingAtom,
    allRetryFailed: allRetryFailedAtom,
    locale: localeAtom,
    experiments: experimentsAtom,
    minStickerQuantity: minStickerQuantityAtom,
    userType: userTypeAtom,
    bogoEligibility: bogoEligibilityAtom,
    bogoMaxDimensionLabel: bogoMaxDimensionLabelAtom,
    promotionResolution: promotionResolutionAtom,

    transferPdpBackButtonDetection: transferPdpBackButtonDetectionAtom,
    spangleConfig: spangleConfigAtom,
    sizeErrorTypes: sizeErrorTypesAtom,
    isMobile: isMobileAtom,
    enableMobileFooterCTA: enableMobileFooterCTAAtom,
    dtfChannelUuid: dtfChannelUuidAtom,
    isEnhancementLoading: isEnhancementLoadingAtom,
    actionCableOptions: actionCableOptionsAtom,
    actionCableConnected: actionCableConnectedAtom,
    stickerQrScanned: stickerQrScannedAtom,
    cable: cableAtom,
    businessLine: businessLineAtom,
    isPuff: isPuffAtom,
    puff: puffAtom,
    isProColor: isProColorAtom,
    isSticker: isStickerAtom,
    isDieCutSticker: isDieCutStickerAtom,
    isStickerSample: isStickerSampleAtom,
    isJiffyMade: isJiffyMadeAtom,
    printReadyInfoConfig: printReadyInfoConfigAtom,
    loading: loadingAtom,
    isJerseyNumbers: isJerseyNumbersAtom,
    isLetters: isLettersAtom,
    letterPreviewMessages: letterPreviewMessagesAtom,
    artworkBackground: artworkBackgroundAtom,
    backgroundType: backgroundTypeAtom,
    stickersStyleOptions: stickersStyleOptionsAtom,
    letterPreviewLoading: letterPreviewLoadingAtom,
    isGoldFoil: isGoldFoilAtom,
    forcePdpTransfersRedraw: forcePdpTransfersRedrawAtom,
    pinBasedRedrawEnabled: pinBasedRedrawEnabledAtom,
    pinBasedRedrawEscaped: pinBasedRedrawEscapedAtom,
    enableRedraw: enableRedrawAtom,
    isPricingLoading: isPricingLoadingAtom,
    enhancementNote: enhancementNoteAtom,
    puffMaxImageCount: puffMaxImageCountAtom,
    previewCanvasSize: previewCanvasSizeAtom,
    gangSheetBuilder: gangSheetBuilderAtom,
    showGangSheetBuilder: showGangSheetBuilderAtom,
    generatedGangSheets: generatedGangSheetsAtom,
    gangSheetBuilderShopId: gangSheetBuilderShopIdAtom,
    showGangSheetBuilderFeature: showGangSheetBuilderFeatureAtom,
    isGangSheetBuilder: isGangSheetBuilderAtom,
    gangSheetBuilderVariants: gangSheetBuilderVariantsAtom,
    gangSheetBuilderSettings: gangSheetBuilderSettingsAtom,
    gangSheetBuilderSizes: gangSheetBuilderSizesAtom,
    isDtfSheet: isDtfSheetAtom,
    gangSheetBulkPrice: gangSheetBulkPriceAtom,
    storeCreditInfo: storeCreditInfoAtom,
    presetMockupColor: presetMockupColorAtom,
    gangSheetBuilderCarousels: gangSheetBuilderCarouselsAtom,
    updatePricingAbortSignal: updatePricingAbortSignalAtom,
    preloadedDesignId: preloadedDesignIdAtom,
    reorderEnabled: reorderEnabledAtom,
    validateArtworkStartTime: validateArtworkStartTimeAtom,
    validateArtworkStartEventIntervalID: validateArtworkStartEventIntervalIDAtom,
    paidExpertEditAddonEnabled: paidExpertEditAddonEnabledAtom,
    gangSheetCatalogNumbers: gangSheetCatalogNumbersAtom,
    customerReviewOnRedraws: customerReviewOnRedrawsAtom,
    customerReviewOnTransferRedraws: customerReviewOnTransferRedrawsAtom,
    klaviyoSmsTransactionalSubscribed: klaviyoSmsTransactionalSubscribedAtom,
    smsTransactionalSubscriptionPdpEnabled: smsTransactionalSubscriptionPdpEnabledAtom,
    transferPdpInactivityDetection: transferPdpInactivityDetectionAtom,
    smsTransactionalPhone: smsTransactionalPhoneAtom,
    smsTransactionalSubscribeButtonText: smsTransactionalSubscribeButtonTextAtom,
    messagingConsents: messagingConsentsAtom,
    blankItemsCount: blankItemsCountAtom,
    transfersInCartCount: transfersInCartCountAtom,
    isNewToTransfers: isNewToTransfersAtom,
    showPinningModal: showPinningModalAtom,
    pinningArtworkIndex: pinningArtworkIndexAtom,
    pinningModalSessionId: pinningModalSessionIdAtom,
    pinningSessionLoading: pinningSessionLoadingAtom,
    pendingInitialMessage: pendingInitialMessageAtom,
    pendingPinningInvalidation: pendingPinningInvalidationAtom,
    lastConfirmedConfigSection: lastConfirmedConfigSectionAtom
  },

  getters: {
    showSampleAddToCart() {
      const urlParams = new URLSearchParams(window.location.search);

      return (
        urlParams.get("spt") === "true" &&
        // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
        this.catalogNumber === DTF001_CATALOG_NUMBER &&
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.simulation.unitPrice > 0
      );
    },
    isGuest() {
      // @ts-expect-error TS(4111): Property 'userType' comes from an index signature,... Remove this comment to see the full error message
      return this.userType === "guest_user";
    },
    /**
     * Returns BOGO-adjusted pricing data for a specific artwork/size
     * @returns {function(string, string, string): {freeQty: number, discountedTotalPrice: number} | null}
     */
    getBogoAdjustedPrice() {
      return (artworkId: any, sizeId: any, sizeKey: any) => {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        if (!this.bogoPromotionData?.applicable || !this.bogoPromotionData?.artworks) {
          return null;
        }

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const artworkData = this.bogoPromotionData.artworks[artworkId];
        if (!artworkData) return null;

        // Normalize sizeId: objNamesToCamelCase converts UUIDs with dashes
        // e.g., "411cb8e6-6b64-4b16-9ec5-b4b1c3d12606" becomes "411cb8e66b644b169ec5B4b1c3d12606"
        // @ts-expect-error TS(6133): 'm' is declared but its value is never read.
        const normalizedSizeId = sizeId.replace(/[^a-zA-Z0-9]+(.)/g, (m: any, chr: any) =>
          chr.toUpperCase()
        );
        const sizeData = artworkData[normalizedSizeId];
        if (!sizeData) return null;

        // Normalize sizeKey: ensure 2 decimal places to match backend format
        const [width, height] = sizeKey.split("x");
        const normalizedSizeKey = `${parseFloat(width).toFixed(2)}x${parseFloat(height).toFixed(2)}`;

        return sizeData[normalizedSizeKey] || null;
      };
    },
    /**
     * Returns total free quantity available from BOGO promotion
     * @returns {number}
     */
    bogoFreeQtyAvailable() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return this.bogoPromotionData?.freeQtyAvailable || 0;
    },
    /**
     * Returns whether BOGO promotion is applicable
     * @returns {boolean}
     */
    isBogoApplicable() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return this.bogoPromotionData?.applicable || false;
    },
    /**
     * @returns {Array<import('./types').Standard.Artwork | import('./types').Sticker.Artwork>}
     */
    artworks() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return this.artworksState.length ? this.artworksState : [this.simulation];
    },
    modalArtworks() {
      // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
      return this.artworks;
    },
    isFavorite() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return this.favorites.includes(this.productId);
    },
    withPreCut() {
      // @ts-expect-error TS(4111): Property 'preCutEnabled' comes from an index signa... Remove this comment to see the full error message
      return this.preCutEnabled && this.preCutPrice > 0;
    },
    files() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return this.artworks.filter(({ isFile }: any) => isFile);
    },
    loadedArtworks() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return this.artworks.filter(({ isFile }: any) => !isFile);
    },
    allArtworksAiApproved() {
      // @ts-expect-error TS(4111): Property 'loadedArtworks' comes from an index signature, so it must be accessed with ['loadedArtworks'].
      const loaded: any[] = this.loadedArtworks;
      if (loaded.length === 0) return false;
      const artworksWithEdits = loaded.filter(
        (a: any) => a.pinningSessionId || a.enhancementNote?.trim()
      );
      if (artworksWithEdits.length === 0) return false;
      return artworksWithEdits.every((a: any) => a.pinningSessionState === "approved");
    },
    canvaDtfEnabled() {
      // @ts-expect-error TS(4111): Property 'canvaDtfEnabledState' comes from an inde... Remove this comment to see the full error message
      return this.canvaDtfEnabledState && this.catalogNumber === DTF001_CATALOG_NUMBER;
    },
    mobileFooterCTAEnabled() {
      // @ts-expect-error TS(4111): Property 'isMobile' comes from an index signature,... Remove this comment to see the full error message
      return this.isMobile && this.enableMobileFooterCTA;
    },
    jerseyFormArtworks() {
      // @ts-expect-error TS(4111): Property 'letterNumberArtwork' comes from an index... Remove this comment to see the full error message
      const artwork = this.letterNumberArtwork;
      return [
        {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          style: artwork.style,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          height: artwork.height,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          width: artwork.width,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          color: artwork.color,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          quantities: artwork.quantities,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          quantity: artwork.quantity,
          metadata: {}
        }
      ];
    },
    letterFormArtworks() {
      // @ts-expect-error TS(4111): Property 'letterNumberArtwork' comes from an index... Remove this comment to see the full error message
      const artwork = this.letterNumberArtwork;
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const texts = artwork.texts.filter(Boolean);
      return [
        {
          texts,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          font: artwork.font,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          style: artwork.style,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          height: artwork.height,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          width: artwork.width,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          color: artwork.color,
          quantity: texts.length,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          max_length: artwork.maxLength,
          metadata: {}
        }
      ];
    },
    formArtworks() {
      // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
      if (this.isJerseyNumbers) {
        // @ts-expect-error TS(4111): Property 'jerseyFormArtworks' comes from an index ... Remove this comment to see the full error message
        return this.jerseyFormArtworks;
      }

      // @ts-expect-error TS(4111): Property 'isLetters' comes from an index signature... Remove this comment to see the full error message
      if (this.isLetters) {
        // @ts-expect-error TS(4111): Property 'letterFormArtworks' comes from an index ... Remove this comment to see the full error message
        return this.letterFormArtworks;
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return this.artworksState.map((artwork: any) => transformArtworkToFormData(artwork, this));
    },
    letterNumberArtworks() {
      // @ts-expect-error TS(2339): Property 'quantities' does not exist on type 'unkn... Remove this comment to see the full error message
      const { quantities, ...artwork } = this.letterNumberArtwork;
      const image = getPdpImage();
      // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
      if (this.isJerseyNumbers) {
        return Object.keys(quantities).map(key => ({
          ...artwork,
          id: key,
          url: image,
          pricing: { unitPrice: artwork.prices[key]?.unitPrice },
          number: key,
          height: artwork.sizes[key]?.height,
          width: artwork.sizes[key]?.width,
          quantity: quantities[key],
          // @ts-expect-error TS(4111): Property 'preCut' comes from an index signature, s... Remove this comment to see the full error message
          preCut: this.preCut
        }));
      }

      const texts = artwork.texts.filter(Boolean);
      // @ts-expect-error TS(7006): Parameter 'text' implicitly has an 'any' type.
      return texts.map((text, index) => ({
        ...artwork,
        id: index + 1,
        url: image,
        pricing: { unitPrice: artwork.prices[index + 1]?.unitPrice },
        text,
        height: artwork.sizes[index]?.height,
        width: artwork.sizes[index]?.width,
        quantity: 1,
        // @ts-expect-error TS(4111): Property 'preCut' comes from an index signature, s... Remove this comment to see the full error message
        preCut: this.preCut
      }));
    },
    /* eslint-disable max-lines-per-function */
    csmData() {
      const artworks =
        // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
        this.isJerseyNumbers || this.isLetters ? this.letterNumberArtworks : this.artworksState;
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const result = artworks.map((artwork: any) => {
        let sizeText = `${artwork.width}" x ${artwork.height}"`;
        // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
        if (this.isJerseyNumbers) {
          sizeText = `Height ${artwork.height}"`;
          // @ts-expect-error TS(4111): Property 'isLetters' comes from an index signature... Remove this comment to see the full error message
        } else if (this.isLetters) {
          sizeText = `${Number(artwork.width).toFixed(2)}" x ${Number(artwork.height).toFixed(2)}"`;
          // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
        } else if (this.printAsIs) {
          sizeText = `${artwork.width}" x ${artwork.lengthFoot}'`;
        }

        // @ts-expect-error TS(4111): Property 'locale' comes from an index signature, s... Remove this comment to see the full error message
        const currency = this.locale === "en-CA" ? "C$" : "$";

        const catalogText = (() => {
          // @ts-expect-error TS(4111): Property 'sticker' comes from an index signature, ... Remove this comment to see the full error message
          if (this.sticker) {
            return "Jiffy Stickers";
          }

          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          if (this.spangleConfig.isSpangle) {
            return "Jiffy Spangles";
          }

          // @ts-expect-error TS(4111): Property 'isPuff' comes from an index signature, s... Remove this comment to see the full error message
          if (this.isPuff) {
            return "Puff Transfers";
          }

          // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
          if (this.isJerseyNumbers) {
            return `Numbers (#${artwork.number})`;
          }

          // @ts-expect-error TS(4111): Property 'isLetters' comes from an index signature... Remove this comment to see the full error message
          if (this.isLetters) {
            return `Custom Names ("${artwork.text.toUpperCase()}")`;
          }

          return "Jiffy Transfers";
        })();

        return {
          id: artwork.id,
          dieCutProductId: artwork.dieCutProductId,
          dieCutVariantId: artwork.dieCutVariantId,
          catalogNumber: catalogText,
          // @ts-expect-error TS(4111): Property 'productId' comes from an index signature... Remove this comment to see the full error message
          productId: this.productId,
          // @ts-expect-error TS(4111): Property 'variantId' comes from an index signature... Remove this comment to see the full error message
          variantId: this.variantId,
          color: "",
          image: artwork.url,
          size: sizeText,
          quantity: artwork.quantity,
          cutlineUrl: artwork.cutlineUrl,
          price: `${currency}${Number(artwork.pricing.unitPrice).toFixed(2)}`,
          // @ts-expect-error TS(4111): Property 'preCut' comes from an index signature, s... Remove this comment to see the full error message
          preCut: this.preCut,
          // @ts-expect-error TS(4111): Property 'preCutPrice' comes from an index signatu... Remove this comment to see the full error message
          preCutPrice: this.preCutPrice
        };
      }, []);

      // Add enhancement services (same as csmDataMultiSize)
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (this.summary.enhancements) {
        // @ts-expect-error TS(4111): Property 'locale' comes from an index signature, s... Remove this comment to see the full error message
        const currency = this.locale === "en-CA" ? "C$" : "$";
        const { isStandardDTFProduct } = this;

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        Object.values(this.summary.enhancements).forEach(enhancement => {
          // Only show print_original enhancements when experiment is active
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          const isPrintOriginalService = enhancement.serviceName === "Print As Is Notes";
          if (isPrintOriginalService && !isStandardDTFProduct) {
            return;
          }

          result.push({
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            catalogNumber: enhancement.serviceName,
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            priceTotal: `${currency}${Number(enhancement.totalPrice).toFixed(2)}`,
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            quantity: enhancement.quantity,
            isEnhancement: true
          });
        });
      }

      return result;
    },
    csmDataMultiSize() {
      const csmData: any = [];
      // @ts-expect-error TS(4111): Property 'locale' comes from an index signature, s... Remove this comment to see the full error message
      const currency = this.locale === "en-CA" ? "C$" : "$";

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.artworksState.forEach(({ id, sizesAndQuantities, url }: any) => {
        sizesAndQuantities
          .filter(({ quantity }: any) => Number(quantity) > 0)
          .forEach((item: any) => {
            const artworkId = String(id);
            const sizeKey = `${item.width}x${item.height}`;
            const bogoPrice =
              // @ts-expect-error TS(4111): Property 'isGuest' comes from an index signature, ... Remove this comment to see the full error message
              !this.isGuest && item.id
                ? // @ts-expect-error TS(2571): Object is of type 'unknown'.
                  this.getBogoAdjustedPrice(artworkId, item.id, sizeKey)
                : null;

            const csmItem = {
              id,
              catalogNumber: "Jiffy Transfers",
              // @ts-expect-error TS(4111): Property 'productId' comes from an index signature... Remove this comment to see the full error message
              productId: this.productId,
              // @ts-expect-error TS(4111): Property 'variantId' comes from an index signature... Remove this comment to see the full error message
              variantId: this.variantId,
              color: "",
              image: url,
              // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
              size: `${item.width}" x ${item.height}${this.printAsIs ? "'" : '"'}`,
              quantity: item.quantity,
              price: `${currency}${Number(item.unitPrice).toFixed(2)}`,
              // @ts-expect-error TS(4111): Property 'preCut' comes from an index signature, s... Remove this comment to see the full error message
              preCut: this.preCut,
              // @ts-expect-error TS(4111): Property 'preCutPrice' comes from an index signatu... Remove this comment to see the full error message
              preCutPrice: this.preCutPrice
            };

            if (bogoPrice) {
              // @ts-expect-error TS(2339): Property 'priceTotal' does not exist on type '{ id... Remove this comment to see the full error message
              csmItem.priceTotal = `${currency}${bogoPrice.discountedTotalPrice.toFixed(2)}`;
            }

            csmData.push(csmItem);
          });
      });

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (this.summary.enhancements) {
        const { isStandardDTFProduct } = this;

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        Object.values(this.summary.enhancements).forEach(enhancement => {
          // Only show print_original enhancements when experiment is active
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          const isPrintOriginalService = enhancement.serviceName === "Print As Is Notes";
          if (isPrintOriginalService && !isStandardDTFProduct) {
            return;
          }

          csmData.push({
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            catalogNumber: enhancement.serviceName,
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            priceTotal: `${currency}${Number(enhancement.totalPrice).toFixed(2)}`,
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            quantity: enhancement.quantity
          });
        });
      }
      return csmData;
    },
    /* eslint-enable max-lines-per-function */
    totalQuantity() {
      // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
      if (this.isJerseyNumbers || this.isLetters) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        return this.letterNumberArtwork.quantity;
      }

      // @ts-expect-error TS(4111): Property 'showMultiSize' comes from an index signa... Remove this comment to see the full error message
      if (this.showMultiSize) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        return this.artworksState.reduce(
          (artworkTotal: any, { sizesAndQuantities }: any) =>
            artworkTotal +
            sizesAndQuantities.reduce(
              (sizesTotal: any, { quantity }: any) => sizesTotal + Number(quantity),
              0
            ),
          0
        );
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return this.artworksState.reduce((acc: any, { quantity }: any) => acc + Number(quantity), 0);
    },
    outOfStock() {
      // @ts-expect-error TS(4111): Property 'isGangSheetBuilder' comes from an index ... Remove this comment to see the full error message
      if (this.isGangSheetBuilder) return false;

      // @ts-expect-error TS(2339): Property 'inventory' does not exist on type 'Windo... Remove this comment to see the full error message
      const available = window.inventory[this.variantId];
      return available == null || available === 0;
    },
    dtfTypeDropText() {
      // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
      return this.printAsIs ? "Drop your gang sheets here" : "Drop your images here";
    },
    isLetterReadyForOrder() {
      // @ts-expect-error TS(2339): Property 'style' does not exist on type 'unknown'.
      const { style, font, height, maxLength, color, sizes, ...artwork } = this.letterNumberArtwork;
      const texts = artwork.texts.filter(Boolean);
      const quantity = texts.length;
      const allSizesDefined = texts.every((_text: any, index: any) => {
        const size = sizes[index];
        return size && size.width !== undefined && size.height !== undefined;
      });

      return (
        style &&
        font &&
        height &&
        maxLength &&
        color &&
        quantity &&
        artwork.isValid &&
        allSizesDefined
      );
    },
    // eslint-disable-next-line max-lines-per-function
    isReadyForOrder() {
      // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
      if (this.isJerseyNumbers) {
        // @ts-expect-error TS(2339): Property 'quantity' does not exist on type 'unknow... Remove this comment to see the full error message
        const { quantity, quantities, height, ...artwork } = this.letterNumberArtwork;
        return (
          quantity &&
          height &&
          artwork.isValid &&
          Object.keys(quantities).every(key => artwork.prices[key]?.unitPrice)
        );
      }

      // @ts-expect-error TS(4111): Property 'isLetters' comes from an index signature... Remove this comment to see the full error message
      if (this.isLetters) {
        // @ts-expect-error TS(4111): Property 'isLetterReadyForOrder' comes from an ind... Remove this comment to see the full error message
        return this.isLetterReadyForOrder;
      }

      return (
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        Boolean(this.artworksState.length) &&
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.artworksState.every(this.isArtworkValid) &&
        // @ts-expect-error TS(4111): Property 'isPricingLoading' comes from an index si... Remove this comment to see the full error message
        !this.isPricingLoading
      );
    },
    dpiInstructionsUrl() {
      // @ts-expect-error TS(4111): Property 'locale' comes from an index signature, s... Remove this comment to see the full error message
      return this.locale === "en-CA" ? "/ca/artwork-dpi-instructions" : "/artwork-dpi-instructions";
    },
    gangSheetArtworkProductLink() {
      let baseLink;
      // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
      if (this.catalogNumber === "DTFGANG001") {
        baseLink = "/jiffytransfers-DTF001.html";
        // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
      } else if (this.catalogNumber === "UVDTFGANG") {
        baseLink = "/jiffytransfers-UVDTF01.html";
        // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
      } else if (this.catalogNumber === "GANGDTFPC1") {
        baseLink = "/jiffytransfers-DTFPC1.html";
        // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
      } else if (this.catalogNumber === "GANGDTFG01") {
        baseLink = "/jiffytransfers-DTFG01.html";
      } else {
        baseLink = "/jiffytransfers-UVDTF01.html";
      }
      // @ts-expect-error TS(4111): Property 'locale' comes from an index signature, s... Remove this comment to see the full error message
      return this.locale === "en-CA" ? `/ca${baseLink}` : baseLink;
    },
    spangleAlgorithms() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return this.spangleConfig.spangleAlgorithms;
    },
    isSpangle() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return this.spangleConfig.isSpangle;
    },
    spangleColors() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return this.spangleConfig.spangleColors;
    },
    isFirstArtworkMinQuantityInvalid() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const quantity = this.artworksState[0]?.quantity;
      // @ts-expect-error TS(4111): Property 'sticker' comes from an index signature, ... Remove this comment to see the full error message
      return this.sticker && quantity && quantity < this.minStickerQuantity;
    },
    removeBgLoading() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return this.loading.removeBg;
    },
    isUVDTFSticker() {
      // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
      return this.catalogNumber === "UVDTF01";
    },
    letterNumberArtwork() {
      // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
      if (this.isJerseyNumbers || this.isLetters) {
        // @ts-expect-error TS(2488): Type 'unknown' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
        const [artwork] = this.artworks;
        const { summary } = this;
        const retailPrice = artwork.quantity
          ? // @ts-expect-error TS(2571): Object is of type 'unknown'.
            Number(summary.orderTotal || 0) / artwork.quantity
          : 0;
        const unitPrice = artwork.quantity
          ? // @ts-expect-error TS(2571): Object is of type 'unknown'.
            Number(summary.orderSubtotal || 0) / artwork.quantity
          : 0;
        const percentage = retailPrice ? 100 * (1 - unitPrice / retailPrice) : 0;
        return {
          ...artwork,
          retailPrice,
          unitPrice,
          percentage
        };
      }

      return null;
    },
    isValidJerseyArtwork() {
      // @ts-expect-error TS(2339): Property 'isValid' does not exist on type 'unknown... Remove this comment to see the full error message
      const { isValid, height, sizes, quantities } = this.letterNumberArtwork;
      return isValid && height && Object.keys(sizes).length && Object.keys(quantities).length;
    },
    isLetterPreviewReady() {
      // @ts-expect-error TS(2339): Property 'style' does not exist on type 'unknown'.
      const { style, font, height, maxLength, color, texts, textIndex } = this.letterNumberArtwork;
      const quantity = (texts || []).filter(Boolean).length;
      return style && font && height && maxLength && color && quantity && textIndex !== null;
    },
    pickFromUploadsOrDesigns() {
      // @ts-expect-error TS(4111): Property 'isSpangle' comes from an index signature... Remove this comment to see the full error message
      return !this.isSpangle && !this.printAsIs;
    },
    initialValues() {
      // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
      if (this.printAsIs) {
        return GANG_DEFAULT_VALUES;
      }
      // @ts-expect-error TS(4111): Property 'sticker' comes from an index signature, ... Remove this comment to see the full error message
      if (this.sticker) {
        return DEFAULT_STICKER_VALUES;
      }
      // @ts-expect-error TS(4111): Property 'isPuff' comes from an index signature, s... Remove this comment to see the full error message
      if (this.isPuff) {
        return DEFAULT_PUFF_VALUES;
      }
      // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
      if (this.isJerseyNumbers) {
        return JERSEY_NUMBERS_DEFAULT_VALUES;
      }

      return DEFAULT_VALUES;
    },
    showMultiSize() {
      // @ts-expect-error TS(4111): Property 'showMultiSizeArtwork' comes from an inde... Remove this comment to see the full error message
      return this.showMultiSizeArtwork;
    },
    showStepsUI() {
      return (
        // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
        !this.isJerseyNumbers && !this.isLetters && !this.spangleConfig.isSpangle && !this.sticker
      );
    },
    isGangSheetProduct() {
      // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
      return this.catalogNumber && this.gangSheetCatalogNumbers.includes(this.catalogNumber);
    },
    showRedrawUI() {
      return (
        // @ts-expect-error TS(4111): Property 'enableRedraw' comes from an index signat... Remove this comment to see the full error message
        Boolean(this.enableRedraw) &&
        // @ts-expect-error TS(4111): Property 'forcePdpTransfersRedraw' comes from an i... Remove this comment to see the full error message
        Boolean(this.forcePdpTransfersRedraw) &&
        // @ts-expect-error TS(4111): Property 'isGangSheetProduct' comes from an index ... Remove this comment to see the full error message
        !this.isGangSheetProduct &&
        // @ts-expect-error TS(4111): Property 'isLetters' comes from an index signature... Remove this comment to see the full error message
        !this.isLetters &&
        // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
        !this.isJerseyNumbers &&
        // Products with post-processing after having the final image
        // @ts-expect-error TS(4111): Property 'sticker' comes from an index signature, ... Remove this comment to see the full error message
        !this.sticker &&
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        !this.spangleConfig.isSpangle &&
        // @ts-expect-error TS(4111): Property 'isGoldFoil' comes from an index signatur... Remove this comment to see the full error message
        !this.isGoldFoil &&
        // @ts-expect-error TS(4111): Property 'isPuff' comes from an index signature, s... Remove this comment to see the full error message
        !this.isPuff
      );
    },
    showNewGangSheetErrorMessage() {
      // @ts-expect-error TS(4111): Property 'showModal' comes from an index signature... Remove this comment to see the full error message
      return !this.showModal;
    },
    isCustomerReviewOnRedrawsEnabled() {
      // @ts-expect-error TS(4111): Property 'customerReviewOnRedraws' comes from an i... Remove this comment to see the full error message
      return this.customerReviewOnRedraws && this.customerReviewOnTransferRedraws;
    },
    isStandardArtwork() {
      return (
        // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
        !this.printAsIs &&
        // @ts-expect-error TS(4111): Property 'isProColor' comes from an index signatur... Remove this comment to see the full error message
        !this.isProColor &&
        // @ts-expect-error TS(4111): Property 'isSticker' comes from an index signature... Remove this comment to see the full error message
        !this.isSticker &&
        // @ts-expect-error TS(4111): Property 'isStickerSample' comes from an index sig... Remove this comment to see the full error message
        !this.isStickerSample &&
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        !this.spangleConfig.isSpangle &&
        // @ts-expect-error TS(4111): Property 'isLetters' comes from an index signature... Remove this comment to see the full error message
        !this.isLetters &&
        // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
        !this.isJerseyNumbers &&
        // @ts-expect-error TS(4111): Property 'isUVDTFSticker' comes from an index sign... Remove this comment to see the full error message
        !this.isUVDTFSticker
      );
    },
    isBackendTriggeredEnhancementEligible() {
      // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
      return BACKEND_TRIGGERED_ENHANCEMENT_ELIGIBLE_CATALOG.includes(this.catalogNumber);
    },
    enableAbAiMonetization() {
      // Default behavior for DTF001 products - show the tabbed interface
      // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
      return this.catalogNumber === DTF001_CATALOG_NUMBER;
    },
    isStandardDTFProduct() {
      // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
      return this.catalogNumber === DTF001_CATALOG_NUMBER;
    },
    isPinBasedRedrawEnabled() {
      // @ts-expect-error TS(4111): Property 'pinBasedRedrawEnabled' comes from an ind... Remove this comment to see the full error message
      return Boolean(this.pinBasedRedrawEnabled) && !this.pinBasedRedrawEscaped;
    },
    showDesignServicesDeliveryBuffer() {
      // @ts-expect-error TS(4111): Property 'isJiffyMade' comes from an index signatu... Remove this comment to see the full error message
      return !this.isJiffyMade && this.experiments.transfers_design_services_delivery_buffer === 1;
    },
    // Helper getter to validate individual artwork
    isArtworkValid() {
      return (artwork: any) => {
        const validQuantity =
          // @ts-expect-error TS(4111): Property 'sticker' comes from an index signature, ... Remove this comment to see the full error message
          this.sticker || this.isPuff
            ? // @ts-expect-error TS(2571): Object is of type 'unknown'.
              artwork.quantity >= this.minStickerQuantity
            : artwork.quantity;

        // @ts-expect-error TS(4111): Property 'showMultiSize' comes from an index signa... Remove this comment to see the full error message
        const sizes = this.showMultiSize
          ? artwork.sizesAndQuantities.filter(({ quantity }: any) => Number(quantity) > 0)
          : artwork.sizesAndQuantities;

        // @ts-expect-error TS(4111): Property 'showMultiSize' comes from an index signa... Remove this comment to see the full error message
        const validMultiQuantity = this.showMultiSize
          ? sizes.length > 0 && sizes.every(({ quantity }: any) => Number(quantity) > 0)
          : validQuantity;

        // @ts-expect-error TS(4111): Property 'isPuff' comes from an index signature, s... Remove this comment to see the full error message
        const isValidColor = !this.isPuff || Boolean(artwork.color);
        const artworkEnhancementProcessing =
          // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
          this.isStandardArtwork && !artwork.isLoading && !artwork.enhancementCompleted;

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const customNoteValid = this.getCustomNoteValid(artwork);
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const customRedrawStateValid = this.getCustomRedrawStateValid(artwork);

        return (
          artwork.isValid &&
          !artwork.uploadError &&
          !artwork.isLoading &&
          validMultiQuantity &&
          isValidColor &&
          !artworkEnhancementProcessing &&
          customNoteValid &&
          customRedrawStateValid
        );
      };
    },
    // Helper to validate custom notes
    getCustomNoteValid() {
      return (artwork: any) => {
        const customNote = artwork.enhancementNote;
        if (artwork.enhancementTier === "custom") {
          return customNote && customNote.trim().length > 0;
        }
        if (artwork.enhancementTier === "full_enhancements") {
          return (
            // @ts-expect-error TS(4111): Property 'paidExpertEditAddonEnabled' comes from a... Remove this comment to see the full error message
            !this.paidExpertEditAddonEnabled ||
            (artwork.hasExpertEditAddon ? customNote && customNote.trim().length > 0 : true)
          );
        }
        return true;
      };
    },
    // Helper to validate custom redraw state
    getCustomRedrawStateValid() {
      return (artwork: any) => {
        if (artwork.enhancementTier !== "custom") return true;
        const customNote = artwork.enhancementNote;
        return customNote && customNote.trim().length > 0;
      };
    }
  },

  actions: {
    // eslint-disable-next-line max-lines-per-function
    addFiles(files, startingIndex) {
      // @ts-expect-error TS(2339): Property 'widthEdited' does not exist on type 'unk... Remove this comment to see the full error message
      const { widthEdited, width, height, enhancementNote } = this.simulation;

      const {
        // @ts-expect-error TS(2339): Property 'isSpangle' does not exist on type 'unkno... Remove this comment to see the full error message
        spangleConfig: { isSpangle }
      } = this;

      const enableCustomSize = widthEdited && !isSpangle;

      // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
      const initialValuesForSize = this.printAsIs ? GANG_DEFAULT_VALUES : DEFAULT_VALUES;

      // @ts-expect-error TS(2488): Type 'unknown' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
      const mappedFiles = [...files].map((file, index) => {
        const initialValues = {
          width: initialValuesForSize.width,
          height: initialValuesForSize.height,
          // @ts-expect-error TS(2339): Property 'previewMetadata' does not exist on type ... Remove this comment to see the full error message
          previewMetadata: initialValuesForSize.previewMetadata
        };
        const dimensions = enableCustomSize && index === 0 ? { width, height } : initialValues;

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const quantity = index === 0 ? this.simulation?.quantity : initialValuesForSize.quantity;

        return {
          ...emptyArtworkItem,
          file,
          enhancementNote,
          enhanceImage: true,
          isFile: true,
          name: file.name,
          quantity,
          ...dimensions,
          sizesAndQuantities: [
            {
              quantity,
              ...dimensions,
              preset: "custom",
              id: getRandomId()
            }
          ]
        };
      });

      // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
      this.simulation = { ...this.simulation, enhancementNote: "" };

      // @ts-expect-error TS(4111): Property 'isJiffyMade' comes from an index signatu... Remove this comment to see the full error message
      if (this.isJiffyMade) {
        // @ts-expect-error TS(2488): Type 'unknown' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
        const newArtworks = [...this.artworksState];
        // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
        newArtworks.splice(startingIndex, mappedFiles.length, ...mappedFiles);
        // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
        this.artworksState = newArtworks;
      } else {
        // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
        this.artworksState = [...this.artworksState, ...mappedFiles];
      }
    },
    setFileLoading(index) {
      // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
      this.artworksState = [...this.artworksState];
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.artworksState[index] = {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        ...this.artworksState[index],
        originalIndex: index,
        isLoading: true
      };
    },
    setSimulation(simulation) {
      // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
      this.simulation = { ...this.simulation, ...simulation };
    },
    setBlankItemsCount(count) {
      // @ts-expect-error TS(4111): Property 'blankItemsCount' comes from an index sig... Remove this comment to see the full error message
      this.blankItemsCount = count;
    },
    setTransfersInCartCount(count) {
      // @ts-expect-error TS(4111): Property 'transfersInCartCount' comes from an inde... Remove this comment to see the full error message
      this.transfersInCartCount = count;
    },
    setIsNewToTransfers(value) {
      // @ts-expect-error TS(4111): Property 'isNewToTransfers' comes from an index si... Remove this comment to see the full error message
      this.isNewToTransfers = value;
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { index, isBuyAgain, artw... Remove this comment to see the full error message
    // eslint-disable-next-line max-lines-per-function
    setLoadedArtwork({ index, isBuyAgain, artwork }) {
      const preparedArtwork = objNamesToCamelCase(artwork);

      const { metadata } = preparedArtwork;
      let { sizesAndQuantities } = preparedArtwork;
      let artworkIndex = index;
      const defaultDimensions = {
        width: metadata.widthInch,
        height: metadata.heightInch
      };

      // @ts-expect-error TS(4111): Property 'showMultiSizeArtwork' comes from an inde... Remove this comment to see the full error message
      let dimensions = this.showMultiSizeArtwork
        ? calculateDefaultDimensions({ aspectRatio: metadata.aspectRatio })
        : defaultDimensions;

      if (!artworkIndex) {
        // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
        artworkIndex = findIndexById(this.artworksState, artwork.id);
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const { isSizesEdited } = this.artworks[artworkIndex] || {};

      // @ts-expect-error TS(2339): Property 'widthEdited' does not exist on type 'unk... Remove this comment to see the full error message
      const { widthEdited, width } = this.simulation;

      const {
        // @ts-expect-error TS(2339): Property 'isSpangle' does not exist on type 'unkno... Remove this comment to see the full error message
        spangleConfig: { isSpangle }
      } = this;

      if (widthEdited && !isSpangle && artworkIndex === 0) {
        // @ts-expect-error TS(4111): Property 'sticker' comes from an index signature, ... Remove this comment to see the full error message
        dimensions = calculateDimensions(metadata.aspectRatio, width, this.sticker);
      }

      // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
      const initialValuesForSize = this.printAsIs ? GANG_DEFAULT_VALUES : DEFAULT_VALUES;

      const quantity =
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        artworkIndex === 0 ? this.simulation?.quantity : initialValuesForSize.quantity;
      const defaultSizesAndQuantities = [
        {
          ...dimensions,
          quantity,
          preset: "custom",
          id: getRandomId()
        }
      ];

      // @ts-expect-error TS(4111): Property 'showMultiSizeArtwork' comes from an inde... Remove this comment to see the full error message
      if (this.showMultiSizeArtwork) {
        if (isSizesEdited) {
          sizesAndQuantities = recalculateCustomSizes(
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.artworks[artworkIndex].sizesAndQuantities,
            metadata.aspectRatio,
            // @ts-expect-error TS(2554): Expected 2 arguments, but got 3.
            this.sticker
          );
        } else {
          sizesAndQuantities = isBuyAgain ? sizesAndQuantities : defaultSizesAndQuantities;
        }
      } else {
        sizesAndQuantities = [];
      }

      // @ts-expect-error TS(2488): Type 'unknown' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
      const updatedArtworks = [...this.artworksState];
      updatedArtworks[artworkIndex] = {
        ...updatedArtworks[artworkIndex],
        ...preparedArtwork,
        isLoading: false,
        isFile: false,
        isSimulated: false,
        removeBackground: metadata.removeBackground,
        originalWidth: metadata.widthInch,
        originalHeight: metadata.heightInch,
        lengthFoot: metadata.lengthFoot,
        lastWebSocketEvent: null,
        lastWebSocketEventData: {},
        ...dimensions,
        sizesAndQuantities
      };
      // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
      this.artworksState = updatedArtworks;
    },
    setCachedArtworkPrices(prices) {
      // @ts-expect-error TS(4111): Property 'cachedArtworkPrices' comes from an index... Remove this comment to see the full error message
      this.cachedArtworkPrices = Object.keys(prices).reduce((acc, price) => {
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        acc[price] = objNamesToCamelCase(prices[price]);
        return acc;
      }, {});
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { index, artworkId, uploa... Remove this comment to see the full error message
    setFailedUploadArtwork({ index, artworkId, uploadError }) {
      let artworkIndex = index;

      if (!artworkIndex) {
        // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
        artworkIndex = findIndexById(this.artworksState, artworkId);
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (!this.artworksState[artworkIndex]) return;

      // @ts-expect-error TS(2488): Type 'unknown' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
      const updatedArtworks = [...this.artworksState];
      updatedArtworks[artworkIndex] = { ...updatedArtworks[artworkIndex], uploadError };
      // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
      this.artworksState = updatedArtworks;
    },
    /* eslint-disable max-lines-per-function */
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { index, isMultiSize, ...... Remove this comment to see the full error message
    setArtworkPricing({ index, isMultiSize, ...responseData }) {
      // @ts-expect-error TS(4111): Property 'response' comes from an index signature,... Remove this comment to see the full error message
      const pricingData = responseData.response;
      const preparedData = objNamesToCamelCase(pricingData);
      const {
        bulkDiscount,
        orderSubtotal,
        orderTotal,
        productCartQuantity,
        artworks,
        enhancements,
        bogoPromotionData
      } = preparedData;

      // Store BOGO promotion data
      if (bogoPromotionData) {
        // @ts-expect-error TS(4111): Property 'bogoPromotionData' comes from an index s... Remove this comment to see the full error message
        this.bogoPromotionData = bogoPromotionData;
      }

      // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
      if (this.isJerseyNumbers || this.isLetters) {
        // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
        this.simulation = {
          // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
          ...this.simulation,
          prices: artworks
        };

        // @ts-expect-error TS(4111): Property 'summary' comes from an index signature, ... Remove this comment to see the full error message
        this.summary = {
          bulkDiscount,
          orderSubtotal,
          orderTotal
        };
        return;
      }

      // @ts-expect-error TS(4111): Property 'isJiffyMade' comes from an index signatu... Remove this comment to see the full error message
      if (artworks.simulation && !this.isJiffyMade) {
        // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
        this.simulation = {
          // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
          ...this.simulation,
          ...(isMultiSize ? artworks.simulation[0] : artworks.simulation),
          id: "simulation",
          sizesAndQuantities: isMultiSize
            ? // @ts-expect-error TS(2571): Object is of type 'unknown'.
              zipArray(this.simulation.sizesAndQuantities, artworks.simulation)
            : []
        };
        // @ts-expect-error TS(4111): Property 'summary' comes from an index signature, ... Remove this comment to see the full error message
        this.summary = initialState.summary;
        // @ts-expect-error TS(4111): Property 'isPricingLoading' comes from an index si... Remove this comment to see the full error message
        this.isPricingLoading = false;
        return;
      }
      const ids = Object.keys(artworks);

      // @ts-expect-error TS(2488): Type 'unknown' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
      const updatedArtworks = [...this.artworksState];
      ids.forEach(id => {
        // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
        let itemIndex = findIndexById(this.artworksState, id);

        if (itemIndex === -1) itemIndex = index;
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        if (!this.artworksState[itemIndex]) return;

        updatedArtworks[itemIndex] = {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          ...this.artworksState[itemIndex],
          pricing: isMultiSize ? artworks[id][0] : artworks[id],
          sizesAndQuantities: isMultiSize
            ? // @ts-expect-error TS(2571): Object is of type 'unknown'.
              zipArrayByKey(this.artworksState[itemIndex].sizesAndQuantities, artworks[id], "id")
            : []
        };
      });
      // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
      this.artworksState = updatedArtworks;
      // @ts-expect-error TS(4111): Property 'summary' comes from an index signature, ... Remove this comment to see the full error message
      this.summary = {
        bulkDiscount,
        orderSubtotal,
        orderTotal,
        productCartQuantity,
        enhancements
      };
      // @ts-expect-error TS(4111): Property 'isPricingLoading' comes from an index si... Remove this comment to see the full error message
      this.isPricingLoading = false;

      // Trigger a reload of delivery estimates if the delivery date response is available.
      // Timeout is used to ensure that the state is updated before the reload.
      // Pass orderSubtotal directly since the Vue DOM hasn't flushed yet.
      setTimeout(
        () =>
          deliveryDateResponse.reloadDeliveryEstimatesWithoutFetch({ pdpSubtotal: orderSubtotal }),
        0
      );
    },
    /* eslint-enable max-lines-per-function */
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { artworks, isMultiSize }... Remove this comment to see the full error message
    setSimulationPricing({ artworks, isMultiSize }) {
      const sizesAndQuantities = {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        ...this.simulation.sizesAndQuantities[0],
        ...artworks.simulation
      };
      // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
      this.simulation = {
        // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
        ...this.simulation,
        ...objNamesToCamelCase(artworks.simulation),
        sizesAndQuantities: isMultiSize ? [sizesAndQuantities] : []
      };
      // @ts-expect-error TS(4111): Property 'isPricingLoading' comes from an index si... Remove this comment to see the full error message
      this.isPricingLoading = false;
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { index, ...values }: { [... Remove this comment to see the full error message
    updateArtworkValues({ index, ...values }) {
      // In Vue, computed refs passed as values are lazily unwrapped by
      // reactive().  In React the conversion turns them into getter
      // functions.  Resolve them: set plain values first so dependent
      // getters read up-to-date state, then call any getter functions.
      const plain: Record<string, unknown> = {};
      const lazy: Record<string, () => unknown> = {};
      for (const [k, v] of Object.entries(values)) {
        if (typeof v === "function") lazy[k] = v as () => unknown;
        else plain[k] = v;
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (!this.artworksState.length) {
        // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
        this.simulation = {
          // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
          ...this.simulation,
          ...plain
        };
        if (Object.keys(lazy).length) {
          const resolved: Record<string, unknown> = {};
          for (const [k, fn] of Object.entries(lazy)) resolved[k] = fn();
          // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
          this.simulation = { ...this.simulation, ...resolved };
        }
        return;
      }
      // @ts-expect-error TS(2488): Type 'unknown' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
      const updatedArtworks = [...this.artworksState];
      let artworkIndex = updatedArtworks.findIndex(
        element => String(index) === String(element.originalIndex)
      );

      // @ts-expect-error TS(4111): Property 'isJiffyMade' comes from an index signatu... Remove this comment to see the full error message
      if (this.isJiffyMade && artworkIndex === -1) {
        artworkIndex = index;
      }

      updatedArtworks[artworkIndex] = { ...updatedArtworks[artworkIndex], ...plain };
      if (Object.keys(lazy).length) {
        const resolved: Record<string, unknown> = {};
        for (const [k, fn] of Object.entries(lazy)) resolved[k] = fn();
        updatedArtworks[artworkIndex] = { ...updatedArtworks[artworkIndex], ...resolved };
      }
      // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
      this.artworksState = updatedArtworks;
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { id, ...values }: { [x: ... Remove this comment to see the full error message
    updateArtworkValuesById({ id, ...values }) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (!this.artworksState.length) {
        return;
      }
      // @ts-expect-error TS(2488): Type 'unknown' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
      const updatedArtworks = [...this.artworksState];
      const index = findIndexById(updatedArtworks, id);

      // Guard: verify the artwork at index actually has the matching id
      // findIndexById returns 0 when not found, which could update wrong artwork
      if (!updatedArtworks[index] || String(updatedArtworks[index].id) !== String(id)) {
        return;
      }

      const preparedArtwork = objNamesToCamelCase(values, MIXPANEL_METADATA_KEYS);

      updatedArtworks[index] = { ...updatedArtworks[index], ...preparedArtwork };
      // @ts-expect-error TS(4111): Property 'metadata' comes from an index signature,... Remove this comment to see the full error message
      if (values.metadata && !preparedArtwork.width) {
        // @ts-expect-error TS(4111): Property 'metadata' comes from an index signature,... Remove this comment to see the full error message
        updatedArtworks[index].width = preparedArtwork.metadata.widthInch;
        // @ts-expect-error TS(4111): Property 'metadata' comes from an index signature,... Remove this comment to see the full error message
        updatedArtworks[index].height = preparedArtwork.metadata.heightInch;
      }
      if (Object.prototype.hasOwnProperty.call(values, "removeBackground")) {
        // @ts-expect-error TS(4111): Property 'removeBackground' comes from an index si... Remove this comment to see the full error message
        updatedArtworks[index].metadata.removeBackground = values.removeBackground;
      }
      // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
      this.artworksState = updatedArtworks;
    },
    setRemovalFile(id) {
      // @ts-expect-error TS(4111): Property 'fileToRemove' comes from an index signat... Remove this comment to see the full error message
      this.fileToRemove = id;
    },
    setPreCut(preCut) {
      // @ts-expect-error TS(4111): Property 'preCut' comes from an index signature, s... Remove this comment to see the full error message
      this.preCut = preCut;
    },
    setPreCutPrice(price) {
      // @ts-expect-error TS(4111): Property 'preCutPrice' comes from an index signatu... Remove this comment to see the full error message
      this.preCutPrice = price;
    },
    setPreCutEnabled(preCutEnabled) {
      // @ts-expect-error TS(4111): Property 'preCutEnabled' comes from an index signa... Remove this comment to see the full error message
      this.preCutEnabled = preCutEnabled;
    },
    setPreCutDuration(preCutDuration) {
      // @ts-expect-error TS(4111): Property 'preCutDuration' comes from an index sign... Remove this comment to see the full error message
      this.preCutDuration = preCutDuration;
    },
    setLoadFromConfig(loadFromConfig) {
      // @ts-expect-error TS(4111): Property 'loadFromConfig' comes from an index sign... Remove this comment to see the full error message
      this.loadFromConfig = loadFromConfig;
    },
    setEnablePreCut() {
      // @ts-expect-error TS(4111): Property 'enablePreCut' comes from an index signat... Remove this comment to see the full error message
      this.enablePreCut = true;
    },
    resetRemovalFile() {
      // @ts-expect-error TS(4111): Property 'fileToRemove' comes from an index signat... Remove this comment to see the full error message
      this.fileToRemove = null;
    },
    reindexArtworks() {
      // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
      this.artworksState = this.artworksState.map((artwork, newIndex) => ({
        ...artwork,
        originalIndex: newIndex
      }));
    },
    removeArtwork(id) {
      if (id) {
        transfersPollingService.stopPolling(id);
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artworkToRemove = this.artworksState.find((artwork: any) => artwork.id === id);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.cancelPinningSessionForArtwork(artworkToRemove, {
        errorMessage: "Failed to cancel pinning session on artwork removal"
      });

      // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
      this.artworksState = this.artworksState.filter((artwork: any) => artwork.id !== id);

      // Reindex remaining artworks to maintain consistent originalIndex values
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.reindexArtworks();

      // @ts-expect-error TS(4111): Property 'fileToRemove' comes from an index signat... Remove this comment to see the full error message
      this.fileToRemove = null;
      // @ts-expect-error TS(4111): Property 'sticker' comes from an index signature, ... Remove this comment to see the full error message
      if (this.sticker) {
        // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
        this.simulation = { ...this.simulation, width: null, height: null };
      }
      // @ts-expect-error TS(4111): Property 'spangles' comes from an index signature,... Remove this comment to see the full error message
      this.spangles = { ...this.spangles, completedSpangleData: [] };
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (!this.artworksState.length) {
        // @ts-expect-error TS(4111): Property 'showModal' comes from an index signature... Remove this comment to see the full error message
        this.showModal = false;
      }
    },
    clearWorkspace() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.cleanupPolling();

      // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
      this.artworksState = [];
      // @ts-expect-error TS(4111): Property 'summary' comes from an index signature, ... Remove this comment to see the full error message
      this.summary = initialState.summary;
      // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
      this.simulation = { ...DEFAULT_SIMULATION_ARTWORK };
    },
    openModal() {
      // @ts-expect-error TS(4111): Property 'showModal' comes from an index signature... Remove this comment to see the full error message
      this.showModal = true;
    },
    hideModal() {
      // @ts-expect-error TS(4111): Property 'showModal' comes from an index signature... Remove this comment to see the full error message
      this.showModal = false;
    },
    setShowCTA(showCTA) {
      // @ts-expect-error TS(4111): Property 'showCTA' comes from an index signature, ... Remove this comment to see the full error message
      this.showCTA = showCTA;
    },
    setAllowForceBgRemove(allowForceBgRemove) {
      // @ts-expect-error TS(4111): Property 'allowForceBgRemove' comes from an index ... Remove this comment to see the full error message
      this.allowForceBgRemove = allowForceBgRemove;
    },
    setCanvaDtfEnabled(canvaDtfEnabled) {
      // @ts-expect-error TS(4111): Property 'canvaDtfEnabledState' comes from an inde... Remove this comment to see the full error message
      this.canvaDtfEnabledState = canvaDtfEnabled;
    },
    setEnableMobileFooterCTA(enableMobileFooterCTA) {
      // @ts-expect-error TS(4111): Property 'enableMobileFooterCTA' comes from an ind... Remove this comment to see the full error message
      this.enableMobileFooterCTA = enableMobileFooterCTA;
    },
    setCanvaReviewer(canvaReviewer) {
      // @ts-expect-error TS(4111): Property 'canvaReviewer' comes from an index signa... Remove this comment to see the full error message
      this.canvaReviewer = canvaReviewer;
    },
    setVariantId(variantId) {
      // @ts-expect-error TS(4111): Property 'variantId' comes from an index signature... Remove this comment to see the full error message
      this.variantId = variantId;
    },
    setProductId(productId) {
      // @ts-expect-error TS(4111): Property 'productId' comes from an index signature... Remove this comment to see the full error message
      this.productId = productId;
    },
    setProductSlug(productSlug) {
      // @ts-expect-error TS(4111): Property 'productSlug' comes from an index signatu... Remove this comment to see the full error message
      this.productSlug = productSlug;
    },
    setFavorites(favorites) {
      // @ts-expect-error TS(4111): Property 'favorites' comes from an index signature... Remove this comment to see the full error message
      this.favorites = favorites;
    },
    setPdpType(pdpType) {
      // @ts-expect-error TS(4111): Property 'pdpType' comes from an index signature, ... Remove this comment to see the full error message
      this.pdpType = pdpType;
    },
    setCatalogNumber(catalogNumber) {
      // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
      this.catalogNumber = catalogNumber;
    },
    setMessagingConsents(messagingConsents) {
      // @ts-expect-error TS(4111): Property 'messagingConsents' comes from an index s... Remove this comment to see the full error message
      this.messagingConsents = messagingConsents;
    },
    setPrintAsIs(printAsIs) {
      // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
      this.printAsIs = printAsIs;
    },
    setNeckLabel(neckLabel) {
      // @ts-expect-error TS(4111): Property 'neckLabel' comes from an index signature... Remove this comment to see the full error message
      this.neckLabel = neckLabel;
    },
    setSticker(sticker) {
      // @ts-expect-error TS(4111): Property 'sticker' comes from an index signature, ... Remove this comment to see the full error message
      this.sticker = sticker;
    },
    setStickerQrScanned(stickerQrScanned) {
      // @ts-expect-error TS(4111): Property 'stickerQrScanned' comes from an index si... Remove this comment to see the full error message
      this.stickerQrScanned = stickerQrScanned;
    },
    setDtfMaxWidth(dtfMaxWidth) {
      // @ts-expect-error TS(4111): Property 'dtfMaxWidth' comes from an index signatu... Remove this comment to see the full error message
      this.dtfMaxWidth = dtfMaxWidth;
    },
    setDtfMaxHeight(dtfMaxHeight) {
      // @ts-expect-error TS(4111): Property 'dtfMaxHeight' comes from an index signat... Remove this comment to see the full error message
      this.dtfMaxHeight = dtfMaxHeight;
    },
    setDtfMinWidth(dtfMinWidth) {
      // @ts-expect-error TS(4111): Property 'dtfMinWidth' comes from an index signatu... Remove this comment to see the full error message
      this.dtfMinWidth = dtfMinWidth;
    },
    setDtfMinHeight(dtfMinHeight) {
      // @ts-expect-error TS(4111): Property 'dtfMinHeight' comes from an index signat... Remove this comment to see the full error message
      this.dtfMinHeight = dtfMinHeight;
    },
    setIsRetrying(isRetrying) {
      // @ts-expect-error TS(4111): Property 'isRetrying' comes from an index signatur... Remove this comment to see the full error message
      this.isRetrying = isRetrying;
    },
    setRetryFailed(value) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.artworksState = this.artworksState.map((artwork: any) =>
        artwork.id ? artwork : { ...artwork, retryFailed: value }
      );
    },
    setIsLoading(value) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.artworksState = this.artworksState.map((artwork: any) =>
        artwork.id ? artwork : { ...artwork, isLoading: value }
      );
    },
    setShowDiscardModal() {
      // @ts-expect-error TS(4111): Property 'showDiscardModal' comes from an index si... Remove this comment to see the full error message
      this.showDiscardModal = true;
    },
    hideDiscardModal() {
      // @ts-expect-error TS(4111): Property 'showDiscardModal' comes from an index si... Remove this comment to see the full error message
      this.showDiscardModal = false;
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, artwork: unknown, { error... Remove this comment to see the full error message
    cancelPinningSessionForArtwork(
      artwork,
      { errorMessage = "Failed to cancel pinning session" } = {}
    ) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (!artwork?.pinningSessionId) return;

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artworkId = artwork.id;
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const sessionId = artwork.pinningSessionId;

      cancelSession(sessionId)
        .then(() => {
          trackTransfersPinningInstructionsRemoved({
            artworkId,
            sessionId
          });
        })
        .catch(error => {
          notifyError(errorMessage, {
            context: { artworkId, sessionId, error }
          });
        });
    },
    dropMultiArtwork() {
      // @ts-expect-error TS(4111): Property 'showModal' comes from an index signature... Remove this comment to see the full error message
      this.showModal = false;
      // @ts-expect-error TS(4111): Property 'summary' comes from an index signature, ... Remove this comment to see the full error message
      this.summary = initialState.summary;
      // @ts-expect-error TS(2488): Type 'unknown' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
      const discardedArtworks = [...this.artworksState];
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const notUploadedArtworks = this.artworksState.filter(
        (artwork: any) => artwork.isFile || artwork.isLoading
      );

      discardedArtworks.forEach(artwork => {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.cancelPinningSessionForArtwork(artwork, {
          errorMessage: "Failed to cancel pinning session on artwork discard"
        });
      });

      // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
      this.artworksState = [];
      // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
      const initialValuesForSize = this.printAsIs ? GANG_DEFAULT_VALUES : DEFAULT_VALUES;
      // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
      this.simulation = { ...DEFAULT_SIMULATION_ARTWORK, ...initialValuesForSize };

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.cleanupPolling();

      if (!notUploadedArtworks.length) return;
      // @ts-expect-error TS(4111): Property 'discarded' comes from an index signature... Remove this comment to see the full error message
      this.discarded = new Date();
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.fetchController?.abort();
      // @ts-expect-error TS(4111): Property 'fetchController' comes from an index sig... Remove this comment to see the full error message
      this.fetchController = null;
    },
    removeArtworkByIndex(index) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artworkToRemove = this.artworksState.find(
        (artwork: any) => artwork.originalIndex === index
      );
      if (artworkToRemove?.id) {
        transfersPollingService.stopPolling(artworkToRemove.id);
      }

      // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
      this.artworksState = this.artworksState.filter(
        (artwork: any) => artwork.originalIndex !== index
      );

      // Reindex remaining artworks to maintain consistent originalIndex values
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.reindexArtworks();

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (!this.artworksState.length) {
        // @ts-expect-error TS(4111): Property 'showModal' comes from an index signature... Remove this comment to see the full error message
        this.showModal = false;
      }
    },
    setEmptyArtwork(id) {
      // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
      this.artworksState = [
        // @ts-expect-error TS(2488): Type 'unknown' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
        ...this.artworksState,
        {
          ...emptyArtworkItem,
          id,
          isLoading: true,
          isFile: false,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          originalIndex: this.artworksState.length
        }
      ];
    },
    setDiscarded(value) {
      // @ts-expect-error TS(4111): Property 'discarded' comes from an index signature... Remove this comment to see the full error message
      this.discarded = value;
    },
    setFetchController(signal) {
      // @ts-expect-error TS(4111): Property 'fetchController' comes from an index sig... Remove this comment to see the full error message
      this.fetchController = signal;
    },
    setUseDefaultValues(useDefaultValues) {
      // @ts-expect-error TS(4111): Property 'useDefaultValues' comes from an index si... Remove this comment to see the full error message
      this.useDefaultValues = useDefaultValues;
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { index, message, isMulti... Remove this comment to see the full error message
    setValidationErrorMessage({ index, message, isMultiSizeError, type }) {
      const error = {
        errorMessage: message,
        isMultiSizeError,
        isValid:
          !type ||
          // @ts-expect-error TS(2339): Property 'description' does not exist on type '"in... Remove this comment to see the full error message
          !Object.values(ErrorTypes).some(symbol => symbol.description === type.description)
      };

      if (type !== undefined) {
        // @ts-expect-error TS(2339): Property 'errorType' does not exist on type '{ err... Remove this comment to see the full error message
        error.errorType = type;
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (!this.artworksState.length) {
        // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
        this.simulation = {
          // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
          ...this.simulation,
          ...error
        };
        return;
      }

      // @ts-expect-error TS(2488): Type 'unknown' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
      const updatedArtworks = [...this.artworksState];
      if (!updatedArtworks[index]) return;

      updatedArtworks[index] = { ...updatedArtworks[index], ...error };
      // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
      this.artworksState = updatedArtworks;
      // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
      this.artworksState = [...this.artworksState];
    },
    setLocale(locale) {
      // @ts-expect-error TS(4111): Property 'locale' comes from an index signature, s... Remove this comment to see the full error message
      this.locale = locale;
    },
    setReplaceArtwork(replace) {
      // @ts-expect-error TS(4111): Property 'replaceArtwork' comes from an index sign... Remove this comment to see the full error message
      this.replaceArtwork = replace;
    },
    resetFilesError() {
      // @ts-expect-error TS(4111): Property 'showFilesError' comes from an index sign... Remove this comment to see the full error message
      this.showFilesError = false;
    },
    setShowArtworkHistoryModal(show) {
      // @ts-expect-error TS(4111): Property 'showArtworkHistoryModal' comes from an i... Remove this comment to see the full error message
      this.showArtworkHistoryModal = show;
    },
    setArtworkHistory(history) {
      // @ts-expect-error TS(4111): Property 'artworkHistory' comes from an index sign... Remove this comment to see the full error message
      this.artworkHistory = history;
    },
    setArtworkHistoryPagination(pageInfo) {
      // @ts-expect-error TS(4111): Property 'artworkHistoryPagination' comes from an ... Remove this comment to see the full error message
      this.artworkHistoryPagination = { ...this.artworkHistoryPagination, ...pageInfo };
    },
    setUserType(type) {
      // @ts-expect-error TS(4111): Property 'userType' comes from an index signature,... Remove this comment to see the full error message
      this.userType = type;
    },
    setBogoEligibility(eligibility) {
      // @ts-expect-error TS(4111): Property 'bogoEligibility' comes from an index sig... Remove this comment to see the full error message
      this.bogoEligibility = eligibility;
    },
    setBogoMaxDimensionLabel(label) {
      // @ts-expect-error TS(4111): Property 'bogoMaxDimensionLabel' comes from an ind... Remove this comment to see the full error message
      this.bogoMaxDimensionLabel = label;
    },
    setPromotionResolution(resolution) {
      // @ts-expect-error TS(4111): Property 'promotionResolution' comes from an index... Remove this comment to see the full error message
      this.promotionResolution = resolution;
    },
    setIsMobile(isMobile) {
      // @ts-expect-error TS(4111): Property 'isMobile' comes from an index signature,... Remove this comment to see the full error message
      this.isMobile = isMobile;
    },
    setPrintingServiceName(printingServiceName) {
      // @ts-expect-error TS(4111): Property 'printingServiceName' comes from an index... Remove this comment to see the full error message
      this.printingServiceName = printingServiceName;
    },
    setDtfChannelUuid(uuid) {
      // @ts-expect-error TS(4111): Property 'dtfChannelUuid' comes from an index sign... Remove this comment to see the full error message
      this.dtfChannelUuid = uuid;
    },
    setActionCableOptions(options) {
      // @ts-expect-error TS(4111): Property 'actionCableOptions' comes from an index ... Remove this comment to see the full error message
      this.actionCableOptions = options;
    },
    setActionCableConnected(value) {
      // @ts-expect-error TS(4111): Property 'actionCableConnected' comes from an inde... Remove this comment to see the full error message
      this.actionCableConnected = value;
    },

    handlePollingEnhancementComplete(artwork) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artworkIndex = this.artworks.findIndex((a: any) => Number(a.id) === Number(artwork.id));
      if (artworkIndex === -1) {
        return;
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.clearValidateArtworkStartEventInterval(artwork.id);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateEnhancedArtwork(artwork);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updatePrintReadyInfoState(artwork.id);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updatePreviewDpi({ artworkId: artwork.id });
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.downscaleOriginalImage({ artworkId: artwork.id });
      // @ts-expect-error TS(4111): Property 'isGoldFoil' comes from an index signatur... Remove this comment to see the full error message
      if (this.isGoldFoil) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.generateGoldFoilImages({ artworkId: artwork.id });
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.convertImageToHexColor({ artwork });
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (!this.artworks.some((a: any) => a.isLoading)) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.getArtworksPricing();
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.dispatchTrackingEvents(artwork);
    },
    dispatchTrackingEvents(artwork) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const existingArtwork = this.artworks.find((a: any) => Number(a.id) === Number(artwork.id));
      if (existingArtwork?.imageProcessingCompletedEventSent) {
        return;
      }

      submitDtfEvent("image_processing_completed", {
        payload: {
          process_data: artwork,
          // @ts-expect-error TS(4111): Property 'dtfChannelUuid' comes from an index sign... Remove this comment to see the full error message
          stream_name: `dtf_channel_${this.dtfChannelUuid}`,
          action_type: "enhancement_complete",
          worker_enhancement: true
        },
        business_line: "transfers",
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        artwork_id: artwork.id,
        completion_source: "polling_fallback"
      });

      trackRudderstackImageProcessingCompleted({
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        artwork_id: artwork.id,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        dpi: artwork.metadata?.dpi,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        location: artwork.metadata?.uploaded_on,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        file_name: artwork.filename,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        file_type: artwork.filetype,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        file_size: artwork.filesize,
        // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
        business_line: this.businessLine,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        artworks_count: this.artworks.length,
        // @ts-expect-error TS(4111): Property 'preCut' comes from an index signature, s... Remove this comment to see the full error message
        pre_cut_transfers: this.preCut
      });

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValuesById({
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        id: artwork.id,
        imageProcessingCompletedEventSent: true
      });

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      api.dtf.acknowledgeArtwork({ id: artwork.id }).catch(() => {
        // Silently ignore errors
      });
    },
    setMockupColorForArtwork(artwork) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const whitePixelsRatio = Number(artwork.metadata?.white_pixels_ratio || 0);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artworkIndex = this.artworks.findIndex((item: any) => item.id === artwork.id);
      if (artworkIndex !== -1) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setPresetMockupColor({
          index: artworkIndex,
          color: whitePixelsRatio > 50 ? "#000000" : "#E1E1E1"
        });
      }
    },
    getEnhancedArtworkImageUrls(artwork) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (artwork.manualEditUrl) {
        return {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          imageUrl: artwork.manualEditUrl,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          enhancedImageUrl: artwork.manualEditUrl,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          url: artwork.manualEditUrl,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          sliderPreviewUrl: artwork.manualEditNoTrimUrl || artwork.manualEditUrl,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          previewUrl: artwork.manualEditUrl,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          displayUrl: artwork.manualEditUrl,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          trimmedWithBgUrl: artwork.manualEditUrl,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          trimmedNoBgUrl: artwork.manualEditUrl,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          trimmedImageUrl: artwork.manualEditUrl
        };
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const useNoBg = artwork.removeBackground || artwork.metadata?.remove_background;
      const imageUrl = useNoBg
        ? // @ts-expect-error TS(2571): Object is of type 'unknown'.
          artwork.noBgUrl || artwork.imageUrl
        : // @ts-expect-error TS(2571): Object is of type 'unknown'.
          artwork.withBgUrl || artwork.imageUrl;
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const enhancedImageUrl = artwork.noBgUrl || artwork.imageUrl;

      return {
        imageUrl,
        enhancedImageUrl,
        url: imageUrl,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        sliderPreviewUrl: artwork.noBgNoTrimUrl || artwork.noBgUrl,
        previewUrl: imageUrl,
        displayUrl: imageUrl,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        trimmedWithBgUrl: artwork.withBgUrl,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        trimmedNoBgUrl: artwork.noBgUrl,
        trimmedImageUrl: imageUrl
      };
    },
    getEnhancedArtworkDimensions(artwork) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const useNoBg = artwork.removeBackground || artwork.metadata?.remove_background;
      const correctMetadata = useNoBg
        ? // @ts-expect-error TS(2571): Object is of type 'unknown'.
          artwork.enhancedMetadata || artwork.metadata
        : // @ts-expect-error TS(2571): Object is of type 'unknown'.
          artwork.withBgMetadata || artwork.metadata;
      const widthInch = correctMetadata?.width_inch || correctMetadata?.widthInch;
      const heightInch = correctMetadata?.height_inch || correctMetadata?.heightInch;

      return {
        width: widthInch,
        height: heightInch,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        originalWidth: artwork.originalMetadata?.width_inch || artwork.originalMetadata?.widthInch,
        originalHeight:
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          artwork.originalMetadata?.height_inch || artwork.originalMetadata?.heightInch
      };
    },
    getEnhancedArtworkSizes(artwork, dimensions) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const existingArtwork = this.artworks.find((a: any) => a.id === artwork.id);
      let sizesAndQuantities = existingArtwork?.sizesAndQuantities || [];

      // @ts-expect-error TS(4111): Property 'showMultiSize' comes from an index signa... Remove this comment to see the full error message
      if (this.showMultiSize && (!sizesAndQuantities.length || !existingArtwork?.isSizesEdited)) {
        sizesAndQuantities = [
          {
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            width: dimensions.width,
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            height: dimensions.height,
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            quantity: this.initialValues.quantity,
            preset: "custom",
            id: getRandomId()
          }
        ];
      }

      return sizesAndQuantities;
    },
    updateEnhancedArtwork(artwork) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setLoadedArtwork({ artwork });
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setMockupColorForArtwork(artwork);

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const dimensions = this.getEnhancedArtworkDimensions(artwork);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const imageUrls = this.getEnhancedArtworkImageUrls(artwork);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const sizesAndQuantities = this.getEnhancedArtworkSizes(artwork, dimensions);

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValuesById({
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        id: artwork.id,
        enhancementCompleted: true,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        enhancedNoBgUrl: artwork.noBgUrl,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        enhancedWithBgUrl: artwork.withBgUrl,
        ...imageUrls,
        ...dimensions,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        metadata: artwork.metadata,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        enhancedMetadata: artwork.enhancedMetadata,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        originalMetadata: artwork.originalMetadata,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        withBgMetadata: artwork.withBgMetadata,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        canRemoveBg: artwork.canRemoveBg,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        removeBackground: artwork.removeBackground || artwork.metadata?.remove_background,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        originalImageUrl: artwork.originalImageUrl,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        originalMime: artwork.metadata?.mime_type,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        enhancedDpi: artwork.metadata?.dpi,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        originalDpi: artwork.originalMetadata?.dpi || 300,
        enhanceImage: true,
        lastWebSocketEvent: "enhancement_complete_via_polling",
        lastWebSocketEventData: {
          source: "polling_fallback",
          data: artwork
        },
        isLoading: false,
        progress: 100,
        progressMessage: "Complete",
        sizesAndQuantities
      });
    },
    handleWebSocketEnhancementComplete(artworkId) {
      transfersPollingService.stopPolling(artworkId);
    },
    cleanupPolling() {
      transfersPollingService.stopAllPolling();
    },
    schedulePollingFallback(artworkId) {
      // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
      if (!artworkId || !transfersPollingService.isPollingEnabled(this.catalogNumber)) return;

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artworkExists = this.artworks.some(
        (artwork: any) => artwork.id && Number(artwork.id) === Number(artworkId)
      );

      if (!artworkExists) {
        return;
      }

      // Check if polling is already active for this artwork
      if (transfersPollingService.isPolling(artworkId)) {
        return;
      }

      transfersPollingService.startPolling(
        artworkId,
        (enhancedArtwork: any) => {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.handlePollingEnhancementComplete(enhancedArtwork);
        },
        {
          // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
          catalogNumber: this.catalogNumber,
          // @ts-expect-error TS(4111): Property 'dtfChannelUuid' comes from an index sign... Remove this comment to see the full error message
          dtfChannelUuid: this.dtfChannelUuid,
          checkArtworkExists: (id: any) =>
            // @ts-expect-error TS migration
            this.artworks.some((artwork: any) => artwork.id && Number(artwork.id) === Number(id))
        }
      );
    },
    setSpangleAlgorithms(algorithms) {
      // @ts-expect-error TS(4111): Property 'spangleConfig' comes from an index signa... Remove this comment to see the full error message
      this.spangleConfig = { ...this.spangleConfig, spangleAlgorithms: algorithms };
    },
    setIsSpangle(isSpangle) {
      // @ts-expect-error TS(4111): Property 'spangleConfig' comes from an index signa... Remove this comment to see the full error message
      this.spangleConfig = { ...this.spangleConfig, isSpangle };
    },
    setSpangleColors(spangleColors) {
      // @ts-expect-error TS(4111): Property 'spangleConfig' comes from an index signa... Remove this comment to see the full error message
      this.spangleConfig = { ...this.spangleConfig, spangleColors };
    },
    setCable(cable) {
      // @ts-expect-error TS(4111): Property 'cable' comes from an index signature, so... Remove this comment to see the full error message
      this.cable = cable;
    },
    setBusinessLine(businessLine) {
      // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
      this.businessLine = businessLine;
    },
    setIsPuff(isPuff) {
      // @ts-expect-error TS(4111): Property 'isPuff' comes from an index signature, s... Remove this comment to see the full error message
      this.isPuff = isPuff;
    },
    setIsProColor(isProColor) {
      // @ts-expect-error TS(4111): Property 'isProColor' comes from an index signatur... Remove this comment to see the full error message
      this.isProColor = isProColor;
    },
    setIsSticker(isSticker) {
      // @ts-expect-error TS(4111): Property 'isSticker' comes from an index signature... Remove this comment to see the full error message
      this.isSticker = isSticker;
    },
    setIsDieCutSticker(isDieCutSticker) {
      // @ts-expect-error TS(4111): Property 'isDieCutSticker' comes from an index sig... Remove this comment to see the full error message
      this.isDieCutSticker = isDieCutSticker;
    },
    setIsJiffyMade(isJiffyMade) {
      // @ts-expect-error TS(4111): Property 'isJiffyMade' comes from an index signatu... Remove this comment to see the full error message
      this.isJiffyMade = isJiffyMade;
    },
    setIsStickerSample(isStickerSample) {
      // @ts-expect-error TS(4111): Property 'isStickerSample' comes from an index sig... Remove this comment to see the full error message
      this.isStickerSample = isStickerSample;
    },
    setIsLetters(isLetters) {
      // @ts-expect-error TS(4111): Property 'isLetters' comes from an index signature... Remove this comment to see the full error message
      this.isLetters = isLetters;
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, [key, value]: [any, any])... Remove this comment to see the full error message
    toggleLoading([key, value]) {
      // @ts-expect-error TS(4111): Property 'loading' comes from an index signature, ... Remove this comment to see the full error message
      this.loading = { ...this.loading, [key]: value };
    },
    setExperiments(experiments) {
      // @ts-expect-error TS(4111): Property 'experiments' comes from an index signatu... Remove this comment to see the full error message
      this.experiments = experiments;
    },
    setDtfCategory(dtfCategory) {
      // @ts-expect-error TS(4111): Property 'dtfCategory' comes from an index signatu... Remove this comment to see the full error message
      this.dtfCategory = dtfCategory;
    },
    setPreCutUpsellThreshold(preCutUpsellThreshold) {
      // @ts-expect-error TS(4111): Property 'preCutUpsellThreshold' comes from an ind... Remove this comment to see the full error message
      this.preCutUpsellThreshold = Number(preCutUpsellThreshold);
    },
    setPuff(puffData) {
      // @ts-expect-error TS(4111): Property 'puff' comes from an index signature, so ... Remove this comment to see the full error message
      this.puff = { ...this.puff, ...puffData };
    },
    resetPuff() {
      // @ts-expect-error TS(4111): Property 'puff' comes from an index signature, so ... Remove this comment to see the full error message
      this.puff = { ...DEFAULT_PUFF_VALUES };
    },
    setIsJerseyNumbers(isJerseyNumbers) {
      // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
      this.isJerseyNumbers = isJerseyNumbers;
    },
    setPrintReadyInfoShow(show) {
      // @ts-expect-error TS(4111): Property 'printReadyInfoConfig' comes from an inde... Remove this comment to see the full error message
      this.printReadyInfoConfig = { ...this.printReadyInfoConfig, show };
    },
    setPrintReadyInfoExpandable(expanded) {
      // @ts-expect-error TS(4111): Property 'printReadyInfoConfig' comes from an inde... Remove this comment to see the full error message
      this.printReadyInfoConfig = { ...this.printReadyInfoConfig, expanded };
    },
    setArtworkBackground(color) {
      // @ts-expect-error TS(4111): Property 'artworkBackground' comes from an index s... Remove this comment to see the full error message
      this.artworkBackground = color;
    },
    setBackgroundType(backgroundType) {
      // @ts-expect-error TS(4111): Property 'backgroundType' comes from an index sign... Remove this comment to see the full error message
      this.backgroundType = backgroundType;
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { width, height }: { widt... Remove this comment to see the full error message
    setPreviewCanvasSize({ width, height }) {
      // @ts-expect-error TS(4111): Property 'previewCanvasSize' comes from an index s... Remove this comment to see the full error message
      this.previewCanvasSize = { width, height };
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { textIndex, message }: {... Remove this comment to see the full error message
    setLetterPreviewMessage({ textIndex, message }) {
      // @ts-expect-error TS(4111): Property 'letterPreviewMessages' comes from an ind... Remove this comment to see the full error message
      this.letterPreviewMessages = { ...this.letterPreviewMessages, [textIndex]: message };
    },
    clearLetterPreviewMessages() {
      // @ts-expect-error TS(4111): Property 'letterPreviewMessages' comes from an ind... Remove this comment to see the full error message
      this.letterPreviewMessages = {};
    },
    removeLetterPreviewMessage(index) {
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      const letterPreviewMessagesCopy = { ...this.letterPreviewMessages };

      delete letterPreviewMessagesCopy[index];

      // @ts-expect-error TS(4111): Property 'letterPreviewMessages' comes from an ind... Remove this comment to see the full error message
      this.letterPreviewMessages = Object.entries(letterPreviewMessagesCopy).reduce(
        (newMessages, [, value], newIndex) => {
          // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          newMessages[newIndex] = value;
          return newMessages;
        },
        {}
      );
    },
    setLetterPreviewLoading(value) {
      // @ts-expect-error TS(4111): Property 'letterPreviewLoading' comes from an inde... Remove this comment to see the full error message
      this.letterPreviewLoading = value;
    },
    setIsGoldFoil(value) {
      // @ts-expect-error TS(4111): Property 'isGoldFoil' comes from an index signatur... Remove this comment to see the full error message
      this.isGoldFoil = value;
    },
    setForcePdpTransfersRedraw(value) {
      // @ts-expect-error TS(4111): Property 'forcePdpTransfersRedraw' comes from an i... Remove this comment to see the full error message
      this.forcePdpTransfersRedraw = value;
    },
    setPinBasedRedrawEnabled(value) {
      // @ts-expect-error TS(4111): Property 'pinBasedRedrawEnabled' comes from an ind... Remove this comment to see the full error message
      this.pinBasedRedrawEnabled = value;
    },
    setPinBasedRedrawEscaped(value) {
      // @ts-expect-error TS(4111): Property 'pinBasedRedrawEscaped' comes from an ind... Remove this comment to see the full error message
      this.pinBasedRedrawEscaped = value;
    },
    setEnableRedraw(value) {
      // @ts-expect-error TS(4111): Property 'enableRedraw' comes from an index signat... Remove this comment to see the full error message
      this.enableRedraw = value;
    },
    setIsPricingLoading(value) {
      // @ts-expect-error TS(4111): Property 'isPricingLoading' comes from an index si... Remove this comment to see the full error message
      this.isPricingLoading = value;
    },
    setShowMultiSize(value) {
      // @ts-expect-error TS(4111): Property 'showMultiSizeArtwork' comes from an inde... Remove this comment to see the full error message
      this.showMultiSizeArtwork = value;
    },
    setGangSheetBuilder(value) {
      // @ts-expect-error TS(4111): Property 'gangSheetBuilder' comes from an index si... Remove this comment to see the full error message
      this.gangSheetBuilder = value;
    },
    setShowGangSheetBuilder(value) {
      // @ts-expect-error TS(4111): Property 'showGangSheetBuilder' comes from an inde... Remove this comment to see the full error message
      this.showGangSheetBuilder = value;
    },
    setGeneratedGangSheets(value) {
      // @ts-expect-error TS(4111): Property 'generatedGangSheets' comes from an index... Remove this comment to see the full error message
      this.generatedGangSheets = value;
    },
    setGangSheetBuilderShopId(value) {
      // @ts-expect-error TS(4111): Property 'gangSheetBuilderShopId' comes from an in... Remove this comment to see the full error message
      this.gangSheetBuilderShopId = value;
    },
    setShowGangSheetBuilderFeature(value) {
      // @ts-expect-error TS(4111): Property 'showGangSheetBuilderFeature' comes from ... Remove this comment to see the full error message
      this.showGangSheetBuilderFeature = value;
    },
    setIsGangSheetBuilder(value) {
      // @ts-expect-error TS(4111): Property 'isGangSheetBuilder' comes from an index ... Remove this comment to see the full error message
      this.isGangSheetBuilder = value;
    },
    setGangSheetBuilderVariants(value) {
      // @ts-expect-error TS(4111): Property 'gangSheetBuilderVariants' comes from an ... Remove this comment to see the full error message
      this.gangSheetBuilderVariants = value;
    },
    updateGangSheetBuilderSettings(value) {
      // @ts-expect-error TS(4111): Property 'gangSheetBuilderSettings' comes from an ... Remove this comment to see the full error message
      this.gangSheetBuilderSettings = {
        // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
        ...this.gangSheetBuilderSettings,
        // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
        ...value
      };
    },
    setReorderEnabled(value) {
      // @ts-expect-error TS(4111): Property 'reorderEnabled' comes from an index sign... Remove this comment to see the full error message
      this.reorderEnabled = value;
    },
    setIsDtfSheet(value) {
      // @ts-expect-error TS(4111): Property 'isDtfSheet' comes from an index signatur... Remove this comment to see the full error message
      this.isDtfSheet = value;
    },
    setGangSheetBulkPrice(value) {
      // @ts-expect-error TS(4111): Property 'gangSheetBulkPrice' comes from an index ... Remove this comment to see the full error message
      this.gangSheetBulkPrice = {
        // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
        ...this.gangSheetBulkPrice,
        // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
        ...value
      };
    },
    setGangSheetBuilderSizes(value) {
      // @ts-expect-error TS(4111): Property 'gangSheetBuilderSizes' comes from an ind... Remove this comment to see the full error message
      this.gangSheetBuilderSizes = value;
    },
    setStoreCreditInfo(info) {
      // @ts-expect-error TS(4111): Property 'storeCreditInfo' comes from an index sig... Remove this comment to see the full error message
      this.storeCreditInfo = info;
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { index, color }: { index... Remove this comment to see the full error message
    setPresetMockupColor({ index, color }) {
      // @ts-expect-error TS(2488): Type 'unknown' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
      const updated = [...this.presetMockupColor];
      updated[index] = color;
      // @ts-expect-error TS(4111): Property 'presetMockupColor' comes from an index s... Remove this comment to see the full error message
      this.presetMockupColor = updated;
    },
    removePresetMockupColor(index) {
      // @ts-expect-error TS(2488): Type 'unknown' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
      const updated = [...this.presetMockupColor];
      // @ts-expect-error TS(2769): No overload matches this call.
      updated.splice(index, 1);
      // @ts-expect-error TS(4111): Property 'presetMockupColor' comes from an index s... Remove this comment to see the full error message
      this.presetMockupColor = updated;
    },
    setGangSheetBuilderCarousels(value) {
      // @ts-expect-error TS(4111): Property 'gangSheetBuilderCarousels' comes from an... Remove this comment to see the full error message
      this.gangSheetBuilderCarousels = value;
    },
    setPreloadedDesignId(value) {
      // @ts-expect-error TS(4111): Property 'preloadedDesignId' comes from an index s... Remove this comment to see the full error message
      this.preloadedDesignId = value;
    },
    setValidateArtworkStartTime(artworkId, time) {
      // @ts-expect-error TS(4111): Property 'validateArtworkStartTime' comes from an ... Remove this comment to see the full error message
      this.validateArtworkStartTime = { ...this.validateArtworkStartTime, [artworkId]: time };
    },
    setValidateArtworkStartEventIntervalID(artworkId, id) {
      // @ts-expect-error TS(2698): Spread types may only be created from object types.
      const prev = { ...this.validateArtworkStartEventIntervalID };
      prev[artworkId] = id;
      // @ts-expect-error TS(4111): Property 'validateArtworkStartEventIntervalID' com... Remove this comment to see the full error message
      this.validateArtworkStartEventIntervalID = prev;
    },
    setPaidExpertEditAddonEnabled(value) {
      // @ts-expect-error TS(4111): Property 'paidExpertEditAddonEnabled' comes from a... Remove this comment to see the full error message
      this.paidExpertEditAddonEnabled = value;
    },
    setKlaviyoSmsTransactionalSubscribed(value) {
      // @ts-expect-error TS(4111): Property 'klaviyoSmsTransactionalSubscribed' comes... Remove this comment to see the full error message
      this.klaviyoSmsTransactionalSubscribed = value;
    },
    setSmsTransactionalSubscriptionPdpEnabled(value) {
      // @ts-expect-error TS(4111): Property 'smsTransactionalSubscriptionPdpEnabled' ... Remove this comment to see the full error message
      this.smsTransactionalSubscriptionPdpEnabled = value;
    },
    setTransferPdpInactivityDetection(value) {
      // @ts-expect-error TS(4111): Property 'transferPdpInactivityDetection' comes fr... Remove this comment to see the full error message
      this.transferPdpInactivityDetection = value;
    },
    setSmsTransactionalPhone(value) {
      // @ts-expect-error TS(4111): Property 'smsTransactionalPhone' comes from an ind... Remove this comment to see the full error message
      this.smsTransactionalPhone = value;
    },
    setSmsTransactionalSubscribeButtonText(value) {
      // @ts-expect-error TS(4111): Property 'smsTransactionalSubscribeButtonText' com... Remove this comment to see the full error message
      this.smsTransactionalSubscribeButtonText = value;
    },
    setGangSheetCatalogNumbers(catalogNumbers) {
      // @ts-expect-error TS(4111): Property 'gangSheetCatalogNumbers' comes from an i... Remove this comment to see the full error message
      this.gangSheetCatalogNumbers = catalogNumbers;
    },
    setCustomerReviewOnRedraws(value) {
      // @ts-expect-error TS(4111): Property 'customerReviewOnRedraws' comes from an i... Remove this comment to see the full error message
      this.customerReviewOnRedraws = value;
    },
    setCustomerReviewOnTransferRedraws(value) {
      // @ts-expect-error TS(4111): Property 'customerReviewOnTransferRedraws' comes f... Remove this comment to see the full error message
      this.customerReviewOnTransferRedraws = value;
    },
    setPinSessionRecording(value) {
      // @ts-expect-error TS(4111): Property 'pinSessionRecording' comes from an index... Remove this comment to see the full error message
      this.pinSessionRecording = value;
    },
    setPinSessionForceMixpanelRecording(value) {
      // @ts-expect-error TS(4111): Property 'pinSessionForceMixpanelRecording' comes ... Remove this comment to see the full error message
      this.pinSessionForceMixpanelRecording = value;
    },

    setTransferPdpBackButtonDetection(value) {
      // @ts-expect-error TS(4111): Property 'transferPdpBackButtonDetection' comes fr... Remove this comment to see the full error message
      this.transferPdpBackButtonDetection = value;
    },
    async openPinningSession(artworkIndex, initialMessage = null) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artwork = this.artworks[artworkIndex];
      if (!artwork) return;

      trackTransfersPinsCtaClicked({ artworkId: artwork.id });
      startPinSessionRecording({
        // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'boolean'... Remove this comment to see the full error message
        enabled: this.pinSessionRecording,
        // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'boolean'... Remove this comment to see the full error message
        forceMixpanelRecording: this.pinSessionForceMixpanelRecording
      });
      // @ts-expect-error TS(4111): Property 'pinningArtworkIndex' comes from an index... Remove this comment to see the full error message
      this.pinningArtworkIndex = artworkIndex;
      // @ts-expect-error TS(4111): Property 'pinningSessionLoading' comes from an ind... Remove this comment to see the full error message
      this.pinningSessionLoading = true;
      try {
        const previewImageName = getArtworkPreviewImageName(artwork);
        const result = await createSession(String(artwork.id), { previewImageName });
        // @ts-expect-error TS(4111): Property 'pinningModalSessionId' comes from an ind... Remove this comment to see the full error message
        this.pinningModalSessionId = result.sessionId;
        // @ts-expect-error TS(4111): Property 'pendingInitialMessage' comes from an ind... Remove this comment to see the full error message
        this.pendingInitialMessage = initialMessage;
        // @ts-expect-error TS(4111): Property 'showPinningModal' comes from an index si... Remove this comment to see the full error message
        this.showPinningModal = true;
      } catch {
        // @ts-expect-error TS(4111): Property 'pinningArtworkIndex' comes from an index... Remove this comment to see the full error message
        this.pinningArtworkIndex = null;
        // @ts-expect-error TS(4111): Property 'pinningModalSessionId' comes from an ind... Remove this comment to see the full error message
        this.pinningModalSessionId = null;
        // @ts-expect-error TS(4111): Property 'pendingInitialMessage' comes from an ind... Remove this comment to see the full error message
        this.pendingInitialMessage = null;
      } finally {
        // @ts-expect-error TS(4111): Property 'pinningSessionLoading' comes from an ind... Remove this comment to see the full error message
        this.pinningSessionLoading = false;
      }
    },
    editPinningSession(artworkIndex) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artwork = this.artworks[artworkIndex];
      if (!artwork?.pinningSessionId) return;

      trackPinsSessionSummaryEditClicked({
        artworkId: artwork.id,
        sessionId: artwork.pinningSessionId
      });
      // @ts-expect-error TS(4111): Property 'pinningArtworkIndex' comes from an index... Remove this comment to see the full error message
      this.pinningArtworkIndex = artworkIndex;
      // @ts-expect-error TS(4111): Property 'pinningModalSessionId' comes from an ind... Remove this comment to see the full error message
      this.pinningModalSessionId = artwork.pinningSessionId;
      // @ts-expect-error TS(4111): Property 'showPinningModal' comes from an index si... Remove this comment to see the full error message
      this.showPinningModal = true;
    },
    closePinningSession() {
      // @ts-expect-error TS(4111): Property 'showPinningModal' comes from an index si... Remove this comment to see the full error message
      this.showPinningModal = false;
      // @ts-expect-error TS(4111): Property 'pinningArtworkIndex' comes from an index... Remove this comment to see the full error message
      this.pinningArtworkIndex = null;
      // @ts-expect-error TS(4111): Property 'pinningModalSessionId' comes from an ind... Remove this comment to see the full error message
      this.pinningModalSessionId = null;
      // @ts-expect-error TS(4111): Property 'pendingInitialMessage' comes from an ind... Remove this comment to see the full error message
      this.pendingInitialMessage = null;
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { artworkIndex, sessionId... Remove this comment to see the full error message
    completePinningSession({ artworkIndex, sessionId, summary, state }) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artwork = this.artworks[artworkIndex];
      if (artwork) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkValuesById({
          id: artwork.id,
          pinningSessionId: sessionId,
          pinningSummary: summary,
          pinningSessionState: state ?? "completed"
        });
      }
    },
    clearPinningSession(artworkIndex) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artwork = this.artworks[artworkIndex];
      if (!artwork) return;

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.clearPinningSessionFromArtwork(artwork);
    },
    clearPinningSessionFromArtwork(artwork) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.cancelPinningSessionForArtwork(artwork);

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (artwork.manualEditUrl) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.clearManualEdit(artwork);
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValuesById({
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        id: artwork.id,
        pinningSessionId: null,
        pinningSummary: null,
        pinningSessionState: null
      });
    },
    clearManualEdit(artwork) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValuesById({
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        id: artwork.id,
        manualEditUrl: null,
        manualEditNoTrimUrl: null
      });

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (artwork.id) {
        const formData = new FormData();
        formData.append("manual_edit", "false");
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        formData.append("remove_background", String(artwork.removeBackground || false));
        formData.append("start_new_edit", "false");

        api.dtf
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          .completeRefineSession({ dtf_artwork_id: artwork.id }, formData, {
            raw: true,
            useAxiosForRequest: true,
            headers: { "Content-Type": undefined }
          })
          .catch((error: any) => {
            notifyError("Failed to clear manual edit", {
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              context: { artworkId: artwork.id, error }
            });
          });
      }
    },
    setPendingPinningInvalidation(change) {
      // @ts-expect-error TS(4111): Property 'pendingPinningInvalidation' comes from a... Remove this comment to see the full error message
      this.pendingPinningInvalidation = change;
    },
    /* eslint-disable-next-line max-lines-per-function */
    confirmPinningInvalidation() {
      // @ts-expect-error TS(4111): Property 'pendingPinningInvalidation' comes from a... Remove this comment to see the full error message
      const pending = this.pendingPinningInvalidation;
      if (!pending) return;

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artwork = this.artworks.find(
        ({
          id
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
        }: any) => String(id) === String(pending.artworkId)
      );
      if (artwork) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.clearPinningSessionFromArtwork(artwork);
      }

      // Execute the pending change directly
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (pending.type === "enhancementTier" && artwork) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const enhancementTier = pending.value;
        if (artwork.enhancementCompleted) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.updateEnableEnhancement({
            artworkId: artwork.id,
            enableEnhancement: enhancementTier !== "print_original",
            enhancementTier
          });
        } else {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.updateArtworkValuesById({
            id: artwork.id,
            enhancementTier,
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            pricing: this.cachedArtworkPrices[enhancementTier] || {},
            hasExpertEditAddon: artwork.hasExpertEditAddon
          });
        }
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
      } else if (pending.type === "enableEnhancement" && artwork) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateEnableEnhancement({
          artworkId: artwork.id,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          enableEnhancement: pending.value
        });
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        if (pending.section) {
          // @ts-expect-error TS(4111): Property 'lastConfirmedConfigSection' comes from a... Remove this comment to see the full error message
          this.lastConfirmedConfigSection = {
            artworkId: artwork.id,
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            section: pending.section
          };
        }
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
      } else if (pending.type === "removeBackground" && artwork) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkStyle({ id: artwork.id, isBgRemoved: pending.value });
        const paddingSize = artwork.paddingSize || "no_padding";
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.sendUpdateArtworkStyle({
          id: artwork.id,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          isBgRemoved: pending.value,
          padding_size: paddingSize,
          forceBgRemoval: false
        });
      }

      // @ts-expect-error TS(4111): Property 'pendingPinningInvalidation' comes from a... Remove this comment to see the full error message
      this.pendingPinningInvalidation = null;
    },
    cancelPinningInvalidation() {
      // @ts-expect-error TS(4111): Property 'pendingPinningInvalidation' comes from a... Remove this comment to see the full error message
      this.pendingPinningInvalidation = null;
    },
    clearValidateArtworkStartEventInterval(artworkId) {
      // @ts-expect-error TS(4111): Property 'validateArtworkStartTime' comes from an ... Remove this comment to see the full error message
      this.validateArtworkStartTime = { ...this.validateArtworkStartTime, [artworkId]: null };
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      clearInterval(this.validateArtworkStartEventIntervalID[artworkId]);
      // @ts-expect-error TS(2698): Spread types may only be created from object types.
      const prevIntervalIds = { ...this.validateArtworkStartEventIntervalID };
      prevIntervalIds[artworkId] = null;
      // @ts-expect-error TS(4111): Property 'validateArtworkStartEventIntervalID' com... Remove this comment to see the full error message
      this.validateArtworkStartEventIntervalID = prevIntervalIds;
    },
    async addSampleToCart() {
      const payload = {
        ...getFormPayload(),
        sample_pack: true,
        artworks: [
          {
            artwork_id: 0,
            width: 1,
            height: 1,
            quantity: 1,
            // @ts-expect-error TS(4111): Property 'variantId' comes from an index signature... Remove this comment to see the full error message
            variant_id: this.variantId,
            sample_pack: true
          }
        ]
      };

      api.dtf.addToCart(payload).then((_res: any) => {
        // @ts-expect-error TS(2322): Type 'string' is not assignable to type '(string |... Remove this comment to see the full error message
        window.location = "/cart";
      });
    },
    /* eslint-disable max-lines-per-function */
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { files, artworkIndex, ex... Remove this comment to see the full error message
    async addFilesToQueue({ files, artworkIndex, existingArtworkId, uploadSource = null }) {
      // Add files if we are not updating an artwork's file or
      // the current artwork is simulation

      // Set upload_source to catalog_number_PDP if not already set
      if (!uploadSource) {
        // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'null'.
        uploadSource = `${this.catalogNumber}_PDP`;
      }

      submitDtfEvent("image_upload_count", {
        // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
        business_line: this.businessLine,
        image_count: files.length
      });

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (artworkIndex === null || this.artworks[0].isSimulated) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.addFiles(files, artworkIndex ?? this.artworks.length);
      }

      // Reset specified artwork by index
      if (artworkIndex !== null) {
        // @ts-expect-error TS(2339): Property 'widthEdited' does not exist on type 'unk... Remove this comment to see the full error message
        const { widthEdited, width, height } = this.simulation;

        // @ts-expect-error TS(4111): Property 'isSpangle' comes from an index signature... Remove this comment to see the full error message
        const enableCustomSize = widthEdited && !this.isSpangle && artworkIndex === 0;

        let dimensions = {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          width: this.initialValues.width,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          height: this.initialValues.height
        };

        if (enableCustomSize) {
          dimensions = {
            // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
            width: this.printAsIs ? this.initialValues.width : width,
            height
          };
        }

        const quantity =
          // @ts-expect-error TS(4111): Property 'isSticker' comes from an index signature... Remove this comment to see the full error message
          artworkIndex === 0 && !this.isSticker
            ? // @ts-expect-error TS(2571): Object is of type 'unknown'.
              this.simulation.quantity
            : // @ts-expect-error TS(2571): Object is of type 'unknown'.
              this.initialValues.quantity;

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setIsRetrying(false);
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkValues({
          index: artworkIndex,
          ...emptyArtworkItem,
          // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
          ...this.initialValues,
          ...dimensions,
          quantity,
          file: files[0],
          isFile: true,
          name: files[0].name,
          errorMessage: null,
          sizesAndQuantities: [
            {
              ...dimensions,
              quantity,
              preset: "custom",
              id: getRandomId()
            }
          ]
        });
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (this.modalArtworks.length > 1) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.openModal();
      }

      const uploadedTimeStamp = new Date();
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const stateFiles = this.artworks.reduce((res: any, item: any, index: any) => {
        if (item.isFile) {
          return [
            ...res,
            {
              ...item,
              originalIndex: index,
              uploadedTimeStamp
            }
          ];
        }
        return res;
      }, []);

      // load files one by one
      // eslint-disable-next-line no-restricted-syntax
      for (const file of stateFiles) {
        // If artwork index is specified only update that artwork
        if (
          (typeof artworkIndex === "number" && artworkIndex !== file.originalIndex) ||
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.artworks[file.originalIndex]?.retryFailed
        )
          // eslint-disable-next-line no-continue
          continue;

        // @ts-expect-error TS(4111): Property 'discarded' comes from an index signature... Remove this comment to see the full error message
        if (!this.discarded || file.uploadedTimeStamp > this.discarded) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.setFileLoading(file.originalIndex);
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          // eslint-disable-next-line no-await-in-loop
          this.uploadArtwork({
            file,
            artworkIndex,
            existingArtworkId,
            // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
            uploadSource: uploadSource || `${this.catalogNumber}_PDP`
          });
        }
      }
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { file, isDropEvent, artw... Remove this comment to see the full error message
    async uploadArtwork({ file, isDropEvent, artworkIndex, existingArtworkId, uploadSource }) {
      const { printAsIs, pdpType, preCut, businessLine, catalogNumber } = this;

      // Validate file type and materialize for cloud storage providers (Google Drive, Dropbox) on mobile
      // Note: Don't mutate file.file - it's used later for identity checks (line ~2145)
      const {
        valid,
        message,
        file: materializedFile
        // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
      } = await validateAndMaterializeFile(file.file, printAsIs);
      if (!valid) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setFailedUploadArtwork({
          index: file.originalIndex,
          uploadError: message
        });
        logUnsupportedFileTypeEvent(file.file, {
          page: "pdp",
          pdp_type: pdpType,
          business_line: businessLine
        });
        return;
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const uploadUuid = this.trackImageUploadStart(file, isDropEvent);
      const maxRetries = 15;
      const { dtfChannelUuid } = this;
      let retryCount = 0;
      const currentArtworkIndex = artworkIndex || file.originalIndex;
      const handleOnlineStatusChange = async () => {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        if (this.artworks[currentArtworkIndex]?.retryFailed) return;

        // @ts-expect-error TS(4111): Property 'isRetrying' comes from an index signatur... Remove this comment to see the full error message
        if (navigator.onLine && this.isRetrying) this.setIsRetrying(false);
        // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
        await uploadWithRetry(currentArtworkIndex);
      };

      window.addEventListener("online", handleOnlineStatusChange);
      window.addEventListener("offline", handleOnlineStatusChange);

      const uploadWithRetry = async () => {
        const controller = new AbortController();
        const { signal } = controller;
        const { productId } = this;
        const formData = new FormData();
        const processTimeStamp = Date.now();

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setFetchController(controller);
        formData.append("upload_source", uploadSource);
        // @ts-expect-error TS(2345): Argument of type 'File | undefined' is not assigna... Remove this comment to see the full error message
        formData.append("file", materializedFile);
        // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
        formData.append("product_id", productId);
        formData.append("file_original_index", file.originalIndex);
        // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
        formData.append("dtf_channel_uuid", dtfChannelUuid);
        // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
        formData.append("pre_cut", preCut);
        // @ts-expect-error TS(2345): Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
        formData.append("process_time_stamp", processTimeStamp);
        // @ts-expect-error TS(4111): Property 'experiments' comes from an index signatu... Remove this comment to see the full error message
        formData.append("experiments", JSON.stringify(this.experiments || {}));
        if (existingArtworkId) {
          formData.append("existing_artwork_id", existingArtworkId);
        }

        const generatedGangSheetData =
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.generatedGangSheets.length > 0 &&
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.generatedGangSheets.find(
            (gangSheet: any) => gangSheet.id === file.file.name.split(".")[0]
          );

        if (generatedGangSheetData) {
          formData.append("generated_gang_sheet_data", JSON.stringify(generatedGangSheetData));
        }
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkValues({
          index: currentArtworkIndex,
          progress: 0,
          processTimeStamp
        });

        const uploadStartTime = performance.now();
        let artwork = null;

        try {
          artwork = await api.dtf.uploadArtwork(formData, {
            raw: true,
            useAxiosForRequest: true,
            headers: { "Content-Type": undefined },
            signal,
            onUploadProgress: ({ progress }: any) => {
              if (progress === 1) {
                // @ts-expect-error TS(2571): Object is of type 'unknown'.
                this.updateArtworkValues({
                  index: currentArtworkIndex,
                  progress: DTF_PROGRESS_MAPPING.upload_artwork.percentage[0],
                  progressMessage: "Processing file"
                });
              } else {
                // @ts-expect-error TS(2571): Object is of type 'unknown'.
                this.updateArtworkValues({
                  index: currentArtworkIndex,
                  progress: DTF_PROGRESS_MAPPING.upload_artwork.percentage[0]
                });
              }
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              this.setIsRetrying(false);
            }
          });

          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          const artworkObj = this.artworks.find(
            (art: any) => art.originalIndex?.toString() === file.originalIndex.toString()
          );

          if (
            // @ts-expect-error TS(4111): Property 'discarded' comes from an index signature... Remove this comment to see the full error message
            (this.discarded && file.uploadedTimeStamp < this.discarded) ||
            file.file !== artworkObj?.file ||
            artworkObj?.retryFailed
          )
            return;
          // @ts-expect-error TS(4111): Property 'isRetrying' comes from an index signatur... Remove this comment to see the full error message
          if (this.isRetrying) this.setIsRetrying(false);

          // @ts-expect-error TS(2339): Property 'widthEdited' does not exist on type 'unk... Remove this comment to see the full error message
          const { widthEdited, width, height } = this.simulation;

          const dimensions = {
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            width: this.initialValues.width,
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            height: this.initialValues.height
          };

          // @ts-expect-error TS(4111): Property 'isSpangle' comes from an index signature... Remove this comment to see the full error message
          const enableCustomSize = widthEdited && !this.isSpangle && currentArtworkIndex === 0;

          if (enableCustomSize) {
            // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
            dimensions.width = this.printAsIs ? this.initialValues.width : width;
            dimensions.height = height;
          }

          let defaultQuantity =
            // @ts-expect-error TS(4111): Property 'isSticker' comes from an index signature... Remove this comment to see the full error message
            currentArtworkIndex === 0 && !this.isSticker
              ? // @ts-expect-error TS(2571): Object is of type 'unknown'.
                this.simulation.quantity
              : // @ts-expect-error TS(2571): Object is of type 'unknown'.
                this.initialValues.quantity;

          // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
          const previewMetadata = this.printAsIs ? { ...GANG_DEFAULT_VALUES.previewMetadata } : {};

          if (generatedGangSheetData) {
            defaultQuantity = generatedGangSheetData.quantity;
            // @ts-expect-error TS(2339): Property 'heightInch' does not exist on type '{}'.
            previewMetadata.heightInch = generatedGangSheetData.size.height;
          }

          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.updateArtworkValues({
            ...artwork,
            // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
            ...this.initialValues,
            ...dimensions,
            index: currentArtworkIndex,
            lastWebSocketEvent: "upload_artwork",
            lastWebSocketEventData: {
              data: artwork.data
            },
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            pricing: this.cachedArtworkPrices[emptyArtworkItem.enhancementTier] || {},
            quantity: defaultQuantity,
            sizesAndQuantities: [
              {
                ...dimensions,
                quantity: defaultQuantity,
                preset: "custom",
                id: getRandomId()
              }
            ],

            previewMetadata,
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            fromGangSheetBuilder: this.generatedGangSheets.length > 0,
            catalogNumber
          });

          if (retryCount > 0) {
            submitDtfEvent("image_upload_retries_success", {});
            trackRudderstackImageUploadRetry({
              status: "success",
              file_name: file.file.file_name,
              file_type: file.file.type,
              file_size: file.file.size,
              location: "pdp",
              dpi: 300,
              // @ts-expect-error TS(4111): Property 'preCut' comes from an index signature, s... Remove this comment to see the full error message
              pre_cut_transfers: this.preCut
            });
          }

          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.trackImageUploadCompleted({
            file: file.file,
            uploadStartTime,
            artwork,
            uploadUuid
          });

          // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
          if (this.isStandardArtwork) {
            const attrToUpdate = {
              ...objNamesToCamelCase(artwork),
              index: currentArtworkIndex,
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              quantity: this.simulation.quantity
            };

            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.updateArtworkValues({
              ...attrToUpdate,
              originalDpi: artwork.metadata?.dpi,
              sizeBasedDpi: artwork.metadata?.dpi,
              enhancedDpi: 300
            });

            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.schedulePollingFallback(artwork.id);
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.setLoadedArtwork({ artwork });
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.updatePreviewDpi({ artworkId: artwork.id });
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            await this.downscaleOriginalImage({ artworkId: artwork.id });
          }

          // @ts-expect-error TS migration
          if (artwork.metadata?.errors?.length > 0) {
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.setGangsheetValidationError({
              index: currentArtworkIndex,
              artwork,
              type: ErrorTypes.INVALID_GANG_SHEET
            });
          }
        } catch (e) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          if (e.name === "AbortError" || e.name === "CanceledError") return;

          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          const errorResponse = e?.response?.data || e;
          const handledError = ["backend_file_validation", "backend_processing_error"].includes(
            errorResponse?.error_type
          );

          if (
            (errorResponse.error && !errorResponse.success) ||
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            (navigator.onLine && e.message !== "Network Error")
          ) {
            let uploadError;
            if (handledError) {
              uploadError = errorResponse.error;
              // Use the artwork response if available, otherwise pass the error response
              // TODO: properly distinguish artwork object, response object and error object
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              this.trackImageUploadCompleted({
                file: file.file,
                response: errorResponse,
                uploadStartTime,
                artwork: artwork || errorResponse,
                uploadUuid
              });
            } else {
              uploadError = "Upload error";
              logUploadError({
                // @ts-expect-error TS(2571): Object is of type 'unknown'.
                error_message: e.message,
                error: errorResponse.error,
                // @ts-expect-error TS(2322): Type 'boolean' is not assignable to type 'string'.
                handledError,
                uploadError,
                errorResponse
              });
            }
            const pageInfo = {
              pageValue: "pdp",
              // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
              businessLine: this.businessLine
            };
            logUploadErrorEvent(pageInfo, file.file, e);
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.setFailedUploadArtwork({
              index: file.originalIndex,
              uploadError
            });

            return;
          }

          if (retryCount < maxRetries) {
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.setIsRetrying(true);
            const retryInterval = RETRY_INTERVALS[retryCount];
            retryCount += 1;
            submitDtfEvent("image_upload_retry", {});
            // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
            setTimeout(() => uploadWithRetry(artworkIndex), retryInterval);
          } else {
            submitDtfEvent("image_upload_retries_failed", {});
            const errorContext = getErrorContext("pdp", file.file, e);
            submitDtfEvent("image_upload_network_error", errorContext);
            trackRudderstackImageUploadRetry({
              status: "failed",
              file_name: errorContext.file_name,
              file_type: errorContext.file_type,
              file_size: errorContext.file_size,
              dpi: errorContext.dpi,
              location: errorContext.page,
              business_line: errorContext.business_line,
              // @ts-expect-error TS(4111): Property 'preCut' comes from an index signature, s... Remove this comment to see the full error message
              pre_cut_transfers: this.preCut
            });
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.setRetryFailed(true);
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.setIsLoading(true);
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.fetchController?.abort();
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.setFetchController(null);
          }
        } finally {
          window.removeEventListener("online", handleOnlineStatusChange);
          window.removeEventListener("offline", handleOnlineStatusChange);
        }
      };

      // Start the initial upload attempt
      // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
      await uploadWithRetry(artworkIndex);
    },
    /* eslint-enable max-lines-per-function */
    downloadAndTriggerArtworkUploadFlow(artworks) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      artworks.forEach((artwork: any, index: any) => {
        fetch(artwork.originalImageUrl)
          .then(response => response.blob())
          .then(blob => {
            const file = new File([blob], artwork.name, { type: artwork.originalMimeType });
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.addFilesToQueue({
              files: [file],
              artworkIndex: index,
              existingArtworkId: artwork.id
            });
          });
      });
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { file, errorResponse }: ... Remove this comment to see the full error message
    handleProcessError({ file, errorResponse }) {
      if (errorResponse.error && !errorResponse.success) {
        let uploadError;
        if (
          ["backend_file_validation", "backend_processing_error"].includes(errorResponse.error_type)
        ) {
          uploadError = errorResponse.error;
        } else {
          uploadError = "Processing error";

          notifyError("Upload artwork error", {
            params: {
              error_message: errorResponse.message,
              error: errorResponse.error,
              error_response: errorResponse,
              uploadError
            }
          });
        }

        const pageInfo = {
          pageValue: "pdp",
          // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
          businessLine: this.businessLine
        };
        logUploadErrorEvent(pageInfo, file, {
          response: {
            data: errorResponse
          }
        });
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setFailedUploadArtwork({
          index: file.originalIndex,
          uploadError
        });
      }
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { data }: { data: any; })... Remove this comment to see the full error message
    async updateArtworkContent({ data }) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.getArtworksPricing();
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updatePdpDates();
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValuesById(data);
    },
    /* eslint-disable max-lines-per-function */
    async getSimulationPricing(dimensions = {}) {
      const { productId, preCut, showMultiSize } = this;
      const data = {
        artwork_id: "simulation",
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        width: Number(dimensions.width) || 1,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        height: Number(dimensions.height) || 1,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        enhancement_tier: this.simulation.enhancementTier || "full_enhancements"
      };
      const pricingData = await api.dtf.dtfPricing(
        { product: productId },
        {
          artworks: [data],
          pre_cut: preCut,
          // @ts-expect-error TS(4111): Property 'isJiffyMade' comes from an index signatu... Remove this comment to see the full error message
          ...(this.isJiffyMade ? { request_source: "jiffy_made" } : {})
        }
      );

      const storeCredits = objNamesToCamelCase({
        order_subtotal: pricingData.order_subtotal,
        user_store_credits: pricingData.user_specific_store_credits,
        expected_credits: pricingData.expected_transfers_store_credit,
        transfers_cart_subtotal: pricingData.transfers_cart_subtotal,
        tiers: pricingData.transfers_store_credit_tiers
      });

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setStoreCreditInfo(storeCredits);

      // @ts-expect-error TS migration
      EventBus.publish(Events.PRICING_UPDATED, storeCredits);

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setSimulationPricing({
        artworks: pricingData.artworks,
        isMultiSize: showMultiSize
      });
    },
    async getArtworksPricing() {
      const { artworks, productId, preCut, isJerseyNumbers, isLetters, showMultiSize } = this;
      let data = [];
      let response;

      if (showMultiSize) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        artworks.forEach((artwork: any) =>
          artwork.sizesAndQuantities
            .filter((sizeQty: any) => Number(sizeQty.quantity) > 0)
            .forEach((sizeQty: any) => {
              const payload = {
                artwork_id: `${artwork.id}--${sizeQty.id}`,
                width: Number(sizeQty.width) || 1,
                height: Number(sizeQty.height) || 1,
                quantity: Number(sizeQty.quantity),
                enhancement_tier: artwork.enhancementTier || "full_enhancements",
                has_expert_edit_addon: artwork.hasExpertEditAddon || false
              };

              // @ts-expect-error TS(4111): Property 'isStandardDTFProduct' comes from an inde... Remove this comment to see the full error message
              if (this.isStandardDTFProduct && !this.isJiffyMade) {
                // @ts-expect-error TS(2339): Property 'enhancement_request_note' does not exist... Remove this comment to see the full error message
                payload.enhancement_request_note = artwork.enhancementNote || "";
              }

              data.push(payload);
            })
        );
        // @ts-expect-error TS(4111): Property 'isJiffyMade' comes from an index signatu... Remove this comment to see the full error message
      } else if (this.isJiffyMade) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        data = artworks
          .filter((artwork: any) => !artwork.isSimulated)
          .map((artwork: any) => ({
            artwork_id: artwork.id,
            width: Number(artwork.width) || 1,
            height: Number(artwork.height) || 1,
            quantity: Number(artwork.quantity),
            enhancement_tier: artwork.enhancementTier || "full_enhancements",
            has_expert_edit_addon: artwork.hasExpertEditAddon || false
          }));
      } else {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        data = (isJerseyNumbers || isLetters ? this.letterNumberArtworks : artworks).map(
          (artwork: any) => {
            const payload = {
              artwork_id: artwork.id || "simulation",
              width: Number(artwork.width) || 1,
              height: Number(artwork.height) || 1,
              quantity: Number(artwork.quantity),
              enhancement_tier: artwork.enhancementTier || "full_enhancements",
              has_expert_edit_addon: artwork.hasExpertEditAddon || false
            };

            // @ts-expect-error TS(4111): Property 'isStandardDTFProduct' comes from an inde... Remove this comment to see the full error message
            if (this.isStandardDTFProduct && !this.isJiffyMade) {
              // @ts-expect-error TS(2339): Property 'enhancement_request_note' does not exist... Remove this comment to see the full error message
              payload.enhancement_request_note = artwork.enhancementNote || "";
            }

            return payload;
          }
        );
      }

      if (!data.length) return;

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setIsPricingLoading(true);

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updatePricingAbortSignal?.abort();
      // @ts-expect-error TS(4111): Property 'updatePricingAbortSignal' comes from an ... Remove this comment to see the full error message
      this.updatePricingAbortSignal = new AbortController();
      try {
        response = await api.dtf.dtfPricing(
          { product: productId },
          {
            artworks: data,
            pre_cut: preCut,
            // @ts-expect-error TS(4111): Property 'isJiffyMade' comes from an index signatu... Remove this comment to see the full error message
            ...(this.isJiffyMade ? { request_source: "jiffy_made" } : {})
          },
          {
            useAxiosForRequest: true,
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            signal: this.updatePricingAbortSignal.signal
          }
        );
      } catch (error) {
        if (!shouldReportError(error)) return;

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const status = error?.response?.status || error?.status;
        if (status && [401, 403, 422].includes(status)) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.setIsPricingLoading(false);
          return;
        }

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setIsPricingLoading(false);
        notifyError("Error fetching artworks pricing", {
          params: {
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            error_message: error.message,
            product_id: productId,
            pre_cut: preCut,
            // @ts-expect-error TS(4111): Property 'isJiffyMade' comes from an index signatu... Remove this comment to see the full error message
            is_jiffy_made: this.isJiffyMade,
            artworks: data,
            show_multi_size: showMultiSize
          }
        });
        return;
      }

      if (showMultiSize) {
        response = {
          ...response,
          artworks: groupByKeyPrefix(response.artworks, "--")
        };
      }

      const storeCredits = objNamesToCamelCase({
        order_subtotal: response.order_subtotal,
        user_store_credits: response.user_specific_store_credits,
        expected_credits: response.expected_transfers_store_credit,
        transfers_cart_subtotal: response.transfers_cart_subtotal,
        tiers: response.transfers_store_credit_tiers
      });

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setStoreCreditInfo(storeCredits);

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setArtworkPricing({ response, isMultiSize: showMultiSize });
      // @ts-expect-error TS migration
      EventBus.publish(Events.PRICING_UPDATED, storeCredits);
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { skipDeliveryDateLoading... Remove this comment to see the full error message
    async initDefaultValues({ skipDeliveryDateLoading = false } = {}) {
      const {
        initialValues,
        isJerseyNumbers,
        isLetters,
        variantId,
        catalogNumber,
        loadFromConfig
      } = this;

      if (!loadFromConfig && !isJerseyNumbers && !isLetters) return;

      try {
        // @ts-expect-error TS migration
        const response = await api.dtf.getInitConfig({ catalog_number: catalogNumber });
        // @ts-expect-error TS migration
        const { success, error, applyDefaultValues, preCut, dtfChannelUuid, messagingConsents } =
          objNamesToCamelCase(response);

        if (!success) {
          // attempt to retrieve error from server if present
          throw new Error(error);
        }

        const pdpDateRequest = {
          // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
          ...initialValues,
          variant_id: variantId,
          artwork_id: "simulation"
        };

        if (!loadFromConfig && (isJerseyNumbers || isLetters)) {
          if (isLetters) {
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.generateLettersPreview(true);
          }

          reloadDeliveryEstimates([pdpDateRequest], preCut);
          return;
        }

        // Only set up cable connection if we're not in enhancement loading flow
        // @ts-expect-error TS(4111): Property 'isEnhancementLoading' comes from an inde... Remove this comment to see the full error message
        if (!this.isEnhancementLoading) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.setDtfChannelUuid(dtfChannelUuid);

          const cable = initCable(this);
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.setCable(cable);
        }

        if (messagingConsents) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.setMessagingConsents(messagingConsents);
        }

        if (applyDefaultValues) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.setPreCut(preCut);
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.setEnablePreCut();

          if (!skipDeliveryDateLoading) {
            reloadDeliveryEstimates([pdpDateRequest], preCut);
          }

          const defaultValues = structuredClone(initialValues);

          // Ensure the default values use the correct enhancement tier based on experiments
          // The simulation object already has the correct enhancement tier set from experiments
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          defaultValues.enhancementTier = this.simulation.enhancementTier;

          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          await this.getSimulationPricing(defaultValues);
          if (isJerseyNumbers || isLetters) {
            // @ts-expect-error TS migration
            defaultValues.height = null;
          }

          // @ts-expect-error TS(4111): Property 'showMultiSize' comes from an index signa... Remove this comment to see the full error message
          if (this.showMultiSize) {
            // @ts-expect-error TS migration
            defaultValues.sizesAndQuantities = [
              {
                // @ts-expect-error TS migration
                ...defaultValues,
                preset: "custom",
                id: getRandomId()
              }
            ];
          }

          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.updateArtworkValues(defaultValues);
        } else {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.updatePdpDates();
        }

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setUseDefaultValues(applyDefaultValues);
      } catch (error) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        if (error.message === "Unable to connect to server") {
          // eslint-disable-next-line no-alert
          alert(
            "Unable to connect to server. Please check your internet connection and try again."
          );
        } else {
          if (!isRelevantBrowserError(error)) return;

          const errorParams = {};
          Object.getOwnPropertyNames(error).forEach(key => {
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            errorParams[key] = error[key];
          });

          notifyError("Could not get dtf init meta", {
            params: {
              ...errorParams,
              // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
              catalog_number: this.catalogNumber,
              // @ts-expect-error TS(4111): Property 'loadFromConfig' comes from an index sign... Remove this comment to see the full error message
              load_from_config: this.loadFromConfig,
              url: window?.location?.href
            }
          });
        }
      }
    },
    /* eslint-enable max-lines-per-function */
    async updatePreCut(preCut) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setPreCut(preCut);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.getArtworksPricing();
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updatePdpDates();
    },
    // eslint-disable-next-line max-lines-per-function
    async trackArtworkAddToCart(artwork) {
      const { formArtworks, variantId, catalogNumber, businessLine, isStandardArtwork } = this;

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const storeArtwork = this.artworks.find((a: any) => a.id === artwork.artwork_id);
      const variant = await getVariantInfo(variantId);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artworkMetadata = artwork.metadata;
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artworkBorneoMetadata = artwork.borneo_metadata;

      const trackProperties = {
        brand: variant.product.brand,
        product_category: variant.product.adwords_category,
        product: variant.product.name,
        spree_composition_id: variant.compositionId,
        composition: variant.color,
        fulfillment_group: variant.fulfillmentGroup || "",
        sku: variant.sku,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        quantity: artwork.quantity,
        buy_it_again: getIsBuyItAgainStatus(),
        favorite: variant.favorite,
        softness_score: variant.softnessScore,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        dtf_width: artwork.width,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        dtf_height: artwork.height,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        dtf_area: artwork.width * artwork.height,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        from_dam: artwork.from_dam,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        multi_artwork: formArtworks.length > 1,
        dtf_image_souce: artworkMetadata.imageSource,
        business_line: businessLine,
        // @ts-expect-error TS(4111): Property 'preCut' comes from an index signature, s... Remove this comment to see the full error message
        pre_cut: this.preCut,
        background_removed: artworkMetadata.removeBackground,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        background_color: artwork.bg_color,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        border_size: artwork.padding_size,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        shape: artwork.shape,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        redraw_requested: artwork.enhancement_request_note || storeArtwork?.pinningSummary,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        multi_size: artwork.sizes_and_quantities?.length > 1,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        enhancement_tier: artwork.enhancement_tier,
        catalog_number: variant.product.catalog_number
      };

      if (isStandardArtwork) {
        // @ts-expect-error TS(2339): Property 'enhance_image' does not exist on type '{... Remove this comment to see the full error message
        trackProperties.enhance_image = artwork.enhanceImage;
      }

      // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
      if (["SPNG-HGR001", "SPNG-GLS001", "SPNG-RNB001"].includes(catalogNumber)) {
        // @ts-expect-error TS(2339): Property 'dtf_spangles_algorithm' does not exist o... Remove this comment to see the full error message
        trackProperties.dtf_spangles_algorithm = spanglesStore.selectedAlgorithm;
        // @ts-expect-error TS(2339): Property 'artwork_url' does not exist on type '{ b... Remove this comment to see the full error message
        trackProperties.artwork_url = spanglesStore.originalArtworkUrl;
      }

      // @ts-expect-error TS(4111): Property 'isPuff' comes from an index signature, s... Remove this comment to see the full error message
      if (this.isPuff) {
        // @ts-expect-error TS(2339): Property 'color' does not exist on type '{ brand: ... Remove this comment to see the full error message
        trackProperties.color = artwork.color;
      }

      // additional params for borneo images
      if (artworkMetadata.imageSource === "borneo") {
        // @ts-expect-error TS(2339): Property 'dtf_borneo_fonts_count' does not exist o... Remove this comment to see the full error message
        trackProperties.dtf_borneo_fonts_count = artworkBorneoMetadata.fonts.fonts?.length || 0;
        // @ts-expect-error TS(2339): Property 'dtf_borneo_font_details' does not exist ... Remove this comment to see the full error message
        trackProperties.dtf_borneo_font_details = artworkBorneoMetadata.fonts.font_details;

        const summary = summarizeFonts(artworkBorneoMetadata.fonts?.font_details);
        // @ts-expect-error TS(2339): Property 'dtf_borneo_non_unique_fonts' does not ex... Remove this comment to see the full error message
        trackProperties.dtf_borneo_non_unique_fonts = summary.fontFamilies;
        // @ts-expect-error TS(2339): Property 'dtf_borneo_fonts' does not exist on type... Remove this comment to see the full error message
        trackProperties.dtf_borneo_fonts = [...new Set(summary.fontFamilies)];
        // @ts-expect-error TS(2339): Property 'dtf_borneo_non_unique_effects' does not ... Remove this comment to see the full error message
        trackProperties.dtf_borneo_non_unique_effects = summary.textEffects;
        // @ts-expect-error TS(2339): Property 'dtf_borneo_effects' does not exist on ty... Remove this comment to see the full error message
        trackProperties.dtf_borneo_effects = [...new Set(summary.textEffects)];
        // @ts-expect-error TS(2339): Property 'dtf_borneo_images_count' does not exist ... Remove this comment to see the full error message
        trackProperties.dtf_borneo_images_count = artworkBorneoMetadata.images.total_images;
        // @ts-expect-error TS(2339): Property 'dtf_borneo_texts_count' does not exist o... Remove this comment to see the full error message
        trackProperties.dtf_borneo_texts_count = artworkBorneoMetadata.fonts.total_texts;
        // @ts-expect-error TS(2339): Property 'dtf_borneo_shapes_count' does not exist ... Remove this comment to see the full error message
        trackProperties.dtf_borneo_shapes_count = artworkBorneoMetadata.elements.total_shapes;
        // @ts-expect-error TS(2339): Property 'dtf_borneo_enhancements' does not exist ... Remove this comment to see the full error message
        trackProperties.dtf_borneo_enhancements = artworkBorneoMetadata.enhancements;
        // @ts-expect-error TS(2339): Property 'dtf_borneo_project_id' does not exist on... Remove this comment to see the full error message
        trackProperties.dtf_borneo_project_id = artwork.project_id;
      }

      // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
      if (this.isJerseyNumbers || this.isLetters) {
        const itemDetails = {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          style: artwork.style,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          height: artwork.height,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          color: artwork.color
        };

        // @ts-expect-error TS(4111): Property 'isLetters' comes from an index signature... Remove this comment to see the full error message
        if (this.isLetters) {
          // @ts-expect-error TS(2339): Property 'font' does not exist on type '{ style: a... Remove this comment to see the full error message
          itemDetails.font = artwork.font;
          // @ts-expect-error TS(2339): Property 'texts' does not exist on type '{ style: ... Remove this comment to see the full error message
          itemDetails.texts = artwork.texts.filter(Boolean);
          // @ts-expect-error TS(2339): Property 'max_length' does not exist on type '{ st... Remove this comment to see the full error message
          itemDetails.max_length = artwork.maxLength;
        }
        // quantities":{"1":5,"2":2,"3":1}
        // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
        if (this.isJerseyNumbers && Object.keys(artwork.quantities).length) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          Object.keys(artwork.quantities).forEach(key => {
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            itemDetails[`number_${key}`] = artwork.quantities[key];
          });
        }

        // @ts-expect-error TS(2339): Property 'item_details' does not exist on type '{ ... Remove this comment to see the full error message
        trackProperties.item_details = itemDetails;
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (artwork.from_gang_sheet_builder) {
        // @ts-expect-error TS(2339): Property 'gang_sheet_builder_variant' does not exi... Remove this comment to see the full error message
        trackProperties.gang_sheet_builder_variant = artwork.catalog_number;
      }

      // @ts-expect-error TS(4111): Property 'showMultiSize' comes from an index signa... Remove this comment to see the full error message
      if (this.showMultiSize && artwork.sizes_and_quantities?.length > 1) {
        submitDtfEvent("multiple_sizes_added", {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          number_of_sizes: artwork.sizes_and_quantities.length,
          brand: variant.product.brand,
          product_category: variant.product.adwords_category,
          product: variant.product.name,
          spree_composition_id: variant.compositionId,
          composition: variant.color
        });

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        artwork.sizes_and_quantities.forEach((sq: any) => {
          submitDtfEvent("product_added", {
            ...trackProperties,
            dtf_width: sq.width,
            dtf_height: sq.height,
            dtf_area: sq.width * sq.height,
            quantity: sq.quantity,
            predefined_placement: sq.preset,
            placement_size: sq.size
          });
        });
      } else {
        // @ts-expect-error TS(2339): Property 'predefined_placement' does not exist on ... Remove this comment to see the full error message
        trackProperties.predefined_placement = "custom";
        submitDtfEvent("product_added", trackProperties);
      }
    },
    buildReorderDtfData(selectedArtworks, prices) {
      // @ts-expect-error TS(4111): Property 'locale' comes from an index signature, s... Remove this comment to see the full error message
      const currency = this.locale === "en-CA" ? "C$" : "$";
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return selectedArtworks.map(({ id, dtfPrintId, url, metadata }: any) => ({
        id,
        catalogNumber: "Jiffy Transfers",
        // @ts-expect-error TS(4111): Property 'productId' comes from an index signature... Remove this comment to see the full error message
        productId: this.productId,
        // @ts-expect-error TS(4111): Property 'variantId' comes from an index signature... Remove this comment to see the full error message
        variantId: this.variantId,
        color: "",
        image: url,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        quantity: prices[dtfPrintId].quantity,
        // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
        size: `${metadata.widthInch}" x ${metadata.heightInch}${this.printAsIs ? "'" : '"'}`,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        price: `${currency}${Number(prices[dtfPrintId].price).toFixed(2)}`,
        preCut: false,
        preCutPrice: 0
      }));
    },
    async submitPrintReorder(selectedArtworks) {
      try {
        const response = await withCsrfRetry(
          () =>
            api.dtf.addToCartPrint({
              // @ts-expect-error TS(4111): Property 'variantId' comes from an index signature... Remove this comment to see the full error message
              variant_id: this.variantId,
              quantity: 1,
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              dtf_print_ids: selectedArtworks.map((artwork: any) => artwork.dtfPrintId),
              source_page: "design_library"
            }),
          "dtf_print_reorder"
        );
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const dtfData = this.buildReorderDtfData(selectedArtworks, response.artwork_prices);
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        incrementHeaderCounter(selectedArtworks.length);
        EventBus.publish(Events.MOBILE_GRID_SUBMIT, { dtfData });
        EventBus.publish(Events.ITEMS_ADDED_TO_CART, { ...response, is_dtf: true });
        deliveryDateResponse.reloadDeliveryEstimatesWithoutFetch({
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          pdpSubtotal: this.summary?.orderSubtotal
        });
      } catch (error) {
        if (isSessionExpired(error)) {
          redirectTo("/login");
          return;
        }
        notifyError("Error adding to cart", {
          params: { error: JSON.stringify(error) }
        });
      }
    },
    // eslint-disable-next-line max-lines-per-function
    submitForm() {
      const payload = getFormPayload();

      submitDtfEvent("dtf_add_to_cart_clicked", {
        ...payload,
        // @ts-expect-error TS(4111): Property 'variantId' comes from an index signature... Remove this comment to see the full error message
        variant_id: this.variantId,
        // @ts-expect-error TS(4111): Property 'totalQuantity' comes from an index signa... Remove this comment to see the full error message
        quantity: this.totalQuantity,
        // @ts-expect-error TS(2769): No overload matches this call.
        artwork_count: Object.values(this.formArtworks).length,
        // @ts-expect-error TS(4111): Property 'preCut' comes from an index signature, s... Remove this comment to see the full error message
        pre_cut: this.preCut,
        // @ts-expect-error TS(4111): Property 'showMultiSize' comes from an index signa... Remove this comment to see the full error message
        multi_size: this.showMultiSize
      });
      const { formArtworks, preCut, isReadyForOrder } = this;
      // @ts-expect-error TS(2769): No overload matches this call.
      const artworkValues = Object.values(formArtworks);
      let hasEmptyValues = false;
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      artworkValues.find(artwork => !artwork.quantity);

      // @ts-expect-error TS(4111): Property 'showMultiSize' comes from an index signa... Remove this comment to see the full error message
      if (this.showMultiSize) {
        // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'boolean'... Remove this comment to see the full error message
        hasEmptyValues = artworkValues.find(artwork =>
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          artwork.sizes_and_quantities?.find((sq: any) => !sq.quantity)
        );
      } else {
        // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'boolean'... Remove this comment to see the full error message
        hasEmptyValues = artworkValues.find(artwork => !artwork.quantity);
      }

      if (!isReadyForOrder) {
        return;
      }

      if (!artworkValues.length || hasEmptyValues) {
        validation.show({ hasFormErrors: true });
        return;
      }

      const requestData = {
        ...payload,
        artworks: formArtworks,
        pre_cut: preCut
      };

      mobileApp.mq.publish("feedback", { type: "vibration" });

      // @ts-expect-error TS(4111): Property 'showModal' comes from an index signature... Remove this comment to see the full error message
      if (this.showModal) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.hideModal();
      }
      idleCallback(() =>
        EventBus.publish(Events.MOBILE_GRID_SUBMIT, {
          // @ts-expect-error TS(4111): Property 'showMultiSize' comes from an index signa... Remove this comment to see the full error message
          dtfData: this.showMultiSize ? this.csmDataMultiSize : this.csmData
        })
      );

      withCsrfRetry(() => api.dtf.addToCart(requestData), "dtf_add_to_cart")
        .then(response => {
          if (response.success) {
            // @ts-expect-error TS(4111): Property 'totalQuantity' comes from an index signa... Remove this comment to see the full error message
            incrementHeaderCounter(this.totalQuantity);
            EventBus.publish(Events.ITEMS_ADDED_TO_CART, {
              ...response,
              is_dtf: true
            });
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            formArtworks.forEach(async (artwork: any) => await this.trackArtworkAddToCart(artwork));
            // @ts-expect-error TS(4111): Property 'totalQuantity' comes from an index signa... Remove this comment to see the full error message
            trackAddToCart(this.totalQuantity, response.cart_total);
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.clearWorkspace();
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.resetPuff();
            return;
          }

          // @ts-expect-error TS(2769): No overload matches this call.
          throw new Error({ message: "Add To Cart response is not successful" });
        })
        .catch(e => {
          // @ts-expect-error TS(2581): Cannot find name '$'. Do you need to install type ... Remove this comment to see the full error message
          $("#continue-shopping-modal").modal("hide");

          if (isSessionExpired(e)) {
            redirectTo("/login");
            return;
          }

          const errorResponse = tryParse(e.message);
          // @ts-expect-error TS(2581): Cannot find name '$'. Do you need to install type ... Remove this comment to see the full error message
          $("#adding-failure").modal("show");
          // @ts-expect-error TS(2581): Cannot find name '$'. Do you need to install type ... Remove this comment to see the full error message
          $("#adding-failure").find("#adding-failure-error").html(errorResponse?.error_message);

          if (typeof errorResponse !== "object") {
            // only on non-JSON or malformed server response
            notifyError("Add to cart error", {
              params: { error_message: e.message }
            });
          }

          submitDtfEvent("add_to_cart_error", { error: e.message });
          throw new Error(e);
        });
    },
    updatePdpDates() {
      const { formArtworks, preCut, isJerseyNumbers, isLetters, showMultiSize, artworks } = this;
      let filledArtworks = [];

      if (showMultiSize) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        formArtworks.forEach((artwork: any) => {
          artwork.sizes_and_quantities
            .filter(({ quantity }: any) => !!quantity)
            .forEach((sizeQty: any, index: any) => {
              filledArtworks.push({
                artwork_id: `${artwork.artwork_id}-${index}`,
                ...sizeQty
              });
            });
        });
      } else {
        filledArtworks =
          isJerseyNumbers || isLetters
            ? // @ts-expect-error TS(4111): Property 'letterNumberArtworks' comes from an inde... Remove this comment to see the full error message
              this.letterNumberArtworks
            : // @ts-expect-error TS(2571): Object is of type 'unknown'.
              formArtworks.filter(({ quantity }: any) => !!quantity);
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const designServicesEnabled = artworks.some(
        (artwork: any) => artwork.hasExpertEditAddon && artwork.enhancementNote?.trim()
      );

      // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
      reloadDeliveryEstimates(filledArtworks, preCut, {
        designServicesEnabled,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        pdpSubtotal: this.summary?.orderSubtotal
      });
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { id, isBgRemoved }: { id... Remove this comment to see the full error message
    updateArtworkStyle({ id, isBgRemoved }) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.toggleLoading(["removeBg", true]);

      const { artworks, isSpangle } = this;
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artwork = artworks.find((artworkItem: any) => String(id) === String(artworkItem.id));
      const metadata = isBgRemoved ? artwork.metadata : artwork.withBgMetadata;
      const url = isBgRemoved ? artwork.noBgUrl : artwork.withBgUrl;

      let originalWidth = metadata.widthInch;
      let originalHeight = metadata.heightInch;

      if (artwork.enhanceImage) {
        originalWidth = artwork.withBgMetadata?.originalWidthInch || originalWidth;
        originalHeight = artwork.withBgMetadata?.originalHeightInch || originalHeight;
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValuesById({
        id,
        isLoading: false,
        removeBackground: isBgRemoved,
        width: metadata.widthInch,
        height: metadata.heightInch,
        originalWidth,
        originalHeight,
        errorMessage: null,
        toggleBackgroundError: null,
        originalDpi: 300,
        url
      });

      if (isSpangle) {
        spanglesStore.setOriginalArtworkUrl(url);
      }
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { id, isBgRemoved, update... Remove this comment to see the full error message
    // eslint-disable-next-line max-lines-per-function
    async sendUpdateArtworkStyle({
      id,
      isBgRemoved,
      updateMetadataCache = false,
      shape = null,
      forceBgRemoval = false
    }) {
      try {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const artwork = this.artworks.find((item: any) => String(item.id) === String(id)) || {};
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.toggleLoading(["removeBg", true]);
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkValuesById({ id, processingImage: true });
        // @ts-expect-error TS(4111): Property 'isSticker' comes from an index signature... Remove this comment to see the full error message
        const sticker = this.isSticker || this.isStickerSample;

        // let paddingSize = "no_padding";
        // if (sticker) {
        //   paddingSize =
        //     artwork.paddingSize === "no_padding"
        //       ? DEFAULT_STICKER_VALUES.paddingSize
        //       : artwork.paddingSize;
        // }
        const response = await api.dtf.updateArtworkStyle(
          { id },
          {
            remove: isBgRemoved,
            // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
            catalog_number: this.catalogNumber,
            enhancement_tier: artwork.enhancementTier,
            options: {
              padding_size: artwork.paddingSize,
              shape: artwork.shape,
              force_bg_removal: forceBgRemoval
            }
          },
          {
            raw: true,
            useAxiosForRequest: true,
            headers: { "Content-Type": undefined }
          }
        );

        let data = {};
        if (sticker) {
          const responseData = objNamesToCamelCase(response);
          const { metadata, stickerCutlineWithBgUrl, stickerCutlineNoBgUrl, noBgUrl, withBgUrl } =
            responseData;
          data = { metadata, stickerCutlineWithBgUrl, stickerCutlineNoBgUrl, noBgUrl, withBgUrl };

          if (updateMetadataCache && shape) {
            // @ts-expect-error TS(4111): Property 'isStickerSample' comes from an index sig... Remove this comment to see the full error message
            const dimensions = this.isStickerSample
              ? { width: metadata.widthInch, height: metadata.heightInch }
              : getStickerDimensions(metadata.widthInch, metadata.heightInch);
            data = { ...data, ...dimensions };

            // dispatch("stickers/updateArtworkDataCache", {
            //   id,
            //   shape,
            //   paddingSize,
            //   data
            // });
          }
        } else {
          // @ts-expect-error TS(2339): Property 'url' does not exist on type '{}'.
          data.url = response.remove_background ? response.url : response.with_bg_url;
          // @ts-expect-error TS(2339): Property 'withBgMetadata' does not exist on type '... Remove this comment to see the full error message
          data.withBgMetadata = response.with_bg_metadata;
        }

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkValuesById({ id, processingImage: false, ...data });
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.getArtworksPricing();
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updatePdpDates();
      } catch (e) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const errorResponse = e?.response?.data || {
          error: "Something went wrong. Please, try again!"
        };
        // revert it
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkStyle({ id, isBgRemoved: !isBgRemoved });
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkValuesById({
          id,
          toggleBackgroundError: errorResponse.error,
          processingImage: false
        });
      } finally {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.toggleLoading(["removeBg", false]);
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkValuesById({ id, processingImage: false });
      }
    },
    async buyArtworksAgainFromOrder(orderNumber) {
      const artworks = await api.dtf.getArtworksFromOrder({ order_number: orderNumber });

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.downloadAndTriggerArtworkUploadFlow(
        artworks.map((artwork: any) => ({
          id: artwork.id,
          name: artwork.name,
          originalImageUrl: artwork.url,
          originalMimeType: artwork.filetype
        }))
      );
    },
    /* eslint-disable max-lines-per-function */
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { spangledArtwork }: { sp... Remove this comment to see the full error message
    async buySpangleAgain({ spangledArtwork }) {
      const { catalogNumber, dtfChannelUuid } = this;
      // @ts-expect-error TS(2339): Property 'store' does not exist on type '() => Sto... Remove this comment to see the full error message
      const spanglesStore = useSpanglesStore.store; // eslint-disable-line no-shadow

      // spangled true - artwork selected from 'Previous Purchases' under 'Spangle' tab
      const spangleDuplicateAction = spangledArtwork.spangled ? "min" : "all";

      const artwork = await api.dtf.getArtwork(
        { id: spangledArtwork.id },
        {
          catalog_number: catalogNumber,
          dtf_channel_uuid: dtfChannelUuid,
          spangle_duplicate_action: spangleDuplicateAction,
          upload_source: "transfers"
        }
      );

      const preparedArtwork = objNamesToCamelCase({
        ...spangledArtwork,
        ...artwork,
        success: true
      });

      if (spangledArtwork.spangled) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setLoadedArtwork({
          artwork: preparedArtwork,
          index: 0
        });
      } else {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setEmptyArtwork(null);
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkValues({
          index: 0,
          ...preparedArtwork,
          isLoading: true,
          isFile: false,
          removeBackground: preparedArtwork.metadata.removeBackground,
          width: preparedArtwork.metadata.widthInch,
          height: preparedArtwork.metadata.heightInch,
          originalWidth: preparedArtwork.metadata.widthInch,
          originalHeight: preparedArtwork.metadata.heightInch,
          lengthFoot: preparedArtwork.metadata.lengthFoot
        });
      }

      if (spangledArtwork.spangled) {
        spanglesStore.setIsSpangleReordering(true);

        const spangleVariation = {
          algorithm: "reorder",
          imageUrl: spangledArtwork.spangledImageUrl || artwork.url,
          spangleCsv: artwork.spangle_csv,
          spanglePagesInfo: artwork.metadata.spangle_pages_info,
          positionsJson: artwork.spangle_positions_json,
          isLoading: false,
          error: false
        };

        spanglesStore.setSpangleVariations([{ ...spangleVariation }]);
        spanglesStore.selectVersion({ version: { ...spangleVariation } });
      }

      spanglesStore.setOriginalArtworkUrl(artwork.url);

      let { width, height } = spangledArtwork;

      if (spangleDuplicateAction === "all") {
        width = artwork.metadata.width_inch;
        height = artwork.metadata.height_inch;
      }

      spanglesStore.setLastSpangledDimensions({ width, height });

      const mode = spangledArtwork.spangled ? SPANGLE_MODES.sizeEdited : SPANGLE_MODES.spangleIt;
      spanglesStore.setSpangleMode(mode);
    },
    /* eslint-enable max-lines-per-function */
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { artwork }: { artwork: a... Remove this comment to see the full error message
    async generateCmykImages({ artwork }) {
      if (
        !artwork.annotateEnabled && // always generate CYMK when annotation is enabled
        (artwork.cmykPreviewImageNoBackgroundUrl || artwork.cmykPreviewImageWithBackgroundUrl)
      ) {
        return;
      }

      const cmykData = await api.dtf.generateCmykImages(
        { id: artwork.id },
        // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
        { catalog_number: this.catalogNumber }
      );

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValuesById({
        id: artwork.id,
        cmykPreviewImageNoBackgroundUrl: cmykData.cmyk_preview_image_no_background_url,
        cmykPreviewImageWithBackgroundUrl: cmykData.cmyk_preview_image_with_background_url
      });
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { artwork }: { artwork: a... Remove this comment to see the full error message
    generateSpangleImage({ artwork }) {
      // @ts-expect-error TS(2339): Property 'store' does not exist on type '() => Sto... Remove this comment to see the full error message
      const spanglesStore = useSpanglesStore.store; // eslint-disable-line no-shadow
      spanglesStore.prepareVariations({ isRetry: false });
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValuesById({ id: artwork.id, progress: 100 });

      api.dtf.generateSpangleImage(
        { id: artwork.id },
        {
          // @ts-expect-error TS(4111): Property 'productId' comes from an index signature... Remove this comment to see the full error message
          product_id: this.productId,
          // @ts-expect-error TS(4111): Property 'dtfChannelUuid' comes from an index sign... Remove this comment to see the full error message
          dtf_channel_uuid: this.dtfChannelUuid,
          width_inch: artwork.width,
          height_inch: artwork.height,
          process_time_stamp: artwork.processTimeStamp
        }
      );
    },
    /* eslint-disable max-lines-per-function */
    async buyArtworksAgain(artworks, index) {
      const { artworks: currentArtworks } = this;
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      let currentIndex = currentArtworks[0].id === "simulation" ? 0 : currentArtworks.length;

      // @ts-expect-error TS(4111): Property 'isJiffyMade' comes from an index signatu... Remove this comment to see the full error message
      if (this.isJiffyMade) {
        currentIndex = index;
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artworksToBuy = artworks.map((artwork: any) => ({
        ...emptyArtworkItem,

        // Allow selecting the same image multiple times on Jiffy Made
        // @ts-expect-error TS(4111): Property 'isJiffyMade' comes from an index signatu... Remove this comment to see the full error message
        id: this.isJiffyMade ? `${artwork.id}-${currentIndex}` : artwork.id,

        name: artwork.name,
        url: artwork.url,
        metadata: artwork.metadata,
        width: artwork.metadata.widthInch,
        height: artwork.metadata.heightInch,
        lengthFoot: artwork.metadata.lengthFoot,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        quantity: this.initialValues.quantity,
        originalMime: artwork.originalMime,
        progress: 100,
        curProgress: 100,
        isFile: false,
        success: true,
        isLoading: true,

        // Preselect default prices for artwork
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        pricing: this.cachedArtworkPrices[emptyArtworkItem.enhancementTier] || {},

        enhancementCompleted: artwork.enhancementCompleted,
        enhanceImage: artwork.enhanceImage,
        enhancedNoBgUrl: artwork.enhancedNoBgUrl,
        enhancedWithBgUrl: artwork.enhancedWithBgUrl,
        originalImageUrl: artwork.originalImageUrl,
        sliderPreviewUrl: artwork.sliderPreviewUrl,
        spangled: artwork.spangled,
        spangledImageUrl: artwork.spangledImageUrl,
        cutlineUrl: artwork.cutlineUrl,
        cmykPreviewImageWithBackgroundUrl: artwork.cmykPreviewImageWithBackgroundUrl,
        cmykPreviewImageNoBackgroundUrl: artwork.cmykPreviewImageNoBackgroundUrl,
        goildFoilPreviewAttached: artwork.goildFoilPreviewAttached,
        originalMetadata: artwork.originalMetadata,
        enhancedMetadata: artwork.enhancedMetadata,
        withBgMetadata: artwork.withBgMetadata,
        previewMetadata: artwork.previewMetadata,
        originalDpi: artwork.originalDpi,
        enhancedDpi: artwork.enhancedDpi,
        enhancedOriginalDpi: artwork.enhancedOriginalDpi,
        originalWidth: artwork.originalWidth,
        originalHeight: artwork.originalHeight,
        sizeBasedDpi: artwork.sizeBasedDpi,
        canRemoveBg: artwork.canRemoveBg,
        processTimeStamp: artwork.processTimeStamp,
        manualEditUrl: artwork.manualEditUrl || null,
        manualEditNoTrimUrl: artwork.manualEditNoTrimUrl || null,
        editImageManual: artwork.editImageManual || false,
        pinningSessionId: artwork.pinningSessionId || null
      }));

      // @ts-expect-error TS(4111): Property 'isSpangle' comes from an index signature... Remove this comment to see the full error message
      if (this.isSpangle) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        await this.buySpangleAgain({ spangledArtwork: artworksToBuy[0] });
      } else {
        let lastIndex = currentIndex;
        await Promise.all(
          artworksToBuy.map(async (artwork: any) => {
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            let pdpArtworkIndex = this.artworks.findIndex(
              (element: any) => String(artwork.id) === String(element.id)
            );

            // @ts-expect-error TS(4111): Property 'isJiffyMade' comes from an index signatu... Remove this comment to see the full error message
            if (this.isJiffyMade) {
              pdpArtworkIndex = index;
            }

            // Duplicate artwork on backend when same image is already on PDP
            // @ts-expect-error TS(4111): Property 'isJiffyMade' comes from an index signatu... Remove this comment to see the full error message
            if (pdpArtworkIndex !== -1 && !this.isJiffyMade) {
              try {
                const dupResponse = objNamesToCamelCase(
                  await api.dtf.duplicateArtwork(
                    { id: artwork.id },
                    // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
                    { catalog_number: this.catalogNumber }
                  )
                );
                artwork = {
                  ...artwork,
                  id: dupResponse.id,
                  name: dupResponse.fileName
                };
                pdpArtworkIndex = -1;
              } catch (error) {
                window.DD_RUM?.addError(error, {
                  context: "duplicateArtwork",
                  artworkId: artwork.id
                });
              }
            }

            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            const pdpArtwork = currentArtworks[pdpArtworkIndex];

            const sizes = pdpArtwork?.sizesAndQuantities;

            const sameSizeIndex = sizes?.findIndex(
              (size: any) =>
                `${size.width}${size.height}` === `${artwork.width}${artwork.height}` &&
                size.preset === "custom"
            );

            // @ts-expect-error TS(4111): Property 'isGoldFoil' comes from an index signatur... Remove this comment to see the full error message
            if (this.isGoldFoil && !artwork.goildFoilPreviewAttached && artwork.url) {
              const coloredImage = await convertImageToHexColor(artwork.url, GOLD_FOIL_HEX);
              artwork.url = coloredImage;
            }

            let artworkWidth = artwork.width;
            let artworkHeight = artwork.height;

            if (!artwork.enhanceImage) {
              artworkWidth = artwork.originalMetadata?.widthInch;
              artworkHeight = artwork.originalMetadata?.heightInch;
            }

            const updatedArtwork = {
              ...artwork,
              metadata: {
                ...artwork.metadata,
                widthInch: artworkWidth,
                heightInch: artworkHeight
              }
            };

            // @ts-expect-error TS(4111): Property 'showMultiSize' comes from an index signa... Remove this comment to see the full error message
            if (this.showMultiSize) {
              let updatedSizes = [];
              const size = {
                width: artwork.width,
                height: artwork.height,
                quantity: artwork.quantity,
                preset: "custom",
                id: getRandomId()
              };

              if (pdpArtwork) {
                // @ts-expect-error TS(7006): Parameter 'sizeItem' implicitly has an 'any' type.
                updatedSizes = pdpArtwork?.sizesAndQuantities.map((sizeItem, sizeItemIndex) => ({
                  ...sizeItem,

                  quantity:
                    sameSizeIndex === sizeItemIndex ? sizeItem.quantity + 1 : sizeItem.quantity
                }));

                if (pdpArtwork && sameSizeIndex === -1) {
                  updatedSizes.push(size);
                }
              } else {
                updatedSizes = [size];
              }

              updatedArtwork.sizesAndQuantities = updatedSizes;
            } else if (pdpArtwork) {
              updatedArtwork.quantity = pdpArtwork.quantity + 1;
            }

            const newIndex = pdpArtwork ? pdpArtworkIndex : lastIndex;
            lastIndex = pdpArtwork ? lastIndex : lastIndex + 1;

            updatedArtwork.originalIndex = newIndex;

            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.setLoadedArtwork({
              artwork: updatedArtwork,
              isBuyAgain: true,
              // @ts-expect-error TS(4111): Property 'isJiffyMade' comes from an index signatu... Remove this comment to see the full error message
              index: this.isJiffyMade ? index : newIndex
            });
          })
        );

        // Check for gang sheet validation errors
        // Only validate for gang sheet products (check if catalog number is in gang sheet catalog numbers)
        const isGangSheetProduct =
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.gangSheetCatalogNumbers.length > 0 &&
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.gangSheetCatalogNumbers.includes(this.catalogNumber);

        if (isGangSheetProduct) {
          artworksToBuy.forEach((artwork: any) => {
            const metadata = artwork.metadata || {};
            const errors = validateGangSheetDimensions(metadata);

            // Set validation error if any errors found
            if (errors.length > 0) {
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              const artworkIndex = this.artworks.findIndex(
                (element: any) => String(artwork.id) === String(element.id)
              );
              if (artworkIndex !== -1) {
                // @ts-expect-error TS(2571): Object is of type 'unknown'.
                this.setGangsheetValidationError({
                  index: artworkIndex,
                  artwork: {
                    id: artwork.id,
                    metadata: {
                      ...metadata,
                      errors
                    }
                  },
                  type: ErrorTypes.INVALID_GANG_SHEET
                });
              }
            }
          });
        }
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (this.artworks.length > 1) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.openModal();
      }

      // @ts-expect-error TS(4111): Property 'isProColor' comes from an index signatur... Remove this comment to see the full error message
      if (this.isProColor) {
        artworksToBuy.forEach((artwork: any) => {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.generateCmykImages({ artwork });
        });
      }

      // @ts-expect-error TS(4111): Property 'isSpangle' comes from an index signature... Remove this comment to see the full error message
      if (this.isSpangle) {
        // DO NOT call generateSpangleImage here for artworks from history
        // because buySpangleAgain creates a NEW artwork with a different ID
        // and we would be calling generateSpangleImage with the OLD ID
        // which causes ActionCable events to be ignored (ID mismatch)

        // If artwork needs spangle generation, we should call it with the NEW ID from store
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const storeArtwork = this.artworks[0];
        if (storeArtwork && storeArtwork.isLoading) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.generateSpangleImage({ artwork: storeArtwork });
        }
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.getArtworksPricing();
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updatePdpDates();
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { id, paddingSize }: { id... Remove this comment to see the full error message
    async loadArtworkAndSetPaddingImage({ id, paddingSize }) {
      const artwork = await api.dtf.getArtwork(
        { id },
        {
          // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
          catalog_number: this.catalogNumber,
          // @ts-expect-error TS(4111): Property 'dtfChannelUuid' comes from an index sign... Remove this comment to see the full error message
          dtf_channel_uuid: this.dtfChannelUuid,
          process_artwork: "false",
          file_content_type: null,
          padding_size: paddingSize
        }
      );

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValuesById({ ...artwork });
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { artworkIds, artworkWidt... Remove this comment to see the full error message
    async preloadArtworks({
      artworkIds,
      artworkWidth,
      artworkHeight,
      processArtwork,
      urlPreCut,
      fileContentType,
      artworkPaddingSize,
      artworkBgColor,
      artworkColor,
      artworkShape
    }) {
      deleteCookie("uploaded_artwork_ids");

      const urlParams = new URLSearchParams(window.location.search);
      const enhancementsStarted = urlParams.get("enhancements_started") === "true";
      const hasDtfChannelUuid = urlParams.has("dtf_channel_uuid");

      if (!enhancementsStarted || !hasDtfChannelUuid) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.cleanupUrlParameters();
      }
      if (artworkIds.length > 1) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.openModal();
      }

      // set preCut only if pre_cut URL param is set
      const preCut = tryParse(urlPreCut);
      // Only buy it again provides artwork width and height
      if (typeof preCut === "boolean") {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setLoadFromConfig(false);
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setPreCut(preCut);
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setEnablePreCut();
      }

      const fetchArtworkPromises = artworkIds.map(async (id: any) => {
        if (!processArtwork) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.updateArtworkValuesById({ id, progress: this.isProColor ? 90 : 100 });
        }

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkValuesById({
          id,
          // @ts-expect-error TS(4111): Property 'isSticker' comes from an index signature... Remove this comment to see the full error message
          quantity: this.isSticker ? this.initialValues.quantity : this.simulation.quantity
        });

        // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
        const artworkIndex = findIndexById(this.artworks, id);

        const fetchArtworkWithRetry = async () => {
          let artwork;
          const delays = [300000, 700000, 900000, 1100000, 1300000]; // delays: 300s to 1300s
          // @ts-expect-error TS(4111): Property 'isSticker' comes from an index signature... Remove this comment to see the full error message
          const sticker = this.isSticker || this.isStickerSample;
          const retries = 5;
          const params = {
            // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
            catalog_number: this.catalogNumber,
            // @ts-expect-error TS(4111): Property 'dtfChannelUuid' comes from an index sign... Remove this comment to see the full error message
            dtf_channel_uuid: this.dtfChannelUuid,
            process_artwork: processArtwork,
            file_content_type: fileContentType,
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            process_time_stamp: this.artworks[artworkIndex]?.processTimeStamp || Date.now(),

            padding_size: artworkPaddingSize
          };

          for (let i = 0; i < retries; i += 1) {
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            // eslint-disable-next-line no-await-in-loop
            artwork = await api.dtf.getArtwork({ id }, this.sanitizeObject(params));

            if (artwork && (!sticker || artwork.cutline_url)) {
              return artwork;
            }
            if (i === retries - 1) {
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              this.setFailedUploadArtwork({
                index: 0,
                uploadError: "Processing error, try reloading page"
              });
            }

            // eslint-disable-next-line no-await-in-loop, no-promise-executor-return
            await new Promise(resolve => setTimeout(resolve, delays[i]));
          }

          return artwork;
        };

        let artwork;

        if (id) {
          artwork = await fetchArtworkWithRetry();
        }

        if (!artwork || artwork.metadata.process_cancelled) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.removeArtwork(id);
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.setSimulation({
            ...DEFAULT_SIMULATION_ARTWORK,
            // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
            ...this.initialValues,
            sizesAndQuantities: [
              {
                // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
                ...this.initialValues,
                preset: "custom",
                id: getRandomId()
              }
            ]
          });
          return;
        }

        // @ts-expect-error TS(4111): Property 'isGoldFoil' comes from an index signatur... Remove this comment to see the full error message
        if (this.isGoldFoil && artwork.url) {
          const originalUrl = artwork.url;
          const coloredImage = await convertImageToHexColor(artwork.url, GOLD_FOIL_HEX);
          artwork.url = coloredImage;
          artwork.goldFoilOriginalUrl = originalUrl;
        }

        // @ts-expect-error TS(4111): Property 'isSpangle' comes from an index signature... Remove this comment to see the full error message
        if (this.isSpangle && !processArtwork) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          await this.buyArtworksAgain([{ ...artwork }]);
        } else {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.updateArtworkValuesById({ ...artwork });
        }

        // @ts-expect-error TS(4111): Property 'isProColor' comes from an index signatur... Remove this comment to see the full error message
        if (this.isProColor && !processArtwork) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          await this.generateCmykImages({ artwork });
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.updateArtworkValuesById({ id, progress: 100 });
        }

        if (artwork.metadata) {
          if (artwork.metadata.errors) {
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            const index = this.artworks.length - 1;
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.setGangsheetValidationError({
              index,
              artwork,
              type: ErrorTypes.INVALID_GANG_SHEET
            });
          }
          submitDtfEvent("external_image_loaded", {
            source: artwork.metadata.uploaded_on,
            // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
            business_line: this.businessLine
          });

          // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
          if (artwork.process_artwork !== "true" && !this.isStandardArtwork) {
            let artworkValues = {
              ...artwork,
              width: artworkWidth,
              height: artworkHeight,
              lengthFoot: artwork.metadata.length_foot,
              isLoading: false,
              isFile: false,
              removeBackground: artwork.metadata.remove_background,
              // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
              ...(this.showMultiSize && {
                sizesAndQuantities: [
                  {
                    width: artworkWidth,
                    height: artworkHeight,
                    // @ts-expect-error TS(2571): Object is of type 'unknown'.
                    quantity: this.initialValues.quantity,
                    preset: "custom",
                    id: getRandomId()
                  }
                ]
              })
            };

            // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
            if (this.printAsIs) {
              const previewMetadata = { heightInch: artwork.metadata.height_inch };
              artworkValues = {
                ...artworkValues,
                previewMetadata,
                isValid: true
              };
            }

            // @ts-expect-error TS(4111): Property 'isSticker' comes from an index signature... Remove this comment to see the full error message
            if (this.isSticker || this.isStickerSample) {
              artworkValues = {
                ...artworkValues,
                paddingSize: artworkPaddingSize,
                bgColor: artworkBgColor,
                shape: artworkShape
              };
              // @ts-expect-error TS(4111): Property 'isPuff' comes from an index signature, s... Remove this comment to see the full error message
            } else if (this.isPuff) {
              artworkValues = { ...artworkValues, color: artworkColor };
            }

            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.updateArtworkValuesById(artworkValues);
            // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
          } else if (this.isStandardArtwork) {
            const needProcess = artwork.process_artwork === "true";
            const artworkCamelCased = objNamesToCamelCase(artwork);
            const { originalMetadata, metadata, enhanceImage, enhancedMetadata, withBgMetadata } =
              artworkCamelCased;

            let selectedMetadata = originalMetadata;

            if (!needProcess && enhanceImage) {
              selectedMetadata = artworkCamelCased.removeBackground
                ? enhancedMetadata || metadata
                : withBgMetadata;
            }

            if (needProcess || !enhanceImage) {
              artworkWidth = originalMetadata?.widthInch;
              artworkHeight = originalMetadata?.heightInch;
            }

            const artworkValues = {
              ...artworkCamelCased,
              id: artwork.id,
              enhanceImage: !needProcess ? enhanceImage : true,
              width: artworkWidth,
              height: artworkHeight,
              originalWidth: selectedMetadata?.widthInch,
              originalHeight: selectedMetadata?.heightInch,
              originalDpi:
                !needProcess && enhanceImage
                  ? artworkCamelCased?.enhancedOriginalDpi
                  : originalMetadata?.dpi,
              sizeBasedDpi:
                !needProcess && enhanceImage
                  ? artworkCamelCased?.enhancedOriginalDpi
                  : originalMetadata?.dpi,
              // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
              ...(this.showMultiSize && {
                sizesAndQuantities: [
                  {
                    width: artworkWidth,
                    height: artworkHeight,
                    // @ts-expect-error TS(2571): Object is of type 'unknown'.
                    quantity: this.initialValues.quantity,
                    preset: "custom",
                    id: getRandomId()
                  }
                ]
              }),
              metadata: {
                ...artwork.metadata,
                widthInch: artworkWidth,
                heightInch: artworkHeight,
                aspectRatio: (
                  parseFloat(selectedMetadata.width) / parseFloat(selectedMetadata.height)
                ).toPrecision(6)
              },
              lengthFoot: artwork.metadata.length_foot,
              isLoading: false,
              isFile: false,
              enhancementCompleted: !needProcess,
              removeBackground: artwork.metadata.remove_background,
              originalImageUrl: artwork.original_image_url,
              enhancedNoBgUrl: artwork.no_bg_url,
              enhancedWithBgUrl: artwork.with_bg_url,
              sliderPreviewUrl: artwork.no_bg_no_trim_url,
              enhancedDpi: 300,
              enhancedOriginalDpi: artworkCamelCased?.enhancedOriginalDpi
            };

            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            this.updateArtworkValuesById(artworkValues);

            // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
            const index = findIndexById(this.artworks, artwork.id);
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            const updatedArtwork = this.artworks[index];

            if (!needProcess && enhanceImage) {
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              this.updatePreviewDpi({ artworkId: updatedArtwork.id });
            }
            if (needProcess) {
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              this.schedulePollingFallback(artwork.id);
            }
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            await this.downscaleOriginalImage({ artworkId: updatedArtwork.id });
          }
        }
      });

      await Promise.all(fetchArtworkPromises);

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.getArtworksPricing();
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updatePdpDates();
    },
    /* eslint-enable max-lines-per-function */
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { index, artwork, type }:... Remove this comment to see the full error message
    setGangsheetValidationError({ index, artwork, type }) {
      const { metadata, id } = artwork;
      submitDtfEvent("invalid_gang_sheet", {
        artwork_id: id,
        ...metadata
      });
      // We only need to show the first gang sheet dimension error
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setValidationErrorMessage({
        index,
        message: metadata.errors[0],
        type
      });
    },
    removeArtworkWithActivity(artworkId) {
      const { pdpType, artworks, businessLine } = this;

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artworkIndex = artworks.findIndex((artwork: any) => artwork.id === artworkId);
      if (artworkIndex === -1) return;

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artworkToRemove = this.artworks[artworkIndex];

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.removePresetMockupColor(artworkIndex);

      const eventContext = {
        file_name: artworkToRemove.name,
        file_type: artworkToRemove.filetype,
        file_size: artworkToRemove.filesize,
        width: artworkToRemove.metadata?.width,
        height: artworkToRemove.metadata?.height,
        page: artworkToRemove.metadata?.uploadedOn || "pdp",
        pdp_type: pdpType,
        business_line: businessLine,
        dpi: artworkToRemove.metadata?.upscalingEnabled
          ? Number(artworkToRemove.metadata?.qualityUpscaleDpi)
          : 200,
        resolution_width:
          artworkToRemove.metadata?.trimInfo?.originalWidthPx || artworkToRemove.metadata?.width,
        resolution_height:
          artworkToRemove.metadata?.trimInfo?.originalHeightPx || artworkToRemove.metadata?.height
      };
      submitDtfEvent("image_removed", eventContext);
      trackRudderstackImageRemoved({
        business_line: businessLine,
        file_name: eventContext.file_name,
        file_type: eventContext.file_type,
        file_size: eventContext.file_size,
        location: eventContext.page,
        dpi: artworkToRemove.metadata?.dpi,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        artworks_count: this.artworks?.length,
        // @ts-expect-error TS(4111): Property 'preCut' comes from an index signature, s... Remove this comment to see the full error message
        pre_cut_transfers: this.preCut
      });

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.removeArtwork(artworkId);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setSimulation({ ...DEFAULT_SIMULATION_ARTWORK, ...this.initialValues });
    },
    trackImageUploadStart(file, isDropEvent) {
      const { pdpType, artworks, businessLine, preCut, catalogNumber } = this;
      const uploadUuid = generateUUID();

      submitDtfEvent("image_upload_started", {
        page: "pdp",
        pdp_type: pdpType,
        type: isDropEvent ? "drop" : "browse",
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        file_name: file.file.name,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        file_type: file.file.type,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        file_size: file.file.size,
        dpi: 300,
        project_id: null,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        multi_artwork: artworks?.length > 1,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        artworks_count: artworks?.length,
        business_line: businessLine,
        catalog_number: catalogNumber,
        upload_uuid: uploadUuid
      });

      trackRudderstackImageUploadStarted({
        catalog_number: catalogNumber,
        location: "pdp",
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        file_name: file.file.name,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        file_type: file.file.type,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        file_size: file.file.size,
        dpi: 300,
        business_line: businessLine,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        artworks_count: artworks?.length,
        pre_cut_transfers: preCut,
        upload_uuid: uploadUuid
      });

      return uploadUuid;
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { index, ...data }: { [x:... Remove this comment to see the full error message
    trackImageUploadCompleted({ index, ...data }) {
      const { artwork, file, response, uploadStartTime, uploadUuid } = data;
      const { pdpType, artworks, businessLine, preCut } = this;

      submitCompletedEvent({
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        multiArtwork: artworks?.length > 1,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        artworksCount: artworks?.length,
        // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
        catalogNumber: this.catalogNumber,
        dpi: 300,
        uploadedOn: "pdp",
        preCutTransfers: preCut,
        uploadStartTime,
        file,
        artwork,
        pdpType,
        response,
        businessLine,
        uploadUuid
      });

      sendDataLayer({
        genericEvent: true,
        event: "ImageUploadCompleted",
        filetype: artwork?.filetype,
        filesize: artwork?.filesize
      });
    },
    /* eslint-disable max-lines-per-function */
    async getArtworkHistory(payload) {
      // @ts-expect-error TS(2339): Property 'search' does not exist on type 'unknown'... Remove this comment to see the full error message
      const { search, sortOrder, artworkIds, currentType, apiType, artworksType } = payload;
      try {
        const {
          artworkHistory,
          dtfChannelUuid,
          catalogNumber,
          artworkHistoryPagination: pagination
        } = this;

        const apiParams = {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          per_page: pagination.perPage,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          page: pagination.page,
          tab: artworksType,
          sort: `created_at_${sortOrder}`,
          artwork_ids: artworkIds,
          search,
          dtf_channel_uuid: dtfChannelUuid,
          catalog_number: catalogNumber
        };

        let response;

        if (apiType === "list") {
          response = await api.dtf.getArtworkHistories(apiParams);
        } else {
          response = await api.dtf.getArtworkHistory(apiParams);
        }

        response = objNamesToCamelCase(response);

        const { ...apiPageInfo } = response;
        let { artworks } = response;

        // @ts-expect-error TS(4111): Property 'isGoldFoil' comes from an index signatur... Remove this comment to see the full error message
        if (this.isGoldFoil && currentType === "true") {
          artworks = await Promise.all(
            artworks.map(async (artwork: any) => {
              const coloredImage = await convertImageToHexColor(
                artwork.ordered.imageUrl,
                GOLD_FOIL_HEX
              );

              artwork.ordered.goldFoilImage = coloredImage;
              artwork.ordered.imageUrl = coloredImage;

              return artwork;
            })
          );
        }

        // @ts-expect-error TS(2488): Type 'unknown' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
        const newArtworkList = apiPageInfo.page === 1 ? artworks : [...artworkHistory, ...artworks];

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setArtworkHistoryPagination(apiPageInfo);
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setArtworkHistory(newArtworkList);
      } catch (error) {
        notifyError("DTF previous purchase modal error", {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          params: { error_message: error.message }
        });
      }
    },

    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { color, index }: { color... Remove this comment to see the full error message
    async changePuffColor({ color, index = 0 }) {
      // @ts-expect-error TS(2488): Type 'unknown' must have a '[Symbol.iterator]()' m... Remove this comment to see the full error message
      const [artwork] = this.artworks;
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValues({ index, color });

      let { url } = artwork;
      // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
      if (this.isStandardArtwork) {
        if (artwork.enhancementTier === "print_original") {
          url = artwork.originalImageUrl;
        } else {
          url = artwork.removeBackground ? artwork.sliderPreviewUrl : artwork.enhancedWithBgUrl;
        }
      }

      if (!url) return;

      try {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setPuff({ isLoading: true });

        const coloredImage = await convertImageToHexColor(url, color);

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setPuff({ image: coloredImage });
      } catch (_error) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setPuff({ image: null });
      } finally {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setPuff({ isLoading: false });
      }
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { artwork }: { artwork: a... Remove this comment to see the full error message
    async convertImageToHexColor({ artwork }) {
      if (artwork.url) {
        const coloredImage = await convertImageToHexColor(artwork.url, GOLD_FOIL_HEX);
        artwork.url = coloredImage;
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setLoadedArtwork({ artwork });
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { artworkId }: { artworkI... Remove this comment to see the full error message
    async generateGoldFoilImages({ artworkId }) {
      // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
      const index = findIndexById(this.artworks, artworkId);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artwork = this.artworks[index];

      const tint = (url: any) =>
        url ? convertImageToHexColor(url, GOLD_FOIL_HEX) : Promise.resolve(url);

      const [enhancedWithBgUrl, enhancedNoBgUrl, sliderPreviewUrl, goldFoilOriginalUrl] =
        await Promise.all([
          tint(artwork.enhancedWithBgUrl),
          tint(artwork.enhancedNoBgUrl),
          tint(artwork.sliderPreviewUrl),
          tint(artwork.originalImageUrl)
        ]);

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValuesById({
        id: artworkId,
        enhancedWithBgUrl,
        enhancedNoBgUrl,
        sliderPreviewUrl,
        goldFoilOriginalUrl,
        enhancementCompleted: true
      });
    },
    updatePrintReadyInfoState(artworkId) {
      const { pdpType, isSpangle, artworks } = this;

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artwork = artworks.find(({ id }: any) => String(id) === String(artworkId));
      const show =
        pdpType !== "gang_sheets" &&
        !isSpangle &&
        artwork?.metadata &&
        !artwork.metadata.canRemoveBg &&
        !artwork.metadata.upscaleInfo;
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValuesById({
        id: artworkId,
        printReadyInfo: {
          show,
          expanded: false
        }
      });
    },
    updateJerseyNumberPdpDates: debounce(function updateJerseyNumberPdpDates(this: any) {
      if (!this.isValidJerseyArtwork) return;

      this.updatePdpDates();
    }, 800),
    // eslint-disable-next-line max-lines-per-function
    async downloadLettersPreview(simulation = false) {
      try {
        // @ts-expect-error TS(2339): Property 'style' does not exist on type 'unknown'.
        const { style, font, height, maxLength, color, texts, textIndex } =
          // @ts-expect-error TS(4111): Property 'letterNumberArtwork' comes from an index... Remove this comment to see the full error message
          this.letterNumberArtwork;
        let text = "ABCD";
        if (texts.length) {
          const index = textIndex;
          text = texts[index];
        }
        const imageIndex = textIndex;
        let letterConfig = {
          font,
          color,
          style,
          letter_height_inch: height,
          text,
          max_length_inch: maxLength
        };

        if (simulation) {
          const presentValues = Object.fromEntries(
            Object.entries(letterConfig).filter(([_, value]) => value !== null)
          );
          // @ts-expect-error TS(2741): Property 'text' is missing in type '{ style: strin... Remove this comment to see the full error message
          letterConfig = {
            ...LETTERS_FILL_IN_VALUES,
            ...presentValues
          };
        }

        if (!letterConfig.text) return;

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setLetterPreviewLoading(true);

        const response = await api.dtf.generateLettersPreview({ letter_configs: letterConfig });
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const latestImageIndex = this.letterNumberArtwork.textIndex;

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        if (this.artworks[0].texts[textIndex] === text) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.setLetterPreviewMessage({ textIndex, message: response.validation_message });
        }

        if (imageIndex !== latestImageIndex) return;

        // @ts-expect-error TS(2339): Property 'sizes' does not exist on type 'unknown'.
        const { sizes } = this.letterNumberArtwork;
        sizes[textIndex] = { width: response.width, height: response.height };

        const { url } = response;

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkValues({ index: 0, url, sizes });
        // @ts-expect-error TS(4111): Property 'isLetterReadyForOrder' comes from an ind... Remove this comment to see the full error message
        if (this.isLetterReadyForOrder) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.getArtworksPricing();
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.updatePdpDates();
        }
      } catch (error) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkValues({ index: 0, url: null });
      } finally {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setLetterPreviewLoading(false);
      }
    },
    debouncedGenerateLettersPreview: debounce(
      function debouncedGenerateLettersPreview(this: any) {
        if (this.isLetterPreviewReady) {
          this.downloadLettersPreview();
        } else {
          this.downloadLettersPreview(true);
        }
      },
      800,
      { leading: true }
    ),
    generateLettersPreview(useDebounce = true) {
      if (useDebounce) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.debouncedGenerateLettersPreview();
        // @ts-expect-error TS(4111): Property 'isLetterPreviewReady' comes from an inde... Remove this comment to see the full error message
      } else if (this.isLetterPreviewReady) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.downloadLettersPreview();
      } else {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.downloadLettersPreview(true);
      }
    },
    updateAllLetterPreviews: debounce(
      function updateAllLetterPreviews(this: any) {
        if (this.isLetterReadyForOrder) {
          this.setLetterPreviewLoading(true);
          this.updateLettersPreviews();
        } else if (!this.isLetterPreviewReady) {
          this.downloadLettersPreview(true);
        }
      },
      800,
      { leading: true }
    ),
    async updateLettersPreviews() {
      try {
        // @ts-expect-error TS(4111): Property 'formArtworks' comes from an index signat... Remove this comment to see the full error message
        const requestData = { artworks: this.formArtworks };
        const response = await api.dtf.generateLettersSizes(requestData);
        const artwork = {
          sizes: response.reduce((acc: any, value: any, index: any) => {
            acc[index] = value;
            return acc;
          }, {})
        };

        // @ts-expect-error TS(2339): Property 'textIndex' does not exist on type 'unkno... Remove this comment to see the full error message
        const { textIndex } = this.letterNumberArtwork;
        if (textIndex !== null) {
          // @ts-expect-error TS(2339): Property 'url' does not exist on type '{ sizes: an... Remove this comment to see the full error message
          artwork.url = artwork.sizes[textIndex].url;
        }
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkValues({ index: 0, ...artwork });
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        await this.getArtworksPricing();
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updatePdpDates();
      } catch (error) {
        notifyError("Error generating letters preview", {
          params: { error: JSON.stringify(error) }
        });
      }
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { artworkIds }: { artwork... Remove this comment to see the full error message
    async buyAsStickerById({ artworkIds }) {
      const { catalogNumber, dtfChannelUuid } = this;

      const artworks = await Promise.all(
        artworkIds.map((id: any) =>
          api.dtf.getArtwork(
            { id },
            {
              catalog_number: catalogNumber,
              dtf_channel_uuid: dtfChannelUuid
            }
          )
        )
      );

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.downloadAndTriggerArtworkUploadFlow(
        artworks.map(artwork => ({
          id: artwork.id,
          name: artwork.name,
          originalImageUrl: artwork.url,
          originalMimeType: artwork.filetype
        }))
      );
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { artworkId, enableEnhanc... Remove this comment to see the full error message
    // eslint-disable-next-line max-lines-per-function
    async updateEnableEnhancement({ artworkId, enableEnhancement, enhancementTier: explicitTier }) {
      const enhancementTier =
        explicitTier ?? (enableEnhancement ? "full_enhancements" : "print_original");
      try {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const artwork = this.artworks.find(({ id }: any) => String(id) === String(artworkId));
        const initialMetadata = artwork.metadata;
        const { originalMetadata, metadata, enhancedMetadata, withBgMetadata } = artwork;

        let selectedMetadata = originalMetadata;
        if (enableEnhancement && enhancementTier !== "custom") {
          selectedMetadata =
            artwork.removeBackground || enhancementTier === "full_enhancements"
              ? enhancedMetadata || metadata
              : withBgMetadata;
        }

        if (artwork.pricing?.enhancementTier) {
          // @ts-expect-error TS(4111): Property 'cachedArtworkPrices' comes from an index... Remove this comment to see the full error message
          this.cachedArtworkPrices = {
            // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
            ...this.cachedArtworkPrices,
            [artwork.pricing.enhancementTier]: artwork.pricing
          };
        }

        const attributes = {
          id: artworkId,
          enhanceImage: enableEnhancement,
          enhancementTier,
          width: selectedMetadata?.widthInch,
          height: selectedMetadata?.heightInch,
          originalWidth: selectedMetadata?.widthInch,
          originalHeight: selectedMetadata?.heightInch,
          originalDpi: enableEnhancement ? artwork?.enhancedOriginalDpi : originalMetadata?.dpi,
          sizeBasedDpi: enableEnhancement ? null : originalMetadata?.dpi,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          pricing: this.cachedArtworkPrices[enhancementTier] || {},
          metadata: {
            ...initialMetadata,
            aspectRatio: (
              parseFloat(selectedMetadata?.width) / parseFloat(selectedMetadata?.height)
            ).toPrecision(6)
          }
        };

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkValuesById(attributes);

        if (enableEnhancement) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.updatePreviewDpi({ artworkId });
        }

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        await this.downscaleOriginalImage({ artworkId });

        // currently only support for first artwork
        const apiParams = { dtf_artwork: { enhance_image: enableEnhancement } };
        await api.dtf.updateArtworkRedrawData({ id: artworkId }, apiParams);

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.getArtworksPricing();
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updatePdpDates();

        submitDtfEvent("dtf_image_print_perfect_toggle", {
          // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
          business_line: this.businessLine,
          artwork_id: artworkId,
          enhance_image: enableEnhancement,
          selected_by: "customer",
          metadata: enableEnhancement ? metadata : originalMetadata
        });

        submitDtfEvent("dtf_enhancement_tier_change", {
          // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
          business_line: this.businessLine,
          name: enhancementTier,
          artwork_id: artworkId,
          enhance_image: enableEnhancement,
          metadata: enableEnhancement ? metadata : originalMetadata
        });
      } catch (error) {
        // NOTES: [AR-1578] for debugging an issue. Clean up after the error is identified.
        let errorMessage = "Unknown error occurred";
        let errorStack = "No stack trace available";
        let errorType = "unknown";
        const errorDetails = {};

        if (error) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          errorMessage = error.message || error.error || String(error);
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          errorStack = error.stack || "No stack trace available";
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          errorType = error.name || error.constructor?.name || typeof error;

          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          if (error.response) {
            // @ts-expect-error TS(2339): Property 'response' does not exist on type '{}'.
            errorDetails.response = {
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              status: error.response.status,
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              data: error.response.data
            };
          }
        }

        notifyError("Artwork enhancement setting save from PDP failed", {
          tags: "enhancement-settings-failed-to-save-pdp",
          params: {
            error_message: errorMessage,
            error_type: errorType,
            stack_trace: errorStack,
            error_details: errorDetails,
            enhance_image: enableEnhancement,
            artwork_id: artworkId,
            enhancement_tier: enhancementTier
          }
        });
      }
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { artworkId }: { artworkI... Remove this comment to see the full error message
    updatePreviewDpi({ artworkId }) {
      // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
      if (!this.isStandardArtwork) return;

      // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
      const index = findIndexById(this.artworks, artworkId);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artwork = this.artworks[index];

      // forces SVG images to have a 300 DPI on display
      if (artwork?.originalMime === "image/svg+xml") {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkValuesById({ id: artworkId, originalDpi: 300, sizeBasedDpi: 300 });
        return;
      }

      // logic to retrieve size
      let requestedWidth = artwork.width;
      let requestedHeight = artwork.height;
      if (artwork.sizesAndQuantities.length > 0) {
        const largestSize = artwork.sizesAndQuantities
          .filter((size: any) => size.quantity > 0)
          .reduce(
            (largest: any, current: any) => {
              const largestDimension = parseFloat(largest.width);
              const currentDimension = parseFloat(current.width);
              return currentDimension > largestDimension ? current : largest;
            },
            artwork.sizesAndQuantities.find((size: any) => size.quantity > 0) ||
              artwork.sizesAndQuantities[0]
          );

        requestedWidth = largestSize.width;
        requestedHeight = largestSize.height;
      }

      let resultingDpi = artwork.originalDpi;

      if (artwork.originalWidth !== requestedWidth || artwork.originalHeight !== requestedHeight) {
        resultingDpi = artwork.originalDpi / (requestedWidth / artwork.originalWidth);
      }

      if (
        !Number.isNaN(artwork.sizeBasedDpi) &&
        !Number.isNaN(resultingDpi) &&
        artwork.sizeBasedDpi !== resultingDpi
      ) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkValuesById({ id: artworkId, sizeBasedDpi: resultingDpi });
      }
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { artworkId }: { artworkI... Remove this comment to see the full error message
    // eslint-disable-next-line max-lines-per-function
    async downscaleOriginalImage({ artworkId }) {
      // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
      if (!this.isStandardArtwork) return;

      // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
      const index = findIndexById(this.artworks, artworkId);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const artwork = this.artworks[index];

      if (
        artwork?.metadata?.mimeType === "image/pdf" ||
        artwork?.originalImageUrl === null ||
        artwork?.originalImageUrl === undefined ||
        artwork?.filetype === "image/svg+xml" ||
        artwork?.originalMime === "image/svg+xml" ||
        !artwork?.originalImageUrl?.startsWith("http")
      ) {
        return;
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const sourceImage = await this.downloadImage(artwork.originalImageUrl);

      if (
        !sourceImage.width ||
        !sourceImage.height ||
        sourceImage.width === 0 ||
        sourceImage.height === 0
      ) {
        logUploadError({
          error_message: `Invalid image dimensions: ${sourceImage.width}x${sourceImage.height}`,
          error: "Canvas rendering error",
          uploadError: "Image has invalid dimensions",
          // @ts-expect-error TS(2345): Argument of type '{ error_message: string; error: ... Remove this comment to see the full error message
          errorResponse: {
            imageUrl: artwork.originalImageUrl,
            width: sourceImage.width,
            height: sourceImage.height
          }
        });
        return;
      }

      const originalDpi = 300; // baseline DPI
      // Fallback to originalDpi if sizeBasedDpi is invalid to prevent NaN in qualityRatio calculation
      // which would lead to 0x0 intermediate canvas dimensions and throw an error
      const targetDpi = Number.isFinite(artwork.sizeBasedDpi) ? artwork.sizeBasedDpi : originalDpi;

      if (targetDpi >= originalDpi) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateArtworkValuesById({
          id: artworkId,
          downscaledOriginalImage: artwork.originalImageUrl
        });

        return;
      }

      const aspectRatio = sourceImage.width / sourceImage.height;
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const previewCanvasWidth = this.previewCanvasSize.width;

      if (!previewCanvasWidth || previewCanvasWidth === 0) {
        return;
      }

      if (!Number.isFinite(aspectRatio) || aspectRatio === 0) {
        logUploadError({
          error_message: `Invalid aspect ratio: aspectRatio=${aspectRatio}`,
          error: "Canvas rendering error",
          uploadError: "Invalid aspect ratio",
          // @ts-expect-error TS(2345): Argument of type '{ error_message: string; error: ... Remove this comment to see the full error message
          errorResponse: {
            aspectRatio,
            imageWidth: sourceImage.width,
            imageHeight: sourceImage.height
          }
        });
        return;
      }

      const previewCanvasHeight = previewCanvasWidth / aspectRatio;

      try {
        // Collect diagnostics locally and attach to thrown errors only
        const debugInfo = {
          artworkId,
          previewCanvasWidth,
          previewCanvasHeight,
          aspectRatio,
          targetDpi,
          originalDpi,
          // @ts-expect-error TS(4111): Property 'previewCanvasSize' comes from an index s... Remove this comment to see the full error message
          previewCanvasSize: this.previewCanvasSize,
          // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
          catalogNumber: this.catalogNumber,
          sizeBasedDpi: artwork.sizeBasedDpi
        };

        const resultCanvas = document.createElement("canvas");
        const resultContext = resultCanvas.getContext("2d");

        // Invert the ratio to create more noticeable blur at lower DPIs
        const qualityRatio = Math.max(0.1, targetDpi / originalDpi); // minimum 0.1 to prevent extreme blur
        // @ts-expect-error TS(2339): Property 'qualityRatio' does not exist on type '{ ... Remove this comment to see the full error message
        debugInfo.qualityRatio = qualityRatio;

        // Create an intermediate canvas at a smaller size to simulate lower DPI
        const intermediateCanvas = document.createElement("canvas");
        const intermediateContext = intermediateCanvas.getContext("2d");

        // Calculate dimensions that simulate the target DPI
        const intermediateWidth = Math.max(1, Math.round(previewCanvasWidth * qualityRatio));
        const intermediateHeight = Math.max(1, Math.round(previewCanvasHeight * qualityRatio));
        // @ts-expect-error TS(2339): Property 'intermediateWidth' does not exist on typ... Remove this comment to see the full error message
        debugInfo.intermediateWidth = intermediateWidth;
        // @ts-expect-error TS(2339): Property 'intermediateHeight' does not exist on ty... Remove this comment to see the full error message
        debugInfo.intermediateHeight = intermediateHeight;

        // Set intermediate canvas to smaller dimensions
        intermediateCanvas.width = intermediateWidth;
        intermediateCanvas.height = intermediateHeight;

        // Validate intermediate canvas dimensions before drawing
        if (intermediateCanvas.width === 0 || intermediateCanvas.height === 0) {
          const err = new Error(
            `Intermediate canvas has invalid dimensions: ${intermediateCanvas.width}x${intermediateCanvas.height}`
          );
          // @ts-expect-error TS(2339): Property 'debug' does not exist on type 'Error'.
          err.debug = {
            ...debugInfo,
            throwAt: "intermediate_canvas_zero_dimension",
            assignedWidth: intermediateCanvas.width,
            assignedHeight: intermediateCanvas.height
          };
          throw err;
        }

        // First draw to smaller size (simulating lower DPI)
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        intermediateContext.imageSmoothingEnabled = true;
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        intermediateContext.imageSmoothingQuality = "low";
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        intermediateContext.drawImage(sourceImage, 0, 0, intermediateWidth, intermediateHeight);

        // Calculate dimensions that simulate the target DPI
        const resultWidth = Math.max(1, previewCanvasWidth);
        const resultHeight = Math.max(1, previewCanvasHeight);
        // @ts-expect-error TS(2339): Property 'resultWidth' does not exist on type '{ a... Remove this comment to see the full error message
        debugInfo.resultWidth = resultWidth;
        // @ts-expect-error TS(2339): Property 'resultHeight' does not exist on type '{ ... Remove this comment to see the full error message
        debugInfo.resultHeight = resultHeight;

        // Set final canvas size
        resultCanvas.width = resultWidth;
        resultCanvas.height = resultHeight;

        // Validate result canvas dimensions before drawing
        if (resultCanvas.width === 0 || resultCanvas.height === 0) {
          const err = new Error(
            `Result canvas has invalid dimensions: ${resultCanvas.width}x${resultCanvas.height}`
          );
          // @ts-expect-error TS(2339): Property 'debug' does not exist on type 'Error'.
          err.debug = {
            ...debugInfo,
            throwAt: "result_canvas_zero_dimension",
            assignedWidth: resultCanvas.width,
            assignedHeight: resultCanvas.height
          };
          throw err;
        }

        // Scale back up to preview size, which will show the quality loss
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        resultContext.imageSmoothingEnabled = true;
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        resultContext.imageSmoothingQuality = "high";
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        resultContext.drawImage(intermediateCanvas, 0, 0, resultWidth, resultHeight);

        const result = resultCanvas.toDataURL("image/png");

        if (result !== "data:,") {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          this.updateArtworkValuesById({ id: artworkId, downscaledOriginalImage: result });
        }
      } catch (error) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const dbg = error?.debug;
        logUploadError({
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          error_message: error.message,
          error: "Canvas rendering error",
          uploadError: "Failed to downscale image",
          // @ts-expect-error TS(2345): Argument of type '{ error_message: any; error: str... Remove this comment to see the full error message
          errorResponse: {
            imageUrl: artwork.originalImageUrl,
            imageWidth: sourceImage.width,
            imageHeight: sourceImage.height,
            previewCanvasWidth,
            previewCanvasHeight,
            aspectRatio,
            targetDpi,
            originalDpi,
            // Diagnostics if available
            qualityRatio: dbg?.qualityRatio,
            intermediateWidth: dbg?.intermediateWidth,
            intermediateHeight: dbg?.intermediateHeight,
            resultWidth: dbg?.resultWidth,
            resultHeight: dbg?.resultHeight,
            assignedWidth: dbg?.assignedWidth,
            assignedHeight: dbg?.assignedHeight,
            throwAt: dbg?.throwAt,
            // @ts-expect-error TS(4111): Property 'previewCanvasSize' comes from an index s... Remove this comment to see the full error message
            previewCanvasSize: dbg?.previewCanvasSize ?? this.previewCanvasSize,
            // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
            catalogNumber: dbg?.catalogNumber ?? this.catalogNumber,
            artworkId: dbg?.artworkId ?? artworkId
          }
        });
      }
    },
    async downloadImage(url, maxRetries = 5) {
      const delays = [250, 500, 1000, 2000, 4000];
      const retryableStatuses = [408, 429, 500, 502, 503, 504];
      let blobUrl: any = null;

      /* eslint-disable no-await-in-loop */
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      for (let attempt = 0; attempt <= maxRetries; attempt += 1) {
        try {
          // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
          const response = await fetch(url);

          if (!response.ok) {
            const error = new Error(
              `Failed to fetch image: HTTP ${response.status} ${response.statusText} for ${url}`
            );
            // @ts-expect-error TS(2339): Property 'status' does not exist on type 'Error'.
            error.status = response.status;
            throw error;
          }

          const blob = await response.blob();
          blobUrl = URL.createObjectURL(blob);
          break;
        } catch (error) {
          if (blobUrl) {
            URL.revokeObjectURL(blobUrl);
          }

          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          const isRetryable = error?.status && retryableStatuses.includes(error.status);
          const lastAttempt = attempt === maxRetries;
          if (lastAttempt || !isRetryable) {
            throw error;
          }

          const delay = delays[Math.min(attempt, delays.length - 1)];
          await new Promise(resolve => {
            setTimeout(resolve, delay);
          });
        }
      }
      /* eslint-enable no-await-in-loop */

      const image = new Image();

      await new Promise((resolve, reject) => {
        image.onload = () => {
          URL.revokeObjectURL(blobUrl);
          // @ts-expect-error TS(2794): Expected 1 arguments, but got 0. Did you forget to... Remove this comment to see the full error message
          resolve();
        };
        image.onerror = event => {
          URL.revokeObjectURL(blobUrl);
          const error = new Error("Failed to decode image");
          // @ts-expect-error TS(2339): Property 'event' does not exist on type 'Error'.
          error.event = event;
          reject(error);
        };
        image.src = blobUrl;
      });

      return image;
    },
    fetchBulkPrice() {
      // @ts-expect-error TS(2769): No overload matches this call.
      Object.entries(this.gangSheetBuilderVariants).forEach(async ([_, value]) => {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const response = await api.dtf.fetchBulkPrice({ variant_id: value.variant_id });
        const bulkPrice = {};

        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        bulkPrice[value.variant_id] = response;

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.setGangSheetBulkPrice(bulkPrice);
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updateBulkTable();
      });
    },
    updateBulkTable() {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (!this.gangSheetBulkPrice[this.gangSheetBuilderSettings.variantId]) return;

      EventBus.publish(Events.BULK_TABLE_UPDATE, {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        htmlTable: this.gangSheetBulkPrice[this.gangSheetBuilderSettings.variantId].table
      });
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { variantId }: { variantI... Remove this comment to see the full error message
    updateCarouselImage({ variantId }) {
      EventBus.publish(Events.SELECTED_VARIANT_CHANGED, {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        carouselData: this.gangSheetBuilderCarousels[variantId]
      });
    },
    sanitizeObject(obj) {
      // @ts-expect-error TS(2769): No overload matches this call.
      return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value != null));
    },
    async cancelArtworkProcess(artwork) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (!artwork.id) return;

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      api.dtf.cancelArtworkProcess({ id: artwork.id });
    },
    sendCancelEvent(artwork) {
      // @ts-expect-error TS(2339): Property 'lastWebSocketEvent' does not exist on ty... Remove this comment to see the full error message
      const { lastWebSocketEvent, id } = artwork;
      let action;

      if (lastWebSocketEvent !== null) {
        if (lastWebSocketEvent === "fetch_delivery_date") {
          action = "spangle_api";
        } else if (lastWebSocketEvent === "upload_artwork") {
          action = "image_upload";
        } else {
          action = "image_processing";
        }
        // @ts-expect-error TS(4111): Property 'isSpangle' comes from an index signature... Remove this comment to see the full error message
      } else if (this.isSpangle) {
        action = "spangle_api";
      } else {
        action = "image_upload";
      }

      // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
      datadogTracker.trackImageProcessingCancelled(this.catalogNumber, action);

      submitDtfEvent("transfers_cancel_button_clicked", {
        action,
        // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
        catalog_number: this.catalogNumber,
        // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
        business_line: this.businessLine,
        artwork_id: id
      });
    },
    handleCancelProcess(artwork) {
      // @ts-expect-error TS(2339): Property 'store' does not exist on type '() => Sto... Remove this comment to see the full error message
      const spanglesStore = useSpanglesStore.store; // eslint-disable-line no-shadow
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValues({ index: artwork.originalIndex, processTimeStamp: Date.now() });
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.sendCancelEvent(artwork);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.cancelArtworkProcess(artwork);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.clearValidateArtworkStartEventInterval(artwork.id);

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (artwork.id) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        transfersPollingService.stopPolling(artwork.id);
      }

      if (
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        !artwork.isLoading &&
        spanglesStore.spangleVariations.some(
          (variation: any) => variation.spanglePagesInfo !== null
        )
      ) {
        spanglesStore.cancelSpangleProcess({ artwork });
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
      } else if (artwork.id) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.removeArtwork(artwork.id);
      } else {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.removeArtworkByIndex(artwork.originalIndex);
      }

      // Recalculate pricing and enhancements after removing artwork
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.getArtworksPricing();
    },

    defineOriginalWidth(ordered) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (ordered.enhanceImage) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        return ordered.removeBackground
          ? // @ts-expect-error TS(2571): Object is of type 'unknown'.
            ordered.enhancedMetadata?.widthInch
          : // @ts-expect-error TS(2571): Object is of type 'unknown'.
            ordered.withBgMetadata?.widthInch;
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return ordered.originalMetadata?.widthInch;
    },
    defineOriginalHeight(ordered) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (ordered.enhanceImage) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        return ordered.removeBackground
          ? // @ts-expect-error TS(2571): Object is of type 'unknown'.
            ordered.enhancedMetadata?.heightInch
          : // @ts-expect-error TS(2571): Object is of type 'unknown'.
            ordered.withBgMetadata?.heightInch;
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return ordered.originalMetadata?.heightInch;
    },
    // @ts-expect-error TS(2322): Type '(this: StoreProxy, { enhancementsStarted, dt... Remove this comment to see the full error message
    async loadEnhancementArtwork({
      enhancementsStarted,
      dtfChannelUuid,
      rawArtworkUrls,
      artworkWidth,
      artworkHeight
    }) {
      if (!enhancementsStarted || !dtfChannelUuid || !rawArtworkUrls) {
        return;
      }

      // @ts-expect-error TS(4111): Property 'isEnhancementLoading' comes from an inde... Remove this comment to see the full error message
      this.isEnhancementLoading = true;

      try {
        const { parseArtworkUrls } = await import("common/utils/json");
        const parsedUrls = parseArtworkUrls(rawArtworkUrls);
        // @ts-expect-error TS(2339): Property 'artworkIds' does not exist on type 'Obje... Remove this comment to see the full error message
        if (!parsedUrls?.artworkIds?.length) {
          return;
        }

        // @ts-expect-error TS(2339): Property 'artworkIds' does not exist on type 'Obje... Remove this comment to see the full error message
        const { artworkIds, lastArtworkId } = parsedUrls;

        // Initialize loading state
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.initializeLoadingState(lastArtworkId);

        // Fetch artwork details
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const artworkDetails = await this.fetchArtworkDetails(artworkIds, dtfChannelUuid);

        if (!artworkDetails?.artworks?.length) {
          return;
        }

        const artwork = artworkDetails.artworks.map(
          ({
            id = null,
            fileName = "",
            originalMime = "",
            enhancementTier = "",
            uploadedOn = "",
            purchasedDate = "",
            ordered = {},
            original = {},
            useFootLength,
            dtfPrintId,
            currentEnhancementState,
            sizesAndQuantities
          }: any) => ({
            id,
            dtfPrintId,
            name: fileName,
            uploadedOn,
            purchasedDate,
            originalMime,
            enhancementTier,
            url: ordered.imageUrl,
            spangledImageUrl: ordered?.spangledImageUrl,
            cutlineUrl: ordered?.cutlineUrl,
            originalImageUrl: original.imageUrl,
            originalMimeType: original.mimeType,
            cmykPreviewImageNoBackgroundUrl: ordered?.cmykPreviewImageNoBackgroundUrl,
            cmykPreviewImageWithBackgroundUrl: ordered?.cmykPreviewImageWithBackgroundUrl,
            processTimeStamp: Date.now(),
            // @ts-expect-error TS(4111): Property 'isGoldFoil' comes from an index signatur... Remove this comment to see the full error message
            goildFoilPreviewAttached: this.isGoldFoil,
            enhancedNoBgUrl: ordered.noBgUrl,
            enhancedWithBgUrl: ordered.withBgUrl,
            enhancementCompleted: true,
            originalDpi: ordered.dpi,
            enhancedDpi: ordered.dpi,
            sliderPreviewUrl: ordered.noBgNoTrimUrl,
            canRemoveBg: ordered.canRemoveBg || false,
            useFootLength: useFootLength || false,
            removeBackground: ordered.removeBackground || false,
            metadata: ordered?.metadata,
            originalMetadata: ordered?.originalMetadata,
            enhancedMetadata: ordered?.enhancedMetadata,
            withBgMetadata: ordered?.withBgMetadata,
            enhanceImage: ordered?.enhanceImage,
            // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
            previewMetadata: this.printAsIs ? { heightInch: ordered.height } : {},
            enhancedOriginalDpi: ordered?.enhancedOriginalDpi,
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            originalWidth: this.defineOriginalWidth(ordered),
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            originalHeight: this.defineOriginalHeight(ordered),
            sizeBasedDpi: ordered?.enhanceImage
              ? ordered?.enhancedOriginalDpi
              : ordered?.originalMetadata?.dpi,
            currentEnhancementState,
            sizesAndQuantities
          })
        )[0];

        const isEnhancementComplete = artwork.currentEnhancementState === "complete_processing";

        if (isEnhancementComplete) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          await this.setupCompletedEnhancement(artwork);
        } else {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          await this.setupInProgressEnhancement(artwork, dtfChannelUuid, {
            width: artworkWidth,
            height: artworkHeight
          });
        }

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.cleanupUrlParameters();
      } catch (error) {
        notifyError("Enhancement loading failed", {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          params: { error: error.message }
        });
      } finally {
        // @ts-expect-error TS(4111): Property 'isEnhancementLoading' comes from an inde... Remove this comment to see the full error message
        this.isEnhancementLoading = false;
      }
    },

    initializeLoadingState(artworkId) {
      // @ts-expect-error TS(4111): Property 'artworksState' comes from an index signa... Remove this comment to see the full error message
      this.artworksState = [
        {
          ...emptyArtworkItem,
          id: artworkId,
          isLoading: true,
          isFile: false,
          originalIndex: 0
        }
      ];

      // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
      this.simulation = { ...DEFAULT_SIMULATION_ARTWORK };

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValuesById({
        id: artworkId,
        isLoading: false,
        enhancementCompleted: false,
        imageProcessingCompletedEventSent: false,
        progress: 50,
        progressMessage: "Loading artwork details...",
        processTimeStamp: Date.now()
      });
    },

    async fetchArtworkDetails(artworkIds, dtfChannelUuid) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValuesById({
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        id: artworkIds[artworkIds.length - 1],
        progress: 50,
        currentProgress: 25,
        progressMessage: "Loading artwork details..."
      });

      const responseHistory = await Promise.all([
        api.dtf.getArtworkHistory({
          // @ts-expect-error TS migration
          artwork_ids: artworkIds,
          dtf_channel_uuid: dtfChannelUuid,
          // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
          catalog_number: this.catalogNumber,
          enhancement_started: true
        }),
        api.dtf.getArtwork(
          {
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            id: artworkIds[artworkIds.length - 1]
          },
          {
            // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
            catalog_number: this.catalogNumber,
            dtf_channel_uuid: dtfChannelUuid
          }
        )
      ]);

      const artworks = responseHistory[0].artworks.map((item: any) => ({
        ...item,
        ordered: { ...item.ordered, ...responseHistory[1] }
      }));

      return objNamesToCamelCase({ ...responseHistory[0], artworks });
    },

    async setupCompletedEnhancement(artwork) {
      const artworkWithCompletion = {
        // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
        ...artwork,
        enhancementCompleted: true
      };

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setLoadedArtwork({ artwork: artworkWithCompletion });

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValuesById({
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        id: artwork.id,
        progress: 100,
        progressMessage: "Enhancement complete",
        processTimeStamp: Date.now(),
        isLoading: false,
        enhancementCompleted: true
      });

      // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
      if (this.isStandardArtwork) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        this.updatePreviewDpi({ artworkId: artwork.id });
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        await this.downscaleOriginalImage({ artworkId: artwork.id });
      }

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValuesById({
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        id: artwork.id,
        imageProcessingCompletedEventSent: true
      });

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updatePrintReadyInfoState(artwork.id);
    },

    async setupInProgressEnhancement(artwork, dtfChannelUuid, dimensions) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setDtfChannelUuid(dtfChannelUuid);
      const cable = initCable(this);
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.setCable(cable);
      // @ts-expect-error TS(2339): Property 'width' does not exist on type 'unknown'.
      const { width: artworkWidth, height: artworkHeight } = dimensions;

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.updateArtworkValuesById({
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        id: artwork.id,
        isLoading: false,
        enhancementCompleted: false,
        progress: 50,
        progressMessage: "Processing enhancements...",
        processTimeStamp: Date.now(),
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        url: artwork.url,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        originalImageUrl: artwork.originalImageUrl,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        canRemoveBg: artwork.canRemoveBg,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        removeBackground: artwork.removeBackground,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        filetype: artwork.filetype,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        filesize: artwork.filesize,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        name: artwork.name,
        // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
        ...this.initialValues,
        metadata: {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          ...artwork.metadata,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          width: artwork.metadata?.width ?? artworkWidth,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          height: artwork.metadata?.height ?? artworkHeight,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          widthInch: artwork.metadata?.widthInch ?? artworkWidth,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          heightInch: artwork.metadata?.heightInch ?? artworkHeight
        },
        withBgMetadata: {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          ...artwork.withBgMetadata,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          width: artwork.withBgMetadata?.width ?? artworkWidth,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          height: artwork.withBgMetadata?.height ?? artworkHeight,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          widthInch: artwork.withBgMetadata?.widthInch ?? artworkWidth,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          heightInch: artwork.withBgMetadata?.heightInch ?? artworkHeight
        }
      });

      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      this.schedulePollingFallback(artwork.id);
    },

    cleanupUrlParameters() {
      // @ts-expect-error TS(2345): Argument of type 'Location' is not assignable to p... Remove this comment to see the full error message
      const newUrl = new URL(window.location);
      const paramsToDelete = [
        "uploaded_artwork_ids",
        "artwork_urls",
        "file_content_type",
        "enhancements_started",
        "dtf_channel_uuid",
        "side"
      ];

      paramsToDelete.forEach(param => newUrl.searchParams.delete(param));
      window.history.replaceState({}, "", newUrl.toString());
    }
  }
});

// @ts-expect-error TS(2339): Property 'store' does not exist on type '() => Sto... Remove this comment to see the full error message
export const dtfStore = useDtfStore.store;
export default useDtfStore;
